const brand = sessionStorage.getItem('brand');
export const botBuilder = {
  canvas: {
    chatflowBuilderLoading: 'Chatflow Builder se učitava...',
    slowNetworkDetected: 'Otkrivena je spora mreža',
    editYourChatFlow: 'Uredite svoj chat protok',
    seeHowToUse: 'Pogledajte kako koristiti',
    help: 'Pomoć',
    classicBuilder: 'Klasični graditelj',
    visualiseFlow: 'Vizualizirajte tok',
    testLiveOnTelegramWeb: 'Testirajte uživo na Telegram Webu',
    testFlow: 'Testirajte tok',
    importTemplate: 'Uvezi predložak',
    landingPageBotReview: 'Pregled bota na stranici za slijetanje',
    install: 'Instaliraj',
    testLiveOnMessengerWeb: 'Testirajte uživo na Messenger Webu',
    testLiveOnWhatsappWeb: 'Testirajte uživo na WhatsApp Webu',
    testLiveOnInstagramWeb: 'Testirajte uživo na Instagram Webu',
    seeAllChatFlow: 'Pogledajte sve chat tokove',
    launchDemoModal: 'Pokreni demo modal',
    selectATemplateToKickStartYourBot: 'Odaberite predložak da biste pokrenuli svog bota',
    hireChatBotDesigner: 'Unajmite dizajnera chatbota',
    recommendedForYou: 'Preporučeno za vas',
    useTemplate: 'Koristi predložak',
    exportStatus: 'Status izvoza',
    flowExport: 'Izvoz toka',
    download: 'Preuzmi',
    importFlow: 'Uvezi tok',
    beforeYouStartUploadPleaseMakeSure: 'Prije nego što počnete s prijenosom, provjerite',
    ponit1: '1. Maksimalno ograničenje veličine prijenosa datoteke je 20 MB',
    point2: '2. Format datoteke treba biti JSON',
    selectFile: 'Odaberi datoteku',
    preview: 'Pregled',
    test: 'Test',
    OopsIntegrationAreNotAvailable: 'Ups! Integracije nisu dostupne u ',
    pleaseUpgradeTo: ' Molimo nadogradite na ',
    planForIntegration: ' za integracije.',
    areYouSure: 'Jeste li sigurni?',
    yesUseTemplate: 'Da, koristi predložak!',
    importTemplateDescription: 'Uvođenje ovog predloška zamijenit će postojeći chatflow. Sve ne spremljene promjene bit će izgubljene.',
    placeholders: {
      searchTemplateYouNeed: 'Pretraži predložak koji vam treba',
    },
    noDataFound: {
      botFlow: 'Bot Tok',
      noBotFlowAddedYet: 'Još nije dodan bot tok!',
      templates: 'Predlošci',
      noTemplatesFound: 'Nijedan predložak nije pronađen!',
    },
    appTooltip: {
      exportFlow: 'Izvoz toka',
      importFlow: 'Uvoz toka',
      clickToViewChatFlow: 'Kliknite da biste vidjeli chat tok u graditelju povlačenja i ispuštanja',
      clickToPreviewChatFlow: 'Kliknite da biste pregledali chat tok',
      clickToViewChatFlowAsFlowDiagram: 'Kliknite da biste vidjeli chat tok kao dijagram toka',
      clickToTestChatFlow: 'Kliknite da biste testirali chat tok',
      clickToSelectAndImportTemplate: 'Kliknite da biste odabrali i uvezli predložak koji najbolje odgovara vašem poslu.',
      clickToInstallYourBotToSelectedPlatform: 'Kliknite da biste instalirali svog bota na odabranoj platformi',
      clickToTestDefaultFlowOfTelegramBot: `Kliknite da biste testirali zadanu (aktivnu) tok na Telegram Webu`,
      clickToTestDefaultFlowOfFacebookBot: `Kliknite da biste testirali zadanu (aktivnu) tok na Facebook Webu`,
      clickToTestDefaultFlowOfWhatsappBot: `Kliknite da biste testirali zadanu (aktivnu) tok na WhatsApp Webu`,
      clickToTestDefaultFlowOfInstagramBot: `Kliknite da biste testirali zadanu (aktivnu) tok na Instagram Webu`,
    }
  },
  createNewBot: {
    createNewBot: 'Kreiraj novog bota',
    stepOneOfTwo: 'Korak 1 od 2',
    selectThePlatform: 'Odaberi platformu',
    selectTheBotType: 'Odaberi vrstu bota',
    aiBasedChatbot: 'AI bazirani chatbot',
    ruleBasedChatBot: 'Pravilo bazirani chatbot',
    webPlatforms: 'Web platforme',
    websiteChatBot: 'Chatbot za web stranicu',
    withLiveChat: '(Sa živim chatom)',
    landingPageBot: 'Bot za stranicu za slijetanje',
    liveChatWidget: 'Widget za živi chat',
    onlyLiveChat: '(Samo živi chat)',
    socialPlatforms: 'Društvene platforme',
    whatsappChatBot: 'WhatsApp Chatbot',
    telegramChatBot: 'Telegram Chatbot',
    facebookChatBot: 'Facebook Chatbot',
    instagramChatBot: 'Instagram Chatbot',
    selectBotType: 'Odaberi vrstu bota',
    selectProblem: 'Odaberite problem koji želite riješiti',
    leadGeneration: 'Generiranje potencijalnih klijenata',
    customerSupport: 'Korisnička podrška',
    appointmentBooking: 'Rezervacija termina',
    marketingAutomation: 'Automatizacija marketinga',
    ecommerceWebsite: 'E-trgovinska web stranica',
    otherUseCase: 'Ostalo',
    back: 'Natrag',
    typeDomainUrl: 'Upišite URL vaše web stranice radi provjere.',
    dataSourceForChatBotTraining: 'Izvor podataka za trening chat bota',
    upload: 'Učitaj',
    uploadDocuments: 'Učitaj dokumente',
    uploadDocument: 'Učitaj dokument',
    selectFile: 'Odaberi datoteku',
    continue: 'Nastavi',
    websiteUrl: 'Upišite URL svoje web stranice',
    skipNow: 'Preskoči sada',
    completeTheExistingBotSetup: 'Dovrši postojeći bot setup',
    youHaveAlreadyCreatedOneWhatsAppBot: 'Već ste stvorili jednog WhatsApp bota. Dovršite postavke istog kako biste stvorili novog.',
    completeSetup: 'Dovrši postavke',
    seeHowToUse: 'Pogledajte kako koristiti',
    help: 'Pomoć',
    fbBot: {
      createNewBot: 'Stvori novog bota',
      help: 'Pomoć',
      back: 'Natrag',
      step: 'Korak ',
      of3: ' od 3',
      loginWithFacebook: 'Prijava s Facebookom',
      asPerLatestChangesInFacebookPolicy: 'Sukladno najnovijim promjenama u politici Facebooka, vlasnik Facebook bota mora imati ulogu `manager`' +
        ' ili više kako bi pristupio svim značajkama Facebook stranice.',
      login: 'Prijava',
      connectFacebookBot: 'Poveži Facebook bota',
      connectBotWithYourFacebookPagesAnd: 'Poveži bota sa svojim Facebook stranicama i ',
      exploreTruePowerOfFacebook: 'istraži pravu snagu Facebooka',
      connect: 'Poveži',
      connected: 'Povezan',
      createNewPage: 'Stvori novu stranicu',
      refreshPageList: 'Osvježi popis stranica',
      thisPageIsSuccessfullyIntegratedWith: 'Ova stranica je uspješno integrirana s ',
      yourMessagesFromMessengerWillAppearIn: '. Vaše poruke s Messengera će se prikazati u ',
      inbox: ' Inbox',
      continueToBotConfiguration: 'Nastavi do konfiguracije bota',
      welcomeToBrandNameWeAreHereToHelpYou: `Dobrodošli u ${brand}. Tu smo da vam pomognemo.`,
      letsTryYourBotAndSeeHowItWorks: `Isprobajte svojeg bota i vidite kako radi! Kliknite "Testiraj na Facebooku".`,
      howAreYouDoingToday: 'Kako ste danas?',
      thisIsHowSimpleToUseFacebookBot: `To je to! Ovo je koliko je jednostavno koristiti Facebook bota`,
      letsCreateYourOwnChatFlowNow: `Hajde sada stvorimo svoj vlastiti tijek razgovora`,
    },
    instagramBot: {
      createNewBot: 'Stvori novog bota',
      back: 'Natrag',
      step: 'Korak ',
      of3: ' od 3',
      loginWithInstagram: 'Prijava s Instagramom',
      loginToYourInstagramAccount: 'Prijavite se na svoj Instagram račun kako biste omogućili chatbot na svom profilu.',
      managerLevelDescription: 'Vlasnici Instagram bota moraju imati barem "manager" razinu ovlasti ili više kako bi pristupili svim značajkama.',
      login: 'Prijava',
      connectInstagramBot: 'Poveži Instagram bota',
      connectBotWithYourInstagramAnd: 'Poveži bota sa svojim Instagramom i ',
      exploreTruePowerOfInstagram: 'istraži pravu snagu Instagrama',
      connected: 'Povezan',
      connect: 'Poveži',
      createNewPage: 'Stvori novu stranicu',
      refreshPageList: 'Osvježi popis stranica',
      thisPageIsSuccessfullyintegratedWith: 'Ova stranica je uspješno integrirana s ',
      yourMessagesFromMessengerWillAppearIn: '. Vaše poruke s Messengera će se pojaviti u ',
      inbox: ' Inbox',
      continueToBotConfiguration: 'Nastavi do konfiguracije bota',
      welcomeToBrandNameWeAreHereToHelpYou: `Dobrodošli u ${brand}. Tu smo da vam pomognemo.`,
      letsTryYourBotAndSeeHowItWorks: `Isprobajte svojeg bota i vidite kako radi! Kliknite "Testiraj na Instagramu".`,
      howAreYouDoingToday: 'Kako ste danas?',
      thisIsHowSimpleToUseInstagramBot: `To je to! Ovo je koliko je jednostavno koristiti Instagram bota`,
      letsCreateYourOwnChatFlowNow: `Hajde sada stvorimo svoj vlastiti tijek razgovora`,
    },
    telegramBot: {
      back: 'Natrag',
      step: 'Korak ',
      of3: ' od 3',
      seeHowToUse: 'Pogledaj kako koristiti',
      help: 'Pomoć',
      loginToYourTelegramAccount: 'Prijavi se na svoj Telegram račun',
      loginToYourAccountToCreateNewBotOrConnectExistingBot: 'Prijavi se na svoj račun kako bi stvorio novog bota ili povezao postojećeg',
      verificationCodeSentOnRegisteredNumber: 'Verifikacijski kod poslan na registrirani broj',
      createYourBot: 'Stvori svog bota',
      enterYourBotsNameAnd: `Unesi ime svog bota, poveži ga i neka zabava počne s `,
      botUserNameMustEndWithBotAtTheEnd: 'Korisničko ime bota mora završiti s "bot" na kraju.',
      terrisBot: 'Npr. teris_bot ili terisbot',
      botNameAlreadyTaken: 'Ovo ime bota već je zauzeto. Pokušajte nešto drugo',
      connect: 'Poveži',
      createBot: 'Stvori bota',
      codeNotReceivedResend: 'Kod nije primljen? Ponovno pošalji!',
      changeNumber: 'Promijeni broj',
      telegramPreview: 'Telegram pregled',
      worldsFastestMessagingApp: `Najbrža aplikacija za razmjenu poruka na svijetu i besplatna!`,
      bot: 'Bot',
      phoneNumber: 'Broj telefona',
      userName: 'Korisničko ime',
      none: 'Ništa',
      bio: 'Biografija',
      fewWordsAboutYourself: 'Nekoliko riječi o sebi',
      settings: 'Postavke',
      notificationsAndSound: 'Obavijesti i zvuk',
      privacyAndSecurity: 'Privatnost i sigurnost',
      dataAndStorage: 'Podaci i pohrana',
      chatSettings: 'Postavke razgovora',
      chatFolders: 'Mape razgovora',
      devices: 'Uređaji',
      connectYourBot: 'Poveži svog bota',
      createNewBotOrConnectWithExistingOne: 'Stvori novog bota ili se poveži s postojećim',
      createNewBot: 'Stvori novog bota',
      welcomeToBrandNameWeAreHereToHelpYou: `Dobrodošli u ${brand}. Tu smo da vam pomognemo.`,
      letsTryYourBotAndSeeHowItWorks: `Isprobajte svog bota i vidite kako radi! Kliknite "Testiraj na Telegramu".`,
      howAreYouDoingToday: 'Kako ste danas?',
      thisIsHowSimpleToUseTelegramBot: `To je to! Ovo je koliko je jednostavno koristiti Telegram bota`,
      letsCreateYourOwnChatFlowNow: `Hajde sada stvorimo svoj vlastiti tijek razgovora`,
      placeholders: {
        searchCountry: 'Pretraži državu',
        enterTelegramMobileNumber: 'Unesi broj mobilnog telefona za Telegram',
        enterLoginCodeReceived: 'Unesi kod za prijavu primljen na Telegram račun *',
        twoFactorAuthentication: 'Dvofaktorska autentikacija (opcionalno)',
        botName: 'Ime bota *',
        botUserName: 'Korisničko ime bota *',
      }
    },
    websiteLandingPageLiveChatBot: {
      createNewBot: 'Stvori novog bota',
      seeHowToUse: 'Pogledaj kako koristiti',
      help: 'Pomoć',
      back: 'Natrag',
      step: 'Korak ',
      of2: ' od 2',
      buildA: 'Izgradi ',
      thatMatchesYourBrandPersonality: ` koji odgovara osobnosti tvog brenda`,
      chatBotIcon: 'Ikona chatbota ',
      optional: 'Opcionalno',
      themeColor: 'Boja teme',
      chatBotName: 'Ime chatbota',
      botNameIsRequired: 'Ime bota je obavezno',
      botNameShouldBeLessThan50Characters: 'Ime bota treba biti manje od 50 znakova',
      continue: 'Nastavi',
      welcomeToBrandNameWeAreHereToHelpYou: `Dobrodošli u ${brand}. Tu smo da vam pomognemo.`,
      whatIsYourEmailAddress: 'Koja je tvoja adresa e-pošte?',
      invalidEmailAddress: 'Nevažeća adresa e-pošte',
      customizeYourLandingPageBotLook: 'Prilagodi izgled svog Landing Page Bota',
      customizeYourWidgetLook: 'Prilagodi izgled svog widgeta',
      customizeYourBotLook: 'Prilagodi izgled svog bota',
      buildYourLandingPageBotAndAutomateInteraction: 'Izgradi svog Landing Page bota i automatiziraj interakciju s kupcima dijeleći njegov link',
      useLiveChatBotToConnectToCustomers: 'Koristi Live Chat Bot za povezivanje s kupcima u stvarnom vremenu',
      connectChatBotToYourWebsiteAndAutomateInteractions: 'Poveži ChatBot sa svojom web stranicom i automatiziraj interakcije s posjetiteljima',
      widget: 'widget',
      botInterface: 'sučelje bota',
      mergedBot: 'Website Chatbot, Landing Page Bot, Mobile App Chatbot',
      mergedBotToolTip: 'Stvori stranicu bota kako bi privukao pažnju posjetitelja i uključio ih u razgovore.',
      placeholders: {
        typeANameForYourBot: 'Unesi ime za svog novog bota',
      },
      appTooltip: {
        TOOLTIP_WEBSITE_BOT_NAME: 'Unesi ime bota',
        mergedBotToolTip: 'Stvori stranicu bota kako bi privukao pažnju posjetitelja i uključio ih u razgovore.',
        TOOLTIP_WEBSITE_BOT_THEME_COLOR: 'Odaberi boju teme za svoj chat prozor',
        thisLogoWillBeUsedInTheBrandNamePlatformOnly: `Ovaj logo će se koristiti samo na platformi ${brand ? brand : ''}. Preporučujemo odabir loga tvrtke. Dodaj PNG ili JPG kvadratnu sliku manju od 1 MB.`
      }
    },
    whatsappBot: {
      back: 'Natrag',
      justAStepAway: 'Samo korak dalje',
      seeHowToUse: 'Pogledaj kako koristiti',
      help: 'Pomoć',
      createWhatsappChatBot: 'Stvori WhatsApp Bota',
      businessNameIsRequired: 'Ime tvrtke je obavezno.',
      maximumLengthForBusinessName40Characters: 'Maksimalna duljina imena tvrtke je 40 znakova.',
      businessCategory: 'Kategorija tvrtke',
      categoryIsRequired: 'Kategorija je obavezna.',
      descriptionIsRequired: 'Opis je obavezan.',
      maximumLengthForDescription200Characters: 'Maksimalna duljina opisa je 200 znakova.',
      pleaseFillAValidEmailAddress: 'Unesite valjanu poslovnu e-poštu.',
      businessEmailIsRequired: 'Poslovna e-pošta je obavezna.',
      phoneNumberShouldHaveMinimum7Digits: 'Broj telefona treba imati barem 7 znamenki',
      phoneNumberIsRequired: 'Broj telefona je obavezan',
      websiteIsRequired: 'Web stranica je obavezna.',
      maximumLengthForWebsite40Characters: 'Maksimalna duljina web stranice je 40 znakova.',
      maximumLengthForAddress150Characters: ' Maksimalna duljina adrese je 150 znakova.',
      doYouHaveWhatsappApiKey: 'Imate li WhatsApp API ključ?',
      apiProvider: 'API pružatelj',
      three60Dialog: '360 Dialog',
      whatsappCloud: 'WhatsApp Cloud',
      netcore: 'Netcore',
      apiKeyIsRequired: 'API ključ je obavezan.',
      whatsappBusinessAccountIdIsRequired: 'WhatsApp ID poslovnog računa je obavezan.',
      whatsappPhoneNumberIdIsRequired: 'WhatsApp ID broja telefona je obavezan.',
      systemAccessTokenIsRequired: 'Pristupni token sustava je obavezan.',
      sourceIdIsRequired: 'ID izvora je obavezan.',
      businessName: 'Ime tvrtke',
      businessAccount: 'Poslovni račun',
      businessDescription: 'Opis tvrtke',
      address: 'Adresa',
      businessEmail: 'Poslovna e-pošta',
      websiteUrl: 'Web stranica Url',
      thankYouForYourInterestIn: 'Hvala vam na interesu za ',
      whatsappChatBot: ' WhatsApp Chatbot.',
      weHaveReceivedYourInterests: 'Primili smo vaš interes, i naš tim prodaje stupit će s vama u kontakt u sljedećih 24 sata.',
      theyWillProvideYouWhatsappApiKey: 'Oni će vam pružiti WhatsApp API ključ.',
      readyToCreateWhatsappBot: `Spreman sam stvoriti WhatsApp Bota`,
      exploreWhatsappFeatures: 'Istražite značajke WhatsApp-a',
      welcomeToBrandNameWeAreHereToHelpYou: `Dobrodošli u ${brand}. Tu smo da vam pomognemo.`,
      letsTryYourBotAndSeeHowItWorks: `Isprobajte svog bota i vidite kako radi! Kliknite na "Testiraj na WhatsAppu".`,
      howAreYouDoingToday: 'Kako vam ide danas?',
      thisIsHowSimpleToUseWhatsappBot: `To je to! Ovo je koliko je jednostavno koristiti WhatsApp bota`,
      letsCreateYourOwnChatFlowNow: `Sada ćemo stvoriti svoj vlastiti chat tok.`,
      connectWhatsAppBot: 'Poveži WhatsApp Bota',
      createtWhatsAppBot: 'Ispunite svoje poslovne podatke',
      proceed: 'Nastavi',
      whatsApiProvider: 'WhatsApp API pružatelj',
      cloudApi: 'Cloud API',
      netcoreApi: 'Netcore API',
      loginWithFacebook: 'Accedi cù Facebook per WhatsApp Onboarding',
      asPerLatestChangesInFacebook: 'Secunnu l\'ultimi cambiamenti in e pulitiche di Facebook, u pruprietariu di u bot di Facebook deve avè u rolu di amministratore per accede à tutte e funzioni di a pagina di Facebook',
      login: 'Login',
      successWhatsAppOnboarding: 'Successu! U contu WhatsApp hè appruvatu !',
      congratulationYourWhatsApp: 'Felicitazioni u vostru numeru WhatsApp hè statu Appruvatu. Aghjurnate u vostru metudu di pagamentu per cumincià à aduprà u vostru bot.',
      sendFirstMessage: 'Mandà u primu messagiu',
      editYourChatFlow: 'Edita u vostru flussu di chat',
      overview: 'panoramica',
      oopsErrorOccurred: 'Oops! L\'errore hè accadutu durante l\'Onboarding',
      oopsSomethingWentWrong: 'Oops! Qualcosa hè andatu sbagliatu durante u prucessu di imbarcu. Per piacè verificate e vostre informazioni è pruvate di novu. Se u prublema persiste, cuntattate u nostru squadra di supportu per assistenza',
      setupManually: 'Configurazione manualmente',
      retryWithAutomatedOnboarding: 'Retry with Automated Onboarding',
      placeholders: {
        yourBusinessName: 'Ime vaše tvrtke',
        businessDescription: 'Opis tvrtke',
        businessEmail: 'Poslovna e-pošta',
        phone: 'Broj telefona*',
        website: 'Web stranica (npr. www.example.com)',
        address: 'Adresa',
        enterApiKey: 'Unesite API ključ',
        enterWhatsappBusinessAccountId: 'Unesite ID poslovnog računa za WhatsApp',
        enterWhatsappPhoneNumberId: 'Unesite ID broja telefona za WhatsApp',
        enterSystemAccessToken: 'Unesite pristupni token sustava',
        enterSourceId: 'Unesite ID izvora',
        businessName: 'Ime tvrtke',
        businessWebsite: 'Web stranica tvrtke',
        selectWhatsappApiProvider: 'Odaberite WhatsApp API pružatelja',
      },
      stepFour: {
        chooseYourWhatsAppAPIProvider: 'Odaberite svog WhatsApp API pružatelja',
        doYouHaveWhatsAppBusinessAPI: 'Imate li WhatsApp Business API?',
        yes: 'Da',
        noIAmNotSure: 'Ne, nisam siguran',
        selectApiProvider: 'Odaberite pružatelja API-ja',
        whatsAppCloudAPI: 'WhatsApp Cloud API',
        enterYourPhoneNumberId: 'Unesite svoj ID broja telefona',
        phoneNumberId: 'ID broja telefona',
        enterYourWhatsAppBusinessAccountId: 'Unesite svoj WhatsApp Business ID računa',
        whatsAppBusinessAccountId: 'WhatsApp Business ID računa',
        enterYourSystemUserToken: 'Unesite svoj token sustava korisnika',
        systemUserToken: 'Token sustava korisnika',
        help: 'Pomoć',
        netcoreAPI: 'Netcore API',
        enterYourSourceId: 'Unesite svoj ID izvora',
        sourceId: 'ID izvora',
        enterYourNetcoreApiKey: 'Unesite svoj Netcore API ključ',
        netcoreApiKey: 'Netcore API ključ',
        submit: 'Pošalji',
        noneOftheAbove: 'Ni jedno od navedenog',
        next: 'Dalje'
      },
      stepTwo: {
        legallyRegisteredBusiness: 'Pravno registrirano poslovanje',
        validWebsiteWithDataPrivacyPolicy: 'Važeća web stranica s politikom privatnosti podataka',
        debit: 'Debitna kartica',
        creditCard: 'Kreditna kartica',
        gstin: 'GSTIN',
        onlyRequiredForIndianResidents: 'Samo za indijske stanovnike',
        onlyRequiredFor: 'Samo za',
        indianResidents: 'indijske stanovnike',
        validPaymentMethod: 'Valjana metoda plaćanja',
        enabledWithInternationalPayments: 'Omogućeno s međunarodnim plaćanjima',
        validUseCaseInComplianceWithWhatsAppCommercePolicy: 'Valjan slučaj upotrebe u skladu s politikom WhatsApp trgovine',
        PhoneNumberWhichDoesNotHaveActiveWhatsAppAndCapableOfReceivingTheSMS: 'Broj telefona koji nema aktivan WhatsApp i sposoban je primati SMS',
        discard: 'Odbaci',
        proceed: 'Nastavi',
        whatsAppBotPrerequisites: 'Preduvjeti za WhatsApp Bot',
        letUsGetItDoneForYou: 'Neka to napravimo za vas!',
        ifYouAreFacingSomeIssues: 'Ako imate nekih problema',
        ourTeamCanHelpYouDoTheSame: 'Naš tim vam može pomoći u istom',
        requestACallbackNow: 'Zatraži povratni poziv sada!',
      },
      stepThree: {
        setupWhatsAppBot: 'Postavljanje WhatsApp Bota',
        selectingTheBestBusinessManagerForYourNeeds: 'Odabir najboljeg poslovnog upravitelja prema vašim potrebama',
        createMetaApp: 'Kako stvoriti Meta App',
        createaMetaAppOn: 'Stvori Meta App na',
        howToCreate: 'Kako stvoriti',
        addWhatsAppNumber: 'Kako dodati broj telefona za WhatsApp',
        addYourWhatsAppNumberAndVerifyTheSame: 'Dodajte svoj broj za WhatsApp i provjerite isti',
        subscribe: 'Pretplati se',
        copyAndSubscribeWebhook: 'Kopiraj i pretplati se na Webhook',
        howToSubscribe: 'Kako se pretplatiti',
        copy: 'Kopiraj',
        appSecretId: 'ID aplikacije',
        enterYourAppSecretId: 'Unesite ID aplikacije',
        enterAppSecret: 'Unesite aplikacijski ključ',
        phoneNumberId: 'ID broja telefona',
        whatsAppBusinessId: 'WhatsApp Business ID',
        assignSystemUser: 'Kako dodijeliti sustavskog korisnika',
        assign: 'Dodijeli',
        createApp: 'Stvori Meta',
        registerAndVerify: 'Registrirajte i provjerite',
        add: 'Dodaj',
        systemUserToken: 'Token sustava korisnika',
        enterYourSystemUserToken: 'Unesite svoj token sustava korisnika',
        getAllNecessaryDetails: 'Kako dobiti sve potrebne detalje',
        subscribeWhatsAppWebhook: 'Kako se pretplatiti na WA Webhook',
        configureTheWebhookForWhatsAppAccount: 'Konfigurirajte Webhook za WhatsApp račun',
        upadatePaymentMethod: 'Kako ažurirati metodu plaćanja',
        assignThePaymentMethodToWhatsAppAccount: 'Dodijeliti metodu plaćanja bilo kojem WhatsApp računu',
        grantControlOfWhatsAppBusinessAccountToASystemUser: 'Dodijeliti kontrolu WhatsApp Business računa sustavskom korisniku',
        keyDetailsThatYouNeedToCopyFromMetaDashboard: 'Ključni detalji koje trebate kopirati s Meta nadzorne ploče',
        updatePayment: 'Ažuriraj plaćanje',
        letUsGetItDoneForYou: 'Neka to napravimo za vas!',
        ifYouAreFacingSomeIssues: 'Ako imate nekih problema',
        ourTeamCanHelpYouDoTheSame: 'Naš tim vam može pomoći u istom',
        requestACallbackNow: 'Zatraži povratni poziv sada!',
        update: 'Ažuriraj',
        connectNow: 'Poveži sada'
      },
      stepFive: {
        selectBusinessManager: 'Odaberi poslovnog upravitelja',
        selectingTheBestBusinessManagerForYourNeeds: 'Odabir najboljeg poslovnog upravitelja prema vašim potrebama'
      },
      stepSix: {
        yourBotIsInstalledAndActive: 'Vaš bot je instaliran i aktivan',
        youhaveSuccessfullyConnected: 'Uspješno ste se povezali',
        withWhatsApp: 's WhatsAppom',
        youHaveBeenAllocaated100ConversationsPerMonthByDefault: 'Zadano vam je dodijeljeno 100 razgovora mjesečno',
        upgradeYourPlanForMore: 'Ažurirajte svoj plan za više.',
        createChatFlow: 'Stvori tijek razgovora',
        upgradePlan: 'Ažuriraj plan'
      },
      activeDemoBotStepFive: {
        scanQrOrSendMessageToActivateBot: 'Skenirajte QR ili pošaljite poruku za aktivaciju bota',
        scanTheQrCodeFrom: 'Skenirajte QR kod s',
        yourPhoneWillOpen: 'Vaš telefon će otvoriti prethodno ispunjenu poruku za slanje na naš broj za testiranje. Pritisnite „Pošalji“ na WhatsAppu',
        sendMessageFromYourWhatsAppNumber: 'Pošaljite poruku s vašeg WhatsApp broja',
        sendUsAWhatsAppMessageOn: 'Pošaljite nam poruku na WhatsApp',
        bySavingInYourContactsAndMessageShouldStartwith: ' spremanjem u svoje kontakte i poruka treba početi s ',
        send: 'Pošalji',
        or: 'ILI'
      },
      phoneNumberSetup: {
        waPhoneNoSetup: 'Postavljanje telefonskog broja za WhatsApp',
        loginWithFb: 'Prijavite se putem Facebooka za ugrađenu WhatsApp Onboarding',
        continueWithFb: 'Nastavi s Facebookom',
        connectAPIKey: 'Poveži se s API ključem',
        apiKeyContinue: 'Ako već imate potvrđeni broj i API ključ, tada slijedite korake u nastavku za nastavak postavljanja',
        connectWaNo: 'Poveži WhatsApp broj'
      },
    },
  },
  gettingStarted: {
    hello: 'Pozdrav, ',
    upgrade: 'Ažuriraj',
    gettingStarted: 'Početak - ',
    yourFacebookBotToken: 'Vaš Facebook bot token ',
    hasBeenExpired: 'istekao je',
    isExpiringIn: 'istječe za ',
    days: ' dana',
    facebookAuthenticationTokenRemainsFor60Days: 'Token za autentifikaciju na Facebooku ostaje aktivan samo 60 dana',
    kindlyProceedWithTheRenewalOfYourBotToken: 'Ljubazno nastavite s obnovom vašeg bot tokena kako biste osigurali neprekidni pristup uslugama chatbota.',
    renewYourBotToken: 'Obnovite svoj bot token',
    editYourChatFlow: 'Uredite tok razgovora',
    buildConversationEngagingBot: 'Izgradite privlačne tokove razgovora za korisnike vašeg bota.',
    takes5minutes: 'traje 5 minuta',
    previewYourLiveChatWidget: 'Pregledajte svoj Live Chat Widget',
    discoverHowThe: 'Otkrijte kako ',
    liveChatFeatureWorks: ' značajka Live Chata funkcionira pomoću naše Live Chat igrališta',
    takes2minutes: 'traje 2 minute',
    takes1minute: 'traje 1 minutu',
    connected: 'Povezano',
    customizeYourBotApperance: 'Prilagodite izgled i funkcionalnosti svog bota.',
    takes3minutes: 'traje 3 minute',
    thirdPartyAppsIntegration: 'Integracija s aplikacijama treće strane',
    integrateYourBot: 'Integrirajte svog bota s drugim aplikacijama/CRM-ovima kako biste stvorili poslovnu automatizaciju.',
    upgradeYourPlanToReceiveLeadsInEmail: 'Ažurirajte svoj plan kako biste primili potencijalne klijente na svoju e-poštu',
    getStartedWithUs: 'Počnite s nama',
    howToBuildAGoodChatFlow: 'Kako izgraditi dobar chatflow',
    howToUseBotPenguinsInboxAndItsFeatures: 'Kako koristiti BotPenguinov Inbox i njegove značajke',
    botPenguinsPricing: 'Cijene BotPenguin-a: Istraživanje planova i značajki',
    openHelpDesk: 'Otvori Pomoćni stol',
    helpAndSupport: 'Pomoć i podrška',
    extensiveGuides: 'Opsežni vodiči za sva vaša pitanja i radne tokove dostupni su u našem ',
    resourceCentre: 'Resource Centre',
    checkoutOurAnswers: 'Možete provjeriti naše odgovore na uobičajena pitanja u nastavku.',
    createANewBot: 'Stvori novog bota',
    installYourBot: 'Instalirajte svog bota',
    plansAndPricing: 'Planovi i cijene',
    previewYourLandingPageBot: 'Pregledajte svog Landing page bota',
    installYourLiveChatWidget: 'Instalirajte svoj Live Chat widget',
    installYourWebsiteBot: 'Instalirajte svog chatbota na web stranicu, mobilnu aplikaciju ili pokrenite kao landing page ili ugrađeni chatbot',
    integrateBotToLandingPage: 'Integrirajte bota na svoj landing page bot',
    installWidgetToWebsite: 'Instalirajte widget na svoju web stranicu',
    installBotToWebsite: 'Instalirajte svog chatbota',
    whatsappAutomation: 'WhatsApp automatizacija',
    facebookAutomation: 'Facebook automatizacija',
    telegramBotSettings: 'Postavke Telegram bota ',
    liveChatWidgetSettings: 'Postavke Live Chat Widget-a',
    landingPageBotSettings: 'Postavke Landing Page Bota',
    websiteChatBotSettings: 'Postavke Chatbota na web stranici',
    instagramAutomation: 'Instagram automatizacija',
    diveDeeperIntoBotPenguin: 'Zaronite dublje u BotPenguin',
    knowWhereWeAreGoing: 'Saznajte kamo idemo, najnovije ažuriranje i pomozite nam ispraviti neke pogreške.',
    productUpdates: 'Ažuriranja proizvoda',
    requestAFeature: 'Zatraži značajku',
    reportABug: 'Prijavi bug',
    prodcutRoadmap: 'Putanja proizvoda',
    trainYourChatbot: 'Obučite svog AI Chat Bota (Baza znanja)',
    buildEngagingConversation: 'Izgradite angažirajuće tokove razgovora za korisnike svog bota.',
    previewYourAIBot: 'Pregledajte svog AI Bota',
    integrateAIbot: 'Integrirajte bota u svog AI bota',
    aiBotSettings: 'Postavke AI Bota',
    CustomizeAIBot: 'Prilagodite izgled i funkcionalnost svog bota.',
    gptKeyWarning: 'Napomena: Možete koristiti do 100 GPT poruka po bota. Da biste nastavili koristiti izvan postavljenog ograničenja, priključite svoj vlastiti ChatGPT API ključ u konfiguraciju modela ChatGPT.',
    whatsappBotSettings: 'Postavke WhatsApp Bota',
    automateCustomerEngagementWithWhatsApp: 'Automatizirajte angažman s korisnicima putem WhatsAppa.',
    connectToYourWhatsappNumber: 'Povežite se s vašim brojem WhatsAppa',
    connectYourWhatsappBotWithYourWhatsappNumber: 'Povežite svog WhatsApp Bota sa svojim brojem WhatsAppa',
    facebookBotSettings: 'Postavke Facebook Bota',
    automateCustomerEngagementWithTelegram: 'Automatizirajte angažman s korisnicima putem Telegrama',
    automateCustomerEngagementWithFacebook: 'Automatizirajte angažman s korisnicima putem Facebooka',
    automateCustomerEngagementWithInstagram: 'Automatizirajte angažman s korisnicima putem Instagrama',
    telegramAutomation: 'Telegram automatizacija',
    limitExhaustMessage: 'Avete righjuntu u limitu massimu di 100 messagi AI gratuiti per u contu. Per cuntinuà aduprà u nostru serviziu API ChatGPT, cliccate nant\'à u buttone \'Aggiungi API Key\' per inserisce a vostra chjave API ChatGPT.',
    addApiKey: 'Aggiungi una chjave API'
  },
  install: {
    previewYourLandingPageBot: 'Pregledajte svog Landing Page Bota',
    preview: 'Pregled',
    test: 'Test',
    squareSpace: 'Squarespace',
    installYourChatBot: 'Instalirajte svog Chat Bota',
    seeHowToUse: 'Pogledajte kako koristiti',
    help: 'Pomoć',
    uniqueLinkToLandingPageBot: 'Evo jedinstvene veze do vašeg Landing Page Bota.',
    shareOnSocialMedia: 'Jednostavno ga podijelite s korisnicima na društvenim mrežama, kontakt stranicama ili poslovnim karticama.',
    or: 'ILI',
    copyUrl: 'Kopiraj URL',
    selectYourWebsiteCms: 'Odaberite CMS vaše web stranice',
    selectCms: 'Odaberite CMS/Builder koji ste koristili za izradu svoje web stranice',
    custom: 'Prilagođeno',
    wordpress: 'WordPress',
    shopify: 'Shopify',
    wix: 'Wix',
    zoomla: 'Zoomla',
    otherCms: 'Drugi CMS',
    howWouldYouLikeToInstall: 'Kako želite instalirati?',
    installingWebsiteBot: 'Odaberite gdje ćete instalirati bota na vašoj web stranici',
    iWillAddMyself: `Dodat ću sam`,
    getChatBotScript: 'Dobijte skriptu chatbota ispod i instalirajte je sami',
    getWordpressPlugin: 'Dobijte WordPress Plugin API ključ',
    getOurOfficialPlugin: 'Dobijte naš službeni plugin ',
    fromWordpressPluginStore: ' iz WordPress trgovine dodataka',
    getPlugin: 'Dobijte Plugin',
    quickGuideToInstall: 'Brzi vodič za instalaciju',
    placeApiKeyBelowIn: 'Zalijepite API ključ u ',
    afterDownloadingAndActivatingPlugin: ' nakon preuzimanja i aktiviranja dodatka',
    copy: 'Kopiraj',
    enterYourWebsite: `Unesite svoju web stranicu i vidjet ćemo kako vaš chatbot izgleda`,
    enterAValidUrl: 'Unesite valjan URL',
    verifyYourInstallation: 'Provjerite je li vaša instalacija uspješna ili ne?',
    testInstallation: 'Testirajte instalaciju',
    getChatBotScriptCode: 'Dobijte kod skripte chatbota',
    copyThisCodeSnippet: 'Kopirajte ovaj isječak koda i umetnite ga u HTML svake web stranice na kojoj želite' +
      ' prikazati chatbot ili ga zalijepite u podnožje prije zatvaranja oznake kako biste ga prikazali na svakoj stranici.',
    // copy: 'Kopiraj',
    sendCodeToMyDeveloper: 'Pošaljite kod svom razvijatelju',
    sendCodeToMyDevelopmentTeam: 'Pošaljite kod mom timu za razvoj',
    sendEmail: 'Pošaljite e-poštu',
    enterAValidEmail: 'Unesite valjanu e-poštu',
    codeHasBeen: 'Kod je ',
    toYourDeveloper: ' vašem razvijatelju ',
    resent: 'ponovno poslan',
    sent: 'poslan',
    resendEmail: 'Ponovno pošalji e-poštu',
    ask: 'Pitaj ',
    supportTeamToInstall: ' Tim podrške za instalaciju',
    raiseTheInstallationRequestTo: 'Podignite zahtjev za instalaciju ',
    team: ' Tim',
    helpMeInstallingChatBot: 'Pomozi mi u instalaciji ChatBota',
    yourBotInstallationIsNotActive: 'Vaša instalacija bota nije aktivna!',
    monthlyMessageLimitExceeded: 'Premašen je mjesečni limit poruka',
    exceededMonthlyMessageLimitUpgradeNow: 'Premašili ste mjesečni limit poruka, ažurirajte sada.',
    upgradeNow: 'Ažuriraj odmah',
    botInstallationNotActivePleaseFix: 'Vaša instalacija bota nije aktivna, molimo popravite isto. ',
    incorrectBotScript: 'Netočan Bot Script',
    installationCodeYouAreVerfiyingNotMatchingOnYourSite: `Kôd instalacije koji provjeravate ne podudara se s onim na vašoj web lokaciji.
      Provjerite jeste li instalirali ispravan kôd za ovog bota.`,
    unableToSee: 'Nije moguće vidjeti ',
    codeOnYourWebsite: ' kod na vašoj web stranici',
    unableToFindCodePleaseReinstall: 'Nismo u mogućnosti pronaći kôd na vašoj web lokaciji, ponovno instalirajte ga.',
    reinstallBot: 'Ponovno instaliraj bota',
    yourBotIsInstalledAndActive: 'Vaš bot je instaliran i aktivan!',
    noPendingAction: 'Nema čekajuće radnje, vaš bot je instaliran i aktivan',
    youAreAllSet: 'Sve ste postavili!',
    showMeMyLeads: 'Prikaži mi svoje potencijalne klijente',
    connectingToYourWebsiteToVerifyInstallation: 'Povezivanje s vašom web lokacijom radi provjere instalacije Bota',
    thisMayTakeUpto30Seconds: 'Ovo može potrajati do 30 sekundi',
    hereIsTheuniqueAILink: 'Evo jedinstvene veze do vašeg AI Bota',
    installHeading: 'Instalirajte svoj Chatbot',
    websiteChatbot: 'Chatbot na web stranici',
    aiChatBot: 'AI Chatbot',
    landingPageBot: 'Bot za Landing Page',
    mobileChatBot: 'Chatbot na mobilnoj aplikaciji',
    embeddedBot: 'Ugrađeni Chatbot',
    selectMobileDevice: 'Odaberite svoj mobilni uređaj',
    mobileDeviceSubheading: 'Odaberite jezik koji ste koristili za izradu svoje mobilne aplikacije',
    ios: 'IOS',
    android: 'Android',
    reactNative: 'React Native',
    otherMobileDevice: 'Drugi',
    copyEmbeddedCodeSnippet: 'Kopirajte ovaj isječak koda i umetnite ga u HTML svake web stranice na kojoj želite prikazati chatbot.',
    copyMobileCodeSnippet: 'Kopirajte ovaj isječak koda u kod svoje mobilne aplikacije gdje želite prikazati chatbot.',
    placeholders: {
      exampleSite: 'https://www.yoursite.com',
      enterDeveloperEmail: 'Unesite e-poštu razvijatelja'
    },
    installGeneral: {
      sendInstructionsToYourDeveloper: 'Pošaljite upute svom razvijatelju',
      notSureHowToDoIt: 'Niste sigurni kako to učiniti? Vaši programeri to mogu učiniti tren oka.',
      developersEmail: `Razvijateljeva e-pošta`,
      emailIsRequired: 'E-pošta je obavezna',
      subject: 'Predmet',
      message: 'Poruka',
      send: 'Pošalji',
      placeholders: {
        enterYourWorkEmail: 'Unesite svoju poslovnu e-poštu',
        createBotUsingBotPenguin: 'Uzbudljivo! Kreirajte bota pomoću BotPenguin-a',
      }
    },
    platforms: {
      hereIsUniqueLinkToLandingPageBot: 'Evo jedinstvene veze do vašeg Landing Page Bota.',
      shareWithUsersOnSocialMedia: 'Jednostavno ga podijelite s korisnicima na društvenim mrežama, kontakt stranicama ili poslovnim karticama.',
      previewMyLandingPageBot: 'Pregledajte svog Landing Page Bota',
      or: 'ILI',
      copyUrl: 'Kopiraj URL',
      howYouLikeToAddBot: 'Odaberite kako želite dodati kôd vašeg Bota na vašu web stranicu',
      installTheBotToYourCustomCodedOrWordPressWebsite: 'Instalirajte Bota na svoju prilagođenu ili WordPress web stranicu kopiranjem jedinstvenog koda.',
      name: 'Naziv',
      actions: 'Akcije',
      javascript: 'JavaScript',
      install: 'Instaliraj ',
      onYourCustomCodedWebsite: ' na svoju prilagođenu web stranicu',
      copyAndPaste: 'Kopirajte i zalijepite',
      copyThisCodeSnippet: 'Kopirajte ovaj isječak koda i umetnite ga u HTML svake web stranice gdje želite prikazati widget. Više detalja',
      seeGuide: 'vidi vodič',
      getCode: 'Dobijte kod',
      howToInstall: 'Kako instalirati?',
      copyCode: 'Kopiraj kôd',
      wordpress: 'WordPress',
      // install: 'Instaliraj ',
      onYourWordPressWebiste: ' na svoju WordPress web stranicu',
      preview: 'Pregled',
      test: 'Test',
    }
  },
  liveChatPreview: {
    liveChatPreview: 'Pregled uživo razgovora',
    agentWindow: 'Prozor agenta',
    person: 'osoba',
    inOrderToTestTypeHere: 'Kako biste testirali, ovdje upišite',
    agentWindowCannotBeCustomized: `Napomena: Prozor agenta ne može se prilagoditi`,
    customerWindow: 'Prozor kupca',
    clickHereToChat: 'Kliknite ovdje za razgovor',
    customerWillChatHere: 'Kupac će razgovarati ovdje',
    chat: 'Razgovor',
    by: 'od',
    changeYourBotLookFromLeftPanel: 'Promijenite izgled svog bota s lijevog panela',
    placeholders: {
      typeYourMessage: 'Upišite svoju poruku...',
      typeYourAnswer: 'Upišite svoj odgovor',
    }
  },
  previews: {
    previewYourLiveChatWidget: 'Pregledajte svoj Live Chat Widget',
    install: 'Instalirajte',
    seeHowToUse: 'Pogledajte kako koristiti',
    appTooltip: {
      clickToInstallYourBotToSelectedPlatform: 'Kliknite da biste instalirali svog bota na odabrani platformu',
    }
  },
  trainYourBot: {
    trainYourBot: 'Obučite svog AI čet bota',
    knowledgeBase: 'Baza znanja',
    faqs: 'FAQ\'s',
    history: 'Istorija',
    faqHeading: 'Često postavljana pitanja',
    faqSubHeading: 'Obučite svog bota na FAQ-ovima kako biste davali tačne odgovore.',
    knowledgeBaseHeading: 'Obučite svog bota',
    knowledgeBaseSubheading: 'Obučite svog bota za unapređene razgovore',
    websiteLink: 'Veza za veb sajt',
    uploadFile: 'Otpremite svoj fajl',
    selectFile: 'Izaberite fajl',
    submit: 'Pošaljite',
    searchHere: 'Traži ovde',
    question: 'Pitanje',
    answer: 'Odgovor',
    questionPlaceholder: 'Napišite svoje pitanje ovde',
    answerPlaceholder: 'Napišite svoj odgovor ovde',
    save: 'Sačuvajte',
    discard: 'Odbacite',
    addFaq: 'Dodajte FAQ',
    createdAt: 'Kreirano',
    updatedAt: 'Poslednje ažurirano',
    actions: 'Akcije',
    noFaqFound: 'Još uvek niste kreirali nijedan FAQ',
    noFaqFoundMessage: 'Svi vaši FAQ-ovi će se prikazati ovde',
    historyTitle: 'Istorija baze znanja',
    historySubtitle: 'Odgovori na pitanja za obuku vašeg AI čet bota',
    fileName: 'Naziv fajla',
    status: 'Status',
    noHistoryTitle: 'Još uvek niste kreirali nijedan obučeni model',
    noHistoryDescription: 'Svi vaši obučeni modeli će se prikazati ovde',
    fileUpload: 'Otpremite fajl',
    files: 'Fajlovi',
    fileSubHeading: 'Otpremite sve fajlove za obuku vašeg AI čet bota.',
    noFileFoundHeading: 'Još uvek niste otpremili nijedan fajl.',
    noFileFoundSubheading: 'Svi vaši fajlovi će se prikazati ovde',
    uploadYourFiles: 'Otpremite svoje fajlove',
    upload: 'Otpremite',
    fileShouldBe: 'Fajl treba da bude PDF, DOC, DOCX, PPTX, TXT.',
    uploadStatus: 'Status otpremanja',
    uploadStatusSubHeading: 'Status otpremanja fajlova za obuku bota',
    addFile: 'Dodajte fajl',
    otherConfiguration: 'AI postavke',
    deleteFiles: 'Kliknite da biste obrisali fajlove',
    websiteURL: 'URL veb sajta',
    websiteUrlSubheading: 'Dodajte URL-ove veb sajtova za obuku vašeg AI čet bota.',
    enterWebsiteUrl: 'Unesite URL',
    addWebsite: 'Dodajte veb sajt',
    tableWebsiteUrl: 'URL veb sajta',
    trainingStatus: 'Status obuke',
    lastTrained: 'Poslednja obuka',
    noWebsitesFound: 'Još uvek nema analiziranih veb sajtova!',
    noWebsitesFoundMessage: 'Svi vaši veb sajtovi će se prikazati ovde',
    loadMore: 'Učitaj još',
    botBehaviour: 'Konfigurišite ponašanje bota',
    botBehaviourSubHeading: 'Podesite ličnost bota, crveni podatke o kupcu, upravljajte tokom i modelom ChatGPT',
    botPersonality: 'Podesite ličnost bota',
    botPersonalitySubHeading: 'Upravljajte kako vaš bot treba odgovarati u smislu ličnosti',
    selectAnswerLength: 'Izaberite dužinu odgovora',
    answerLength: 'Dužina odgovora',
    answerAs: 'Odgovori kao',
    tone: 'Ton',
    language: 'Jezik',
    answerFormatting: 'Formatiranje odgovora',
    customInstructions: 'Prilagođene instrukcije',
    customerInstructionPlaceholder: 'Budite ljubazni i prijateljski. Ne koristite sleng. Ne koristite emotikone',
    redactCustomerData: 'Sakupite podatke o kupcu',
    redactDataSubheading: 'Podesite informacije o kupcu koje želite sakupiti',
    collectName: 'Sakupite ime',
    configureQuestion: 'Podesite pitanje',
    maxCharacterLimit: 'Maksimalno ograničenje karaktera u datom imenu',
    collectEmail: 'Sakupite e-mail',
    excludeEmail: 'Isključite e-mailove sa domenom',
    collectPhone: 'Sakupite broj telefona',
    manageUnusualMessages: 'Upravljajte neuobičajenim scenarijima u razgovoru',
    unusualMessagesSubheading: 'Rukujte situacijama u kojima bot nije odgovorio i drugim retkim scenarijima',
    startConversation: 'Poruka za početak razgovora',
    configureMessage: 'Poruka kada bot nije u mogućnosti da odgovori',
    profanityMessage: 'Poruka za odgovor na upotrebu neprikladnog jezika',
    chatGptModel: 'Konfiguracija modela ChatGPT',
    chatGptModelSubheading: 'Upravljajte kojim modelom ChatGPT-a želite koristiti i izbegavajte zloupotrebu',
    chatGptApi: 'Ključ ChatGPT API-ja',
    enableDisableRedactData: 'Sakupljanje podataka o kupcu',
    triggerToCollectData: 'Sakupljanje kontaktnih podataka nakon postavljanja pitanja.',
    train: 'Obuka',
    website: 'Veb sajt',
    analytics: 'Analitika',
    conversationsHistory: 'Istorija razgovora',
    exportCustomerConversation: 'Izvoz razgovora s korisnicima za obuku AI čet bota.',
    includedSourcesForResponse: 'Uključeni izvori za odgovor',
    visibility: 'Vidljivost',
    yourConversation: 'Vaši razgovori',
    reviewAndSelectConversation: 'Pregledajte i izaberite razgovore za izvoz za obuku čet bota',
    exportAiAnalytics: 'Izvoz analitike',
    startDate: 'Datum početka',
    endDate: 'Datum završetka',
    userQuestion: 'Pitanje korisnika',
    botsReply: 'Odgovor bota',
    dateCreated: 'Datum kreiranja',
    noAnalyticsFound: 'Nema dostupnih razgovora.',
    noAnalyticsFoundMessage: 'Svi vaši interakcije sa botom će se prikazati ovde.',
    detectYourLanguage: 'Prepoznajte jezik korisnika i odgovorite istim jezikom',
    exportData: 'Izvoz podataka',
    exportCompleteAnalyticsData: 'Izvoz kompletnih analitičkih podataka',
    export: 'Izvoz',
    integrateWithChatGpt: 'Integrišite sa ChatGPT',
    integrated: 'Integrisano',
    connected: 'Povezano',
    gpt3: 'GPT-3.5 (Niži trošak, prosečna tačnost)',
    gpt4: 'GPT-4 (Veći trošak, veća tačnost)',
    gptAssistant: 'Assistenti Beta* (Custu Premium, Precisione Superiore)',
    configure: 'Konfigurišite',
    prompt: 'Okidač',
    vectorResult: 'Vektorski rezultat',
    appToolTip: {
      deleteWebsite: 'Obrišite veb sajt',
      knowledgeBase: 'Obučite svog bota pomoću baze znanja',
      faqs: 'Obučite svog bota pomoću FAQ-a',
      knowledgeHistory: 'Istorija baze znanja',
      uploadFaqs: 'Otpremite FAQ-ove',
      addFaqs: 'Kliknite da biste dodali FAQ-ove za obuku vašeg AI čet bota',
      deleteFaqs: 'Obrišite FAQ-ove',
      deleteHistory: 'Obrišite istoriju',
      uploadFile: 'Otpremljeni fajl mora biti PDF, DOCX, DOC ili CSV i veličina ne sme preći 1 MB.',
      trainWebsite: 'Obučite svog bota koristeći veb sajt.',
      fileUpload: 'Obučite svog bota koristeći fajlove poput PDF-ova, TXT-ova, PPTX-ova, DOC-ova i DOCX-ova.',
      configureBotBehaviour: 'Prilagodite ličnost bota, upravljajte tokom i prilagodite model ChatGPT-a.',
      clickToAddWebsite: 'Kliknite da biste dodali URL-ove veb sajtova za obuku vašeg AI čet bota.',
      clickToAddFile: 'Kliknite da biste otpremili sve fajlove za obuku vašeg AI čet bota',
      clickToDeleteWebsites: 'Kliknite da biste obrisali veb sajtove',
      syncWebsite: 'Sinhronizujte veb sajt',
      copyUrl: 'Kopirajte URL',
      weWillBeFetchingAllTheWebpages: 'Pribavićemo sve veb stranice i obučiti ChatGPT model na njima.'
    },
    modal: {
      deleteWebsiteUrl: 'Izbriši URL web stranice',
      areYouSureYouWantToDeleteThisWebsiteUrl: 'Jeste li sigurni da želite izbrisati ovaj URL web stranice?'
    }
  },
  configuration: {
    websiteChatbotSetting: 'Podešavanja veb čet bota',
    preview: 'Pregled',
    test: 'Test',
    install: 'Instalacija',
    designHeader: 'Dizajn',
    generalHeader: 'Opšte',
    alertsHeader: 'Upozorenja',
    triggerHeader: 'Okidač',
    userAccessHeader: 'Pristup korisnicima',
    chatWindowHeader: 'Prozor za čet',
    otherConfiguration: 'AI podešavanja',
    appTooltip: {
      clickToInstallYourBotToSelectedPlatform: 'Kliknite da instalirate svog bota na odabranoj platformi',
      customizeAppearanceOfBot: 'Prilagodite pozicioniranje i izgled interfejsa svog bota.',
      configureBotsSettingsWhenAgentUnavailable: 'Podesite postavke bota kada vaš agent nije dostupan.',
      configureHowBotWillAlertYou: 'Podesite kako će vam bot javiti o novim potencijalnim klijentima.',
      makeSureYourBotsPopUpProperlyTimed: 'Proverite da li su iskačući prozori vašeg bota savršeno sinhronizovani.',
      customizeWhereYouWantYourBotToAppear: 'Prilagodite gde želite da se vaš bot pojavi i gde ne.',
      enableChatOptionsForVisitorsToTransferChat: 'Omogućite opcije četa posetiocima za prenos četa, čet uživo i obnavljanje četa.',
      configureBotBehaviour: 'Prilagodite ličnost bota, upravljajte tokom i prilagodite ChatGPT model.',
    },
    alerts: {
      configureYourBotsAlertSettings: 'Konfigurirajte postavke obavijesti svog bota',
      specifyHowYourBotWillNotify: 'Navedite kako će vas bot obavještavati o novim potencijalnim klijentima.',
      subject: 'Predmet',
      emailNotification: 'Obavijest putem e-pošte',
      emailAddresses: 'E-poštanske adrese',
      leadRevisitNotification: 'Obavijesti o ponovnom posjetu potencijalnog klijenta',
      youHaveSuccessfullyRegisteredWithDesktopNotifications: 'Uspješno ste se registrirali za obavijesti na radnoj površini',
      youHaveBlockedYourNotificationsOnBrowser: 'Onemogućili ste obavijesti u postavkama preglednika.',
      discard: 'Odbaci',
      saveChanges: 'Spremi promjene',
      seeHowToUse: 'Pogledajte kako koristiti',
      placeholders: {
        enterSubjectForYourEmail: 'Unesite predmet za svoju e-poštu',
        typeYourEmailAddressAndHitEnter: 'Upišite svoju e-poštansku adresu i pritisnite Enter',
      },
      appTooltip: {
        TOOLTIP_SUBJECTS: 'Prilagodite predmet svojih e-poštanskih obavijesti iz bota',
        TOOLTIP_EMAIL_NOTIFICATION: 'Omogućite/onemogućite obavijest bota putem e-pošte o novim potencijalnim klijentima',
        TOOLTIP_EMAIL_ADDRESS: 'Unesite e-poštansku adresu računa na koju želite primati e-poštanske obavijesti. Možete dodati više e-poštanskih adresa tako da unesete jednu i pritisnete Enter za dodavanje nove.',
        TOOLTIP_LEAD_REVISIT_NOTIFICATION: 'Omogućite/onemogućite obavijest bota putem e-pošte ako se korisnik koji je već zabilježen kao potencijalni klijent ponovno interagira s botom.',
      }
    },
    broadcasts: {
      createBroadcastHeading: 'Kreirajte emitovanje',
      youCanCreateMultipleBroadcasts: 'Možete kreirati više emitovanja',
      broadcastName: 'Naziv emitovanja',
      broadcastNameIsRequired: 'Naziv emitovanja je obavezan',
      continue: 'Nastavi',
      manageBroadcasts: 'Upravljanje emitovanjima',
      youCanCreateMultipleBroadcastsWithMultipleTemplatesAndSegments: 'Možete kreirati više emitovanja sa više planiranih šablona za različite grupe klijenata.',
      createNewBroadcast: 'Kreirajte novo emitovanje',
      name: 'Ime',
      segment: 'Grupa',
      template: 'Šablon',
      contacts: 'Kontakti',
      send: 'Pošalji',
      delivered: 'Dostavljeno',
      read: 'Pročitano',
      failed: 'Neuspešno',
      broadcastAt: 'Emitovanje u',
      status: 'Status',
      actions: 'Akcije',
      nA: 'N/A',
      seeHowToUse: 'Pogledajte kako koristiti',
      deleteBroadcast: 'Obriši emitovanje',
      wantToDeleteThisBroadcast: 'Da li ste sigurni da želite da obrišete ovo emitovanje?',
      placeholders: {
        searchHere: 'Pretražite ovde',
        enterBroadcastName: 'Unesite naziv emitovanja'
      },
      appTooltip: {
        deleteMultipleBroadcasts: 'Obrišite više emitovanja',
        broadcastAnalytics: 'Analitika emitovanja',
        deleteBroadcast: 'Obriši emitovanje',
      },
      broadcastAnalytics: {
        broadcastInsights: 'Uvidi emitovanja',
        broadcastStatus: 'Status emitovanja',
        youCanFindDetailsOfEachContactBelow: 'Možete pronaći detalje o svakom kontaktu ispod i izvezti one koji mogu imati problema.',
        filterApplied: 'Primenjeni filteri',
        placeholders: {
          searchByPhoneNumber: 'Pretraži po broju telefona',
          searchByName: 'Pretraži po imenu',
        },
        appTooltip: {
          filterDataBasedOnStatus: 'Filtrirajte podatke na osnovu statusa',
          exportData: 'Izvezi podatke',
        },
        modal: {
          exportData: 'Izvezi podatke',
          exportCompleteBroadcastData: 'Izvezi kompletne podatke o emitovanju',
          export: 'Izvoz'
        }
      },
      createBroadcast: {
        broadcastName: 'Naziv emitovanja',
        broadcastNameIsRequired: 'Naziv emitovanja je obavezan',
        template: 'Šablon',
        segments: 'Grupe',
        whenToSend: 'Kada poslati',
        now: 'SADA',
        later: 'KASNIJE',
        selectBroadcastUsing: 'Izaberite emitovanje pomoću',
        usingCsv: 'Korišćenje CSV-a',
        usingSegment: 'Korišćenje Grupe',
        allContacts: 'Svi kontakti',
        selectDate: 'Izaberite datum',
        selectTimeSlot: 'Izaberite vremenski interval',
        assignVariablesToTemplates: 'Dodeli promenljive šablonima ',
        addHeaderMedia: 'Dodajte zaglavlje Medija ',
        selectFile: 'Izaberite fajl',
        cancel: 'Otkaži',
        createBroadcast: 'Kreirajte emitovanje',
        broadcastUsing: 'Emitovanje pomoću',
        selectCSVFile: 'Izaberite CSV fajl',
        importContacts: 'Uvezi kontakte',
        beforeYouStartUpload: 'Pre nego što počnete sa otpremanjem, proverite da li je',
        point1: '1. Preuzmite uzorak CSV fajla.',
        point2: '2. Počnite unositi podatke od drugog reda nadalje.',
        point3: '3. U svakom redu će biti podaci za jedan kontakt',
        point4: '4. Pazite da su svi brojevi telefona jedinstveni.',
        point5: '5. Maksimalno ograničenje veličine fajla za otpremanje je 20MB',
        clickHere: 'Kliknite ovde',
        toDownloadSampleFile: 'za preuzimanje uzorak fajla',
        placeholders: {
          enterBroadcastName: 'Unesite naziv emitovanja',
          selectTemplate: 'Izaberite šablon',
          searchTemplateByName: 'Pretraži šablon po imenu',
          selectSegments: 'Izaberite Grupe',
          selectTimeSlot: 'Izaberite vremenski interval',
          selectValueForThisVariable: 'Izaberite vrednost za ovu promenljivu',
          searchHeaderByVariableName: 'Pretraži zaglavlje promenljive po imenu',
          variableFallbackValue: 'Rezervna vrednost promenljive',
          searchBodyVariableByName: 'Pretraži telo promenljive po imenu',
          searchSegmentByName: 'Pretraži grupu po imenu',
          selectBroadcastUsing: 'Izaberite emitovanje pomoću',
        },
        indexMergeDatePicker: {
          selectStartDate: 'Izaberite početni datum',
        },
        appTooltip: {
          importContactsForWhatsappBroadcast: 'Uvezi kontakte za WhatsApp emitovanje',
        }
      },
      failedBroadcast: {
        whatsappNumber: 'Broj WhatsApp-a',
        errorCode: 'Šifra greške',
        errorMessage: 'Poruka o grešci',
        nA: 'N/A',
      }
    },
    design: {
      customizeYourLandingPage: 'Prilagodite svoju ciljanu stranicu',
      customizeYourConversationalBot: 'Prilagodite svog AI bota',
      customizeYourBot: 'Prilagodite svog bota',
      createHeadingTextAndTheme: 'Stvorite naslovni tekst i temu koja odražava osobnost vašeg brenda',
      content: 'Sadržaj',
      theme: 'Tema',
      layout: 'Raspored',
      landingPageName: 'Naziv ciljane stranice',
      botName: 'Naziv bota',
      charactersRemaining: ' preostalih znakova',
      landingPageHeader: 'Zaglavlje ciljane stranice',
      landingPageDescription: 'Opis ciljane stranice',
      hideContent: 'Sakrij sadržaj',
      profilePic: 'Profilna slika',
      selectFile: 'Odaberi datoteku',
      socialMediaLinks: 'Poveznice društvenih medija',
      initialMessage: 'Početna poruka razgovornog bota',
      flowTriggerDetail: 'Okidač za prikupljanje kontaktnih podataka',
      selectType: 'Odaberi vrstu',
      url: 'URL',
      delete: 'Obriši',
      editLink: 'Uredi poveznicu',
      addLink: 'Dodaj poveznicu',
      callToAction: 'Poziv na akciju',
      liveChatWelcomeMessage: 'Poruka dobrodošlice za live chat',
      liveChatTriggerMessage: 'Poruka za pokretanje live chata',
      autoHideCallToAction: 'Automatsko skrivanje poziva na akciju',
      maxDelayShouldBe300Seconds: 'Maksimalno kašnjenje treba biti 300 sekundi',
      landingPageThemeColor: 'Boja teme ciljane stranice',
      themeColor: 'Boja teme',
      landingPageBackground: 'Pozadina ciljane stranice',
      chatBackgroundColor: 'Boja pozadine chata',
      color: 'Boja',
      gradient: 'Gradijent',
      image: 'Slika',
      video: 'Video',
      gradientStart: 'Početak gradijenta',
      gradientEnd: 'Kraj gradijenta',
      positionOnWeb: 'Položaj na webu',
      positionOnMobile: 'Položaj na mobilnom uređaju',
      windowSize: 'Veličina prozora',
      s: 'S',
      m: 'M',
      l: 'L',
      xl: 'XL',
      xxl: 'XXL',
      custom: 'Prilagođeno',
      height: 'Visina',
      minimum300HeightIsRequired: 'Potrebna je minimalna visina od 300 px',
      heightCannotExceed720: 'Visina ne može premašiti 720 px',
      width: 'Širina',
      px: 'px',
      minimum200WidthIsRequired: 'Potrebna je minimalna širina od 200 px',
      widthCannotExceed1050: 'Širina ne može premašiti 1050 px',
      discard: 'Odbaci',
      saveChanges: 'Spremi promjene',
      landingPageBot: 'Bot ciljane stranice',
      chatBot: 'Razgovorni bot',
      preview: 'Pregled',
      botIcon: 'Ikona bota',
      websiteBot: 'Web stranica bota za razgovor',
      selectFont: 'Odaberi font',
      fontLibrary: 'Biblioteka fontova',
      uploadFont: 'Učitaj font',
      selectFontForBot: 'Odaberi font za bota',
      uploadedFont: 'Učitani font',
      placeholders: {
        enterName: 'Unesite naziv',
        enterHeaderText: 'Unesite zaglavlje',
        enterDescription: 'Unesite opis',
        enterUrl: 'Unesite URL',
        howCanIHelpYou: 'Kako vam mogu pomoći?',
        enterYourWelcomeMessageHere: 'Unesite svoju poruku dobrodošlice ovdje',
        enterYourLiveChatMessageHere: 'Unesite svoju poruku za live chat ovdje',
        enterTimeInSeconds: 'Unesite vrijeme u sekundama',
        enterHeight: 'Unesite visinu',
        enterWidth: 'Unesite širinu',
        flowInitialMessage: 'Unesite početno pitanje',
      },
      appTooltip: {
        standardLayout: 'Standardni raspored',
        rightLayout: 'Desni raspored',
        mergedLayout: 'Spojeni raspored',
        enterNameOfYourBot: 'Unesite naziv svog bota',
        enterNameOfYourLandingPageBot: 'Unesite naziv svog bota ciljane stranice',
        headingTextThatAppearOnLandingPageBot: 'Unesite tekst zaglavlja koji želite da se pojavi na vašem botu ciljane stranice',
        descriptionTextThatAppearOnLandingPageBot: 'Unesite tekst opisa koji želite da se pojavi na vašem botu ciljane stranice.',
        addLinksAndSocialMediaIcons: 'Dodajte poveznice i ikone društvenih medija',
        initialFlowMessage: 'Unesite prvu poruku koju će bot poslati kako bi započeo razgovor s korisnikom',
        anInvitingCatchPhrase: 'Pozivajuća fraza koja će potaknuti korisnika da razgovara s botom',
        setAWelcomeMessageForYourVisitors: 'Postavite poruku dobrodošlice za svoje posjetitelje. To će biti prva poruka u vašem razgovoru.',
        setAMessageToInitiateLiveChat: `Postavite poruku za pokretanje live chata s kraja posjetitelja. Primit ćete obavijest svaki put kada se ova poruka pokrene
        u bilo kojem od vaših razgovora.`,
        autoHideCallToAction: `Automatsko skrivanje teksta 'Poziv na akciju' nakon određenog vremena`,
        TOOLTIP_HIDE_LANDINGPAGE_INFO: 'Možete odabrati sakriti logotip i tekstove kako biste prikazali samo prozor za razgovor na zaslonu',
        TOOLTIP_LANDINGPAGE_PROFILE_ICON: 'Učitajte logotip za stranicu razgovornog bota.',
        TOOLTIP_CHAT_THEME_COLOR: 'Odaberite boju prozora chata vašeg bota',
        TOOLTIP_CHAT_THEME_BACKGROUND_COLOR: 'Odaberite boju pozadine prozora chata bota',
        TOOLTIP_WEB_1ST_POSITION: 'Položite bota u donjem lijevom kutu radne površine korisnika bota',
        TOOLTIP_WEB_2ND_POSITION: 'Položite bota u sredini desno gornjeg kuta radne površine korisnika bota',
        TOOLTIP_WEB_3RD_POSITION: 'Položite bota u donjem desnom kutu radne površine korisnika bota',
        TOOLTIP_MOBILE_1ST_POSITION: 'Položite bota u donjem lijevom kutu mobilne radne površine korisnika bota',
        TOOLTIP_MOBILE_2ND_POSITION: 'Položite bota u sredini desno gornjeg kuta mobilne radne površine korisnika bota',
        TOOLTIP_MOBILE_3RD_POSITION: 'Položite bota u donjem desnom kutu mobilne radne površine korisnika bota',
        TOOLTIP_WINDOW_HEIGHT: 'Promijenite veličinu prozora chata bota',
        TOOLTIP_BOT_ICON: 'Odaberite ikonu ili učitajte logotip/sliku za svog bota',
        flowTriggerMessage: 'Unesite broj poruka koje će se postaviti prije prikupljanja kontaktnih podataka poput imena, e-pošte i telefona',
      }
    },
    dripCampaigns: {
      createDripCampaignHeader: 'Kreirajte kampanju kapljanja',
      youCanCreateMultipleCampaigns: 'Možete kreirati više kampanja',
      dripCampaignName: 'Naziv kampanje kapljanja',
      dripCampaignNameIsReuired: 'Naziv kampanje kapljanja je obavezan',
      continue: 'Nastavi',
      manageDripCampaign: 'Upravljanje kampanjama kapljanja',
      youCanCreateMultipleCampaignsWith: 'Možete kreirati više kampanja kapljanja sa planiranim,' +
        ' automatizovanim porukama za pokretanje odgovora od određenih grupa korisnika.',
      createNewDripCampaign: 'Kreirajte novu kampanju kapljanja',
      campaignName: 'Naziv kampanje',
      appliedOn: 'Primenjeno na',
      segment: 'Grupa',
      template: 'Šablon',
      startDate: 'Datum početka',
      action: 'Akcija',
      nA: 'N/A',
      seeHowToUse: 'Pogledajte kako koristiti',
      deleteDripCampaign: 'Obrišite kampanje kapljanja',
      wantToDeleteThisDripCampaign: 'Da li ste sigurni da želite da obrišete ovu kampanju kapljanja?',
      placeholders: {
        enterDripCampaignName: 'Unesite naziv kampanje kapljanja',
        searchByName: 'Pretraži po imenu'
      },
      appTooltip: {
        deleteMultipleDripCampaigns: 'Obrišite više kampanja kapljanja',
        deleteDripCampaign: 'Obrišite kampanju kapljanja',
      },
      createDripCampaign: {
        dripCampaignName: 'Naziv kampanje kapljanja',
        appliedOn: 'Primenjeno na',
        segments: 'Grupe',
        selectDate: 'Izaberite datum',
        scheduleYourTemplate: 'Planirajte vaše šablone',
        schedule: 'Planirajte',
        template: 'Šablon',
        sendAfter: 'Pošalji posle',
        assignVariablesToTemplate: 'Dodeli promenljive šablonima',
        addHeaderMedia: 'Dodajte zaglavlje medija ',
        selectFile: 'Izaberite fajl',
        createDripCampaign: 'Kreirajte kampanju kapljanja',
        newSubscriber: 'Novi pretplatnik',
        minutes: 'Minuti',
        hours: 'Sati',
        days: 'Dani',
        placeholders: {
          enterDripName: 'Unesite naziv kampanje kapljanja',
          selectAppliedOn: 'Izaberite primenjeno na',
          selectSegments: 'Izaberite grupe',
          searchByName: 'Pretraži po imenu',
          selectTemplate: 'Izaberite šablon',
          searchTemplateByName: 'Pretraži šablon po imenu',
          enterSendAfter: 'Unesite Pošalji posle',
          selectValueForThisVariable: 'Izaberite vrednost za ovu promenljivu',
          searchHeaderVariableByName: 'Pretraži zaglavlje promenljive po imenu',
          searchBodyVariableByName: 'Pretraži telo promenljive po imenu',
        },
        dateTimePicker: {
          selectStartDate: 'Izaberite datum početka',
        }
      }
    },
    general: {
      configureLandingPageGeneralSettings: `Konfigurirajte opće postavke vaše ciljane stranice`,
      configureBotsGeneralSettings: `Konfigurirajte opće postavke vašeg bota`,
      selectTheTimeZone: 'Odaberite vremensku zonu, jezik i malu napomenu za svoje korisnike kada ',
      isNotAvailable: `nije dostupan`,
      landingPagesBot: `bota ciljane stranice`,
      bot: 'bota',
      waitingMessage: 'Poruka čekanja',
      landingPageBotStatus: 'Status bota ciljane stranice',
      chatBotStatus: 'Status razgovornog bota',
      unavailabilityMessage: 'Poruka o nedostupnosti',
      sendIncompleteResponses: 'Pošalji nepotpune odgovore',
      language: 'Jezik',
      invalidateCache: 'Poništi predmemoriju',
      timezone: 'Vremenska zona',
      chatWindowMessageHistory: 'Povijest poruka prozora za razgovor',
      session: 'sesije',
      forever: 'zauvijek',
      english: 'Engleski',
      spanish: 'Španjolski',
      french: 'Francuski',
      portuguese: 'Portugalski',
      german: 'Njemački',
      italian: 'Talijanski',
      swedish: 'Švedski',
      arabic: 'Arapski',
      malay: 'Malajski',
      russian: 'Ruski',
      discard: 'Odbaci',
      saveChanges: 'Spremi promjene',
      seeHowToUse: 'Pogledajte kako koristiti',
      placeholders: {
        enterYourWaitingMessageHere: 'Unesite svoju poruku čekanja ovdje',
        // selectLanguage: '',
        searchTimeZone: 'Pretraži vremensku zonu',
        // selectChatRetentionPolicy: '',
      },
      appTooltip: {
        TOOLTIP_WAITING_MESSAGES: 'Prilagodite poruku kako želite da se odmah pojavi na prozoru za razgovor nakon što korisnik bota pošalje zahtjev za Live Chat',
        TOOLTIP_CHATBOT_STATUS: 'Aktivirajte / deaktivirajte bota',
        TOOLTIP_UNAVAILABILITY_MESSAGE: 'Prilagodite poruku kako želite da se pojavi na prozoru za razgovor kada nijedan od vaših agenata nije dostupan za Live Chat s korisnikom bota',
        TOOLTIP_SEND_INCOMPLETE_RESPONSES: 'Pošaljite e-mail obavijesti čak i kada korisnik bota nije završio razgovor.',
        TOOLTIP_LANGUAGE: 'Odaberite jezik bota',
        TOOLTIP_INVALIDATE_CACHE: 'Kliknite ovdje da biste očistili predmemoriju kad god uredite tok razgovora ili postavke bota, jer se promjene odražavaju tek nakon 15 minuta',
        TOOLTIP_TIME_ZONE: 'Odaberite vremensku zonu za svog bota',
        TOOLTIP_CHAT_RETENTION: 'Odaberite želite li zadržati razgovore korisnika bota zauvijek na prozoru za razgovor ili samo tijekom sesije preglednika.',
      }
    },
    liveChat: {
      customizeYourChatWindow: 'Prilagodite svoj prozor za razgovor',
      controlAndCustomizeTheChatWindow: 'Kontrolirajte i prilagodite prozor za razgovor s kojim će vaši korisnici interagirati.',
      allowVisitorsToTransferChatToWhatsapp: 'Omogućite posjetiteljima prijenos razgovora na WhatsApp',
      allowVisitorsToRefreshChat: 'Omogućite posjetiteljima osvježavanje razgovora',
      displayNameForTransferringChatToWhatsapp: 'Ime za prijenos razgovora na Whatsapp',
      displayNameForTransferringToLiveChat: 'Ime za prijenos u Live/Agent razgovor',
      displayNameForTransferringAChatToBot: 'Ime za prijenos razgovora na Bota',
      discard: 'Odbaci',
      saveChanges: 'Spremi promjene',
      allowVisitorsToTransferChatToBot: 'Omogućite posjetiteljima prijenos razgovora na Bota.',
      allowVisitorsToRequestForLiveChat: 'Omogućite posjetiteljima zahtjev za Live Chat.',
      indicativeTextForCustomersReply: `Indikativni tekst za odgovor korisnika`,
      displayNameForRestartingChatBot: 'Ime za ponovno pokretanje razgovora s Chatbotom',
      seeHowToUse: 'Pogledajte kako koristiti',
      placeholders: {
        enterButtonNameForWhatsapp: 'Unesite naziv gumba za prijenos na WhatsApp',
        enterButtonNameForLiveChat: 'Unesite naziv gumba za prijenos u Live Chat ili agenta',
        enterButtonNameForBot: 'Unesite naziv gumba za prijenos na Bota',
        enterTextDisplayInEmptyReplyArea: 'Unesite tekst koji se prikazuje u praznom prostoru za odgovor',
        enterButtonForRestartingConversation: 'Unesite naziv gumba za ponovno pokretanje razgovora',
      },
      appTooltip: {
        TOOLTIP_TRANSFER_CHAT_TO_WHATSAPP: 'Omogućite posjetiteljima web stranice prijenos razgovora na WhatsApp broj odgovarajućeg agenta s kojim su povezani. Za rad ove značajke mora biti omogućena mogućnost Live Chata.',
        TOOLTIP_ALLOW_VISITOR_TO_REFRESH_CHAT: 'Omogućite korisnicima bota osvježavanje razgovora kako bi mogli započeti razgovor iznova.',
        TOOLTIP_ALLOW_TRANSFER_CHAT_TO_BOT: 'Omogućite korisnicima bota prijenos razgovora na bota u bilo kojem trenutku tijekom razgovora s agentom uživo.',
        TOOLTIP_ALLOW_REQUEST_FOR_CHAT: 'Omogućite korisnicima bota zahtjev za Live Chat s agentom kad god to žele.',
        ifYouHaveEnabledUserToTransferToWhatsapp: 'Ako ste omogućili korisniku prijenos na WhatsApp, popunite kako biste željeli prikazati tu opciju',
        ifYouHaveEnabledUserToTransferToLiveChat: 'Ako ste omogućili korisniku prijenos u Live Chat, popunite kako biste željeli prikazati tu opciju',
        ifYouHaveEnabledUserToTransferToWhatsapp2: 'Ako ste omogućili korisniku prijenos na WhatsApp, popunite kako biste željeli prijenos natrag na bota',
        howWouldYouLikeToDisplayReplySpaceForCustomers: 'Popunite kako biste željeli prikazati prostor za odgovor korisnika',
        ifYouHaveEnabledUserToRestartChatBot: 'Ako ste omogućili korisniku ponovno pokretanje razgovora s Chatbotom, popunite kako biste željeli prikazati tu opciju',
      }
    },
    socialPlatforms: {
      chatFlowsHeader: 'Razgovorni tokovi',
      dripCampaignHeader: 'Kapanje kampanje',
      widgetsHeader: 'Widgeti',
      broadcastHeader: 'Emitiranje',
      ordersHeader: 'Narudžbe',
      manageHeader: 'Upravljanje',
      inputHeader: 'Unos',
      apiKeyHeader: 'API ključ',
      appTooltip: {
        TOOLTIP_DRIP_CAMPAIGN_TITLE: 'Kreirajte putovanje korisnika kroz kapajuću kampanju pomoću planiranih razgovora.',
        TOOLTIP_CHAT_FLOW_TITLE: 'Prilagodite predloške razgovora i kreirajte više razgovora za različite ciljne grupe.',
        TOOLTIP_WIDGET_TITLE: 'Kreirajte vidžete (prozore za razgovor) i ugradite ih u promotivne web stranice kako biste usmerili posetioce ka botu',
        TOOLTIP_BROADCAST_TITLE: 'Poslati poruke ili tokove kontaktima jednim klikom u unapred zakazano vreme',
        TOOLTIP_ORDERS_TITLE: 'Lista narudžbi koje je postavio korisnik',
        TOOLTIP_MANAGE_TITLE: 'Upravljanje funkcionalnostima bota za kontakte/leads i ključne reči',
        TOOLTIP_INPUT_TITLE: 'Kreirajte WhatsApp predloške, slike i tekst kao materijal za odgovor kontaktima/leads',
      },
      apiWrapper: {
        whatsappApiCredentials: 'WhatsApp API podaci za prijavu',
        generateYourWhatsappApiKey: 'Generirajte svoj WhatsApp API ključ za integraciju s vašim prilagođenim razvijenim aplikacijama.',
        generateApiKey: 'Generirajte API ključ',
        webhookUrl: 'Webhook URL',
        addHeader: 'Dodaj zaglavlje',
        test: 'Testiraj',
        webhookNotSet: 'Webhook nije postavljen',
        webhookHeaders: 'Webhook zaglavlja',
        setWebhookUrl: 'Postavi Webhook URL',
        placeholders: {
          yourApiKey: 'Vaš API ključ',
          enterWebhookUrl: 'Unesite Webhook URL',
          enterHeaderKey: 'Unesite ključ zaglavlja',
          enterValue: 'Unesite vrijednost',
        }
      },
      broadcast: {
        createBroadcast: 'Kreirajte emitovanje',
        createMultipleBroadcasts: 'Možete kreirati više emitovanja sa više zakazanih tokova/predložaka za različite grupe korisnika.',
        broadcastName: 'Ime emitovanja',
        nameIsRequired: 'Ime je obavezno',
        selectType: 'Izaberite tip',
        selectYourFlowType: 'Izaberite tip vašeg toka',
        segment: 'Grupa',
        selectYourSegmentType: 'Izaberite tip grupe',
        whenToSend: 'Kada poslati',
        selectDate: 'Izaberite datum',
        messageTag: 'Oznaka poruke',
        selectMessageTag: 'Izaberite oznaku poruke',
        contentType: 'Tip sadržaja',
        nonPromotional: 'Nepromotivno (primenjuju se oznake poruka)',
        tagEachMessgeThatComesBeforeAnyInteraction: 'Označite svaku poruku koja dolazi pre svakog interakcije ili nakon koraka sa odlaganjem' +
          ' preko 24 sata sa odgovarajućom oznakom. Poruke bez oznake neće stići do pretplatnika' +
          ' koji su interagovli sa botom pre više od 24 sata.',
        promotional: 'Promotivno (Oznake poruka ignorisane)',
        theseBroadcasts: 'Ova emitovanja mogu sadržavati promocije, ali ciljna grupa je ograničena na pretplatnike koji su' +
          ' interagovli sa vašim botom u poslednjih 24 sata.',
        createNewBroadcast: 'Kreirajte novo emitovanje',
        sentMessages: 'Poslate poruke',
        deliveredMessages: 'Dostavljene poruke',
        readMessages: 'Pročitane poruke',
        failedMessages: 'Neuspele poruke',
        type: 'Tip',
        template: 'Predložak',
        sent: 'Poslato',
        delivered: 'Dostavljeno',
        read: 'Pročitano',
        failed: 'Neuspešno',
        broadcastAt: 'Emitovano u',
        status: 'Status',
        shipmentUpdate: 'Ažuriranje pošiljke',
        flow: 'Tok',
        resendFailedMessages: 'Ponovno slanje neuspešnih poruka',
        goBack: 'Nazad',
        number: 'Broj',
        errorCode: 'Kôd greške',
        failedAt: 'Neuspešno u',
        badGateway: '502 loš prolaz',
        loadMore: 'Učitaj više',
        placeholders: {
          enterBroadcastName: 'Unesite ime emitovanja',
          searchBroadcastByName: 'Pretraži emitovanje po imenu',
        },
        appTooltip: {
          totalBroadcastMessagesSent: 'Ukupno poslatih emitovanih poruka',
          totalBroadcastMessagesDelivered: 'Ukupno dostavljenih emitovanih poruka',
          totalBroadcastMessagesReadByContacts: 'Ukupno pročitanih emitovanih poruka od strane kontakata',
          totalFailedBroadcastMessages: 'Ukupno neuspešnih emitovanih poruka',
          clickToViewDetailedInformationOfFailedMessages: 'kliknite da biste videli detaljne informacije o neuspešnim porukama',
          clickToCreateNewBroadcast: 'Kliknite da biste kreirali novo emitovanje',
          templateUsedInBroadcast: 'Predložak korišćen u emitovanju',
          numberOfBroadcastMessagesSent: 'Broj emitovanih poruka poslatih',
          numberOfBroadcastMessagesDelivered: 'Broj emitovanih poruka dostavljenih',
          numberOfBroadcastMessagesReadByContacts: 'Broj emitovanih poruka pročitanih od strane kontakata',
          numberOfTimesBroadcastMessagesHasFailed: 'Broj puta kada emitovane poruke nisu uspele',
          contactNumberOnWhichMessageDeliveryFailed: 'Broj kontakta na kojem dostava poruke nije uspela',
          unDeliveredTemplate: 'Nedostavljeni predložak',
          errorReceivedForFailedMessage: 'Greška primljena za neuspešnu poruku',
          timeWhenMessageDeliveryFailed: 'Vreme kada dostava poruke nije uspela',
          TOOLTIP_ADD_BROADCAST_NAME: 'Unesite novo ime emitovanja',
          TOOLTIP_BROADCAST_SELECT_TYPE: 'Izaberite da li emitujete tok ili poruku.',
          TOOLTIP_BROADCAST_FLOW: 'Izaberite razgovor koji želite da emitujete,',
          TOOLTIP_BROADCAST_SELECT_YOUR_SEGMENT: 'Izaberite grupu kontakata kojoj želite da emitujete',
          TOOLTIP_BROADCAST_NAME: 'Ime emitovanja',
          TOOLTIP_BROADCAST_TYPE: 'Tok ili poruka izabrani za emitovanje',
          TOOLTIP_BROADCAST_SEGMENT: 'Grupa za koju je emitovanje kreirano',
          TOOLTIP_BROADCAST_AT: 'Datum i vreme zakazano za emitovanje',
          TOOLTIP_BROADCAST_STATUS: 'Status emitovanja kao zakazano, trenutno pokrenuto ili završeno',
        }
      },
      drip: {
        createDripCampaign: 'Kreirajte Drip kampanju',
        youCanCreateMultipleCampaigns: 'Možete kreirati više kampanja',
        dripCampaignName: 'Ime Drip kampanje',
        dripCampaignNameIsRequired: 'Ime Drip kampanje je obavezno',
        youCanCreateMultipleDripCampaigns: 'Možete kreirati više Drip kampanja sa zakazanim, automatizovanim porukama kako biste pokrenuli odgovore određenih grupa korisnika.',
        campaignName: 'Ime kampanje',
        campaignNameIsRequired: 'Ime kampanje je obavezno',
        after: 'Nakon ',
        thisMessageWillBeSendAfter: 'Ova poruka će biti poslata nakon',
        saveAndUpdate: 'Sačuvaj i ažuriraj',
        schedule: ' Raspored',
        select: 'Izaberi',
        messages: 'Poruke',
        cancel: 'Otkaži',
        createCampaign: 'Kreirajte kampanju',
        updateCampaign: 'Ažurirajte kampanju',
        createNewCampaign: 'Kreirajte novu kampanju',
        messagesSent: 'Poslate poruke',
        createdAt: 'Kreirano u',
        updatedAt: 'Ažurirano u',
        action: 'Akcija',
        placeholders: {
          nameYourDripCampaign: 'Imenujte svoju Drip kampanju',
          enterCampaignName: 'Unesite ime kampanje',
          searchCampaignByName: 'Pretraži kampanju po imenu',
        },
        appTooltip: {
          TOOLTIP_CREATE_CAMPAIGN: 'Kliknite da biste dodali novu kampanju',
          TOOLTIP_SCHEDULE: 'Planirajte kada i koji tok razgovora poslati prvo u ovoj kampanji.',
          TOOLTIP_AFTER_DAYS: 'Planirajte kada poslati prvi tok kampanje u minutima, satima ili danima.',
          TOOLTIP_ADD_MESSAGES: 'Kliknite da biste dodali novi tok kampanji',
          TOOLTIP_ADD_CAMPAIGN_NAME: 'Unesite novo ime kampanje',
          TOOLTIP_CAMPAIGN_NAME: 'Ime kampanje',
          TOOLTIP_NO_MESSAGES_SENT: 'Broj poruka poslatih kampanjom',
          TOOLTIP_CAMPAIGN_CREATED_AT: 'Datum i vreme kreiranja kampanje',
          TOOLTIP_CAMPAIGN_UPDATED_AT: 'Datum i vreme poslednje izmene kampanje',
          TOOLTIP_CAMPAIGN_ACTION: 'Izmeni ili obriši kampanju',
          TOOLTIP_UPDATE_CAMPAIGN: 'Kliknite da biste sačuvali izmene napravljene u postavkama kampanje',
        }
      },
      flows: {
        createChatFlow: 'Stvori tijek razgovora',
        youCanCreateMultipleConversationsFlow: 'Možete stvoriti više tijekova razgovora na različitim kanalima za A/B testiranje i emitiranja.',
        flowName: 'Naziv tijeka',
        nameIsRequired: 'Naziv je obavezan',
        cancel: 'Odustani',
        createFlow: 'Stvori tijek',
        createNewFlow: 'Stvori novi tijek',
        ofMessages: 'od poruka',
        triggered: 'Pokrenuto',
        stepsFinsished: 'Koraci završeni',
        finished: 'Završeno',
        createdOn: 'Stvoreno',
        lastModified: 'Zadnja izmjena',
        defaultFlow: 'Zadani tijek',
        action: 'Akcija',
        flowAnalytics: 'Analiza tijeka',
        placeholders: {
          enterFlowName: 'Unesite naziv tijeka',
          searchFlowByName: 'Pretraži tijek po nazivu',
        },
        appTooltip: {
          numberOfTimesChatFlowTriggered: 'Broj puta kada je tijek razgovora pokrenut',
          numberOfCompletedChatFlowStepsWhenTriggered: 'Broj završenih koraka tijeka razgovora kada je pokrenut',
          numberOfTimesUsersCompletedChatFlowSteps: 'Broj puta kada su korisnici završili sve korake tijeka razgovora',
          dateAndTimeOfCreationOfChatFlow: 'Datum i vrijeme stvaranja tijeka razgovora',
          dateAndTimeWhenChatFlowLastModified: 'Datum i vrijeme kada je tijek razgovora zadnji put izmijenjen',
          TOOLTIP_CREATE_FLOW: 'Klikni za stvaranje novog tijeka razgovora',
          TOOLTIP_FLOW_NAME: 'Unesite naziv tijeka razgovora',
          TOOLTIP_FLOW_TABLE_NAME: 'Naziv tijeka razgovora',
          TOOLTIP_NO_OF_MESSAGES: 'Broj komponenata poruka u tijeku razgovora',
          TOOLTIP_DEFAULT_FLOW: 'Upotrijebite ovu prekidač da biste postavili tijek razgovora kao zadani, koji će se prikazivati svim novim korisnicima.',
          TOOLTIP_ACTION: 'Uredi ili izbriši tijek razgovora',
        }
      },
      manage: {
        leads: 'Potencijalni klijenti',
        manageBotsFunctionalityForContacts: `Upravljajte funkcionalnostima bota za kontakte/potencijalne klijente`,
        whenToSendLeadInfo: 'Kada poslati informacije o potencijalnom klijentu',
        smartFlow: 'Pametni tok',
        welcomeMessageWhenNoSearchKeywordIsMet: 'Poruka dobrodošlice kada nema poklapanja ključne reči',
        selectTemplates: 'Izaberite šablone',
        selectFlows: 'Izaberite tokove',
        selectText: 'Izaberite tekst',
        selectImages: 'Izaberite slike',
        whenItAlmostReaches24HoursSinceMessage: 'Kada se približi 24 časa od poslednje poruke',
        updateChanges: 'Ažurirajte promene',
        manageBotsFunctionalityAccordingToKeywords: `Upravljajte funkcionalnostima bota prema ključnim rečima unetim od strane korisnika bota, u slučaju pametnog toka`,
        addKeywordAction: 'Dodajte akciju ključne reči',
        keywords: 'Ključne reči',
        matchingMethod: 'Metoda poklapanja',
        replyMaterial: 'Materijal za odgovor',
        action: 'Akcija',
        select: 'Izaberite',
        placeholders: {
          keyword: 'ključna reč'
        },
        appTooltip: {
          TOOLTIP_LEADS_WHEN_TO_SEND_LEAD: 'Predložite da li bot treba odmah poslati informacije o kontaktu/potencijalnom klijentu ka integrisanom CRM-u, ili nakon 5 minuta, ili na kraju toka',
          TOOLTIP_LEAD_SMART_FLOW: 'Izaberite bilo koji podrazumevani tok kako biste ga poslali svim korisnicima bota, ili pametni tok (određen ključnim rečima unetim od strane korisnika bota).',
          TOOLTIP_LEAD_WELCOME_MESSAGE: 'Izaberite materijal za odgovor (tok, šablon, tekst, slika) za slanje ako bot ne pronađe poklapanje ključnih reči u odgovoru korisnika bota',
          TOOLTIP_IT_ALMOST_REACHED: 'Izaberite materijal za odgovor koji će se poslati kontaktima/potencijalnim klijentima neposredno pre isteka 24 sata od poslednje poruke',
          TOOLTIP_KEYWORD_ACTION_TITLE: 'Upravljajte funkcionalnostima bota prema ključnim rečima unetim od strane korisnika bota, u slučaju pametnog toka',
          TOOLTIP_ADD_KEYWORD_ACTIONS_HEADING: 'Izaberite odgovor bota kao šablon, tok, tekst ili sliku prema određenim ključnim rečima unetim od strane korisnika',
          TOOLTIP_ADD_KEYWORD: 'Dodajte ključne reči',
          TOOLTIP_MATCHING_METHOD: 'Dodajte poklapanje ključnih reči kao \'tačno\' ili \'sadrži\'',
          TOOLTIP_REPLY_MATERIAL: 'Izaberite šablon, tok, tekst ili sliku za odgovor na predloženu ključnu reč',
          TOOLTIP_KEYWORD_ACTIONS: 'Obrišite akciju ključne reči',
        },
        socialAlerts: {
          alerts: 'Upozorenja',
          specifyHowYourBotWillNotify: 'Navedite kako će vaš bot obaveštavati o novim potencijalnim klijentima.'
        }
      },
      orders: {
        manageCustomersOrder: 'Upravljajte narudžbama klijenata',
        checkAndManageAllOfYourCustomerOrders: 'Provjerite i upravljajte svim narudžbama i ažuriranjima svojih klijenata.',
        selectShipmentTemplate: 'Odaberite predložak dostave',
        send: 'Pošalji',
        export: 'Izvoz',
        phoneNumber: 'Broj telefona',
        numberOfItems: 'Broj predmeta',
        orderValue: 'Vrijednost narudžbe',
        orderDate: 'Datum narudžbe',
        status: 'Status',
        chat: 'Razgovor',
        item: 'Predmet',
        quantity: 'Količina',
        amount: 'Iznos',
        unitPrice: 'Jedinična cijena',
        placeholders: {
          searchOrdersByPhoneNumber: 'Pretraži narudžbe po brojevima telefona',
        },
        appTooltip: {
          exportOrdersDataInCSVFile: 'Izvezi podatke o narudžbama u CSV datoteku',
          TOOLTIP_ORDERS_PHONE_NO: 'Broj telefona klijenta koji je naručio',
          TOOLTIP_NO_OF_ITEMS: 'Broj naručenih predmeta',
          TOOLTIP_ORDER_VALUE: 'Vrijednost narudžbe',
          TOOLTIP_ORDER_DATE: 'Narudžba je napravljena na ovaj datum.',
          TOOLTIP_ORDER_STATUS: 'Status narudžbe kao potvrđeno, u tijeku, odbijeno ili poslano',
          TOOLTIP_ORDER_CHAT: 'Svi prethodni razgovori ove narudžbe',
        }
      },
      widgets: {
        installWidgetHeader: 'Instalirajte vidžet',
        createWidgetHeader: 'Kreirajte vidžet',
        copyTheCodeAndPasteItWhereYouWant: 'Kopirajte kod i nalepite ga gde god želite u svom HTML-u, veb lokaciji itd.',
        youCanCreateMultipleWidgets: 'Možete kreirati više vidžeta kako biste svom botu dali različit izgled na različitim veb stranicama.',
        installWidget: {
          javascript: 'JavaScript',
          install: 'Instalirajte ',
          onYourWebsite: ' na svojoj veb stranici',
          copyCode: 'Kopirajte kod',
          copyAndPaste: 'Kopirajte i nalepite',
          copyThisCodeSnippet: 'Kopirajte ovaj odlomak koda i umetnite ga u HTML svake veb stranice gde želite da prikažete vidžet. Za više detalja',
          seeGuide: 'vidi vodič',
        },
        widgetList: {
          widgetName: 'Ime vidžeta',
          nameIsRequired: 'Ime je obavezno',
          cancel: 'Otkaži',
          createWidget: 'Kreirajte vidžet',
          icon: 'Ikona',
          name: 'Ime',
          createdAt: 'Kreirano u',
          action: 'Akcija',
          placeholders: {
            enterWidgetName: 'Unesite ime vidžeta',
            searchWidgetByName: 'Pretraži vidžet po imenu',
          },
          appTooltip: {
            widgetIcon: 'Ikona vidžeta',
            nameOfWidget: 'Ime vidžeta',
            dateAndTimeOfCreationOfWidget: 'Datum i vreme kreiranja vidžeta',
            editOrDeleteWidget: 'Uredi ili obriši vidžet',
          }
        },
        widgetTemplates: {
          widgetName: 'Ime vidžeta',
          nameIsRequired: 'Ime je obavezno',
          chooseTypeOfWidget: 'Izaberite vrstu vidžeta',
          bar: 'Traka',
          slideIn: 'Klizanje',
          pageTakeOver: 'Preuzimanje stranice',
          button: 'Dugme',
          facebookModal: 'Facebook Modal',
          comment: 'Komentar',
          direct: 'Direktno',
          whatsappIcon: 'WhatsApp Ikona',
          refUrl: 'Ref URL',
          qrCode: 'QR kod',
          backgroundColor: 'Boja pozadine',
          descriptionColor: 'Boja opisa',
          headlineColor: 'Boja naslova',
          buttonBackgroundColor: 'Boja pozadine dugmeta',
          contactNumber: 'Kontaktni broj',
          entryMessage: 'Poruka prijema',
          buttonText: 'Tekst dugmeta',
          selectButtonText: 'Izaberite tekst dugmeta',
          buttonSize: 'Veličina dugmeta',
          selectOne: 'Izaberite jedno',
          placement: 'Postavljanje',
          rightBottom: 'Desno-dole',
          optInFlow: 'Opt-in tok',
          selectFlow: 'Izaberite tok',
          addSubscriberToSequence: 'Dodajte pretplatnika u sekvencu',
          selectDrip: 'Izaberite kap',
          whenDoesItDisplay: 'Kada se prikazuje (Sekunde)',
          showWidgetToSameUserAgainAfter: 'Prikaži vidžet istom korisniku ponovo nakon',
          ifManuallyClosedByUser: 'Ako je ručno zatvoreno od strane korisnika, prikaži nakon',
          specificPosts: 'Specifični postovi',
          allPosts: 'Svi postovi',
          postMessage: 'Poruka posta',
          postDate: 'Datum posta',
          status: 'Status',
          action: 'Akcija',
          discard: 'Odbaci',
          saveChanges: 'Sačuvaj promene',
          nextStep: 'Sledeći korak',
          widgetDescription: 'Opis vidžeta',
          integrateTheBarWidget: `Integrišite Bar vidžet u telo vaše veb stranice i povećajte broj pretplatnika stranice zajedno sa slanjem prilagođenih poruka bota.`,
          hereIsYourWidgetHeadline: 'Evo naslova vašeg vidžeta, kliknite ovde da ga promenite.',
          sendUsMessage: 'Pošaljite nam poruku',
          weAlsoPutDefaultTextHere: 'Takođe smo stavili podrazumevani tekst ovde. Obratite pažnju da ga pretvorite u vrednu poruku.',
          selectYourPagePost: 'Izaberite svoj post na stranici',
          nA: 'N/A',
          saveRule: 'Sačuvaj pravilo',
          placeholders: {
            enterWidgetName: 'Unesite ime vidžeta',
            enterNumber: 'Unesite broj',
            enterMessageHere: 'Unesite poruku ovde',
            enterTimeInSeconds: 'Unesite vreme u sekundama',
          }
        }
      }
    },
    triggers: {
      customizeYourBotsTriggerSettings: `Prilagodite postavke okidača svog bota`,
      makeYourBotsTimingPerfect: `Postavite vreme svog bota savršeno.`,
      onDesktopTriggerTime: 'Na desktopu, vreme okidača (sekunde)',
      onMobileTriggerTime: 'Na mobilnom, vreme okidača (sekunde)',
      chatBubble: 'Automatsko otvaranje chat balona',
      seconds: 'Sekunde',
      discard: 'Odbaci',
      saveChanges: 'Sačuvaj promene',
      autoTriggerOnOrOff: 'Onemogući automatsko pokretanje',
      seeHowToUse: 'Pogledajte kako koristiti',
      alwaysOpenAfter: 'Uvek otvoreno nakon navedenih okidača',
      automaticallyAfterSelectedNumberOfTime: 'Automatski nakon određenog vremena',
      neverAutomaticallyOpenBot: 'Nikada automatski ne otvarajte bota',
      placeholders: {
        enterTimeInSeconds: 'Unesite vreme u sekundama',
      },
      appTooltip: {
        TOOLTIP_DESKTOP_TRIGGER_TIME: 'Vreme čekanja u sekundama, na desktop uređajima posetioca, pre nego što vaš bot automatski iskoči',
        TOOLTIP_MOBILE_TRIGGER_TIME: 'Vreme čekanja u sekundama, na mobilnom uređaju posetioca, pre nego što vaš bot automatski iskoči',
        TOOLTIP_CHAT_BUBBLE_OPENING: 'Kada posetilac zatvori prozor za čet, odaberite kako će se automatsko otvaranje bota ponašati',
        customerWaitingTimeToOpenBubble: 'Vreme čekanja kupca za otvaranje čet balona',
        wantToDisableAutoTriggering: 'Omogući ovo ako ne želite automatski otvoriti čet robota na web mjestu'
      }
    },
    userAccess: {
      customizeYourBotsSettings: `Prilagodite postavke svog bota`,
      decideWhoCanAccessYourBot: 'Odlučite tko može pristupiti vašem botu',
      deviceSupport: 'Podrška uređajima',
      blockIpAddresses: 'Blokiraj IP adrese',
      hideChatBotOnSpecificPages: 'Sakrijte chatbota na određenim stranicama',
      selectCountriesToEnableBot: 'Odaberite zemlje za omogućavanje bota',
      discard: 'Odbaci',
      saveChanges: 'Spremi promjene',
      seeHowToUse: 'Pogledajte kako koristiti',
      allDevices: 'Svi uređaji',
      mobileOnly: 'Samo mobilni uređaji',
      desktopOnly: 'Samo radna površina',
      placeholders: {
        enterIpAddress: `Unesite IP adresu (ipv4 ili ipv6) i pritisnite 'Enter'`,
        enterUrl: `Unesite URL stranica i pritisnite 'Enter'`,
        searchCountry: 'Pretražite zemlju',
      },
      appTooltip: {
        TOOLTIP_DEVICE_SUPPORT: 'Odaberite na kojim uređajima želite da se vaš bot pojavi',
        TOOLTIP_BLOCK_IP_ADDRESS: 'Unesite IP adrese na kojima ne želite da se vaš bot pojavi',
        TOOLTIP_HIDE_CHATBOT_SPECIFIC_PAGES: 'Unesite URL svojih web stranica na kojima ne želite da se vaš bot pojavi',
        TOOLTIP_COUNTRIES_TO_ENABLE_BOT: 'Odaberite lokacije s kojih želite da korisnici pristupaju vašem botu',
      }
    },
    facebook: {
      facebookBotSettings: 'Podešavanje Facebook Bota',
      chatFlowsHeader: 'Chat Flow-ovi',
      dripCampaignHeader: 'Drip Kampanje',
      broadcastHeader: 'Broadcast',
      widgetsHeader: 'Widgeti',
      autoReplyHeader: 'Auto-Odgovor',
      generalHeader: 'Opšte',
      facebookAutomation: 'Automatizacija na Facebook-u',
      appTooltip: {
        TOOLTIP_CHAT_FLOW_TITLE: 'Prilagodite predloške chat flow-ova i kreirajte više chat flow-ova za različite ciljne grupe.',
        TOOLTIP_DRIP_CAMPAIGN_TITLE: 'Kreirajte putovanje korisnika kroz drip kampanju zakazanih chat flow-ova.',
      },
      broadcasts: {
        createBroadcast: 'Kreiraj Broadcast',
        youCanCreateMultipleBroadcasts: 'Možete kreirati više broadcast-ova',
        broadcastName: 'Ime Broadcast-a',
        broadcastNameIsRequired: 'Ime Broadcast-a je obavezno',
        continue: 'Nastavi',
        manageBroadcasts: 'Upravljaj Broadcast-ovima',
        youCanCreateMultipleBroadcastsWith: 'Možete kreirati više broadcast-ova sa zakazanim predlošcima za različite grupe korisnika.',
        createNewBroadcast: 'Kreiraj Novi Broadcast',
        name: 'Ime',
        segment: 'Grupa',
        template: 'Predložak',
        contacts: 'Kontakti',
        send: 'Pošalji',
        failed: 'Neuspelo',
        broadcastAt: 'Broadcast U',
        status: 'Status',
        actions: 'Akcije',
        nA: 'N/A',
        deleteBroadcast: 'Obriši Broadcast',
        wantToDeleteThisBroadcast: 'Da li ste sigurni da želite da obrišete ovaj Broadcast?',
        placeholders: {
          enterBroadcastName: 'Unesite ime broadcast-a',
          searchHere: 'Pretraži ovde',
        },
        appTooltip: {
          deleteMultipleBroadcasts: 'Obriši više broadcast-ova',
          deleteBroadcast: 'Obriši Broadcast'
        }
      },
      createBroadcastFacebook: {
        braodcastName: 'Ime Broadcast-a',
        broadcastNameIsRequired: 'Ime Broadcast-a je obavezno',
        flow: 'Flow',
        segments: 'Grupe',
        whenToSend: 'Kada poslati',
        selectDate: 'Izaberite Datum',
        selectTimeSlot: 'Izaberite Vremenski Slot',
        createBroadcast: 'Kreiraj Broadcast',
        cancel: 'Otkaži',
        now: 'Sada',
        later: 'Kasnije',
        placeholders: {
          enterBroadcastName: 'Unesite ime Broadcast-a',
          selectFlow: 'Izaberite Flow',
          searchFlowByName: 'Pretražite flow po imenu',
          selectSegments: 'Izaberite Grupe',
          searchSegmentByName: 'Pretražite grupu po imenu',
          selectTimeSlot: 'Izaberite Vremenski Slot',
        },
        indexMergeDatePicker: {
          selectStartDate: 'Izaberite početni datum',
        }
      },
      dripCampaigns: {
        createDripCampaign: 'Kreiraj Drip Kampanju',
        youCanCreateMultipleCampaign: 'Možete kreirati više kampanja',
        dripCampaignName: 'Ime Drip Kampanje',
        dripCampaignNameIsRequired: 'Ime Drip Kampanje je obavezno',
        continue: 'Nastavi',
        manageDripCampaign: 'Upravljaj Drip Kampanjama',
        youCanCreateMutlipleDripCampaign: 'Možete kreirati više drip kampanja sa zakazanim, automatizovanim porukama koje pokreću odgovore iz određenih grupa korisnika.',
        createNewDripCampaign: 'Kreiraj Novu Drip Kampanju',
        campaignName: 'Ime Kampanje',
        appliedOn: 'Primenjeno Na',
        segment: 'Grupa',
        flow: 'Flow',
        startDate: 'Datum Početka',
        action: 'Akcija',
        nA: 'N/A',
        deleteDripCampaign: 'Obriši Drip Kampanje',
        wantToDeleteThisDripCampaign: 'Da li ste sigurni da želite da obrišete ovu Drip Kampanju?',
        placeholders: {
          enterDripCampaignName: 'Unesite ime Drip Kampanje',
          searchByName: 'Pretraži po imenu',
        },
        appTooltip: {
          deleteMultipleDripCampaigns: 'Obriši više drip kampanja',
          deleteDripCampaign: 'Obriši Drip Kampanju',
        },
        createDripCampaignFacebook: {
          dripCampaignName: 'Ime Drip Kampanje',
          appliedOn: 'Primenjeno Na',
          segments: 'Grupe',
          selectDate: 'Izaberite Datum',
          scheduleYourFlows: 'Zakazivanje Vaših Flow-ova',
          schedule: 'Raspored',
          flow: 'Flow',
          sendAfter: 'Pošalji Nakon',
          cancel: 'Otkaži',
          newSubscriber: 'Novi Pretplatnik',
          days: 'Dana',
          minutes: 'Minuta',
          hours: 'Sati',
          createDripCampaign: 'Kreiraj Drip Kampanju',
          placeholders: {
            enterDripName: 'Unesite ime Drip Kampanje',
            selectAppliedOn: 'Izaberite Primenjeno Na',
            selectSegment: 'Izaberite Grupu',
            searchByName: 'Pretraži Po Imenu',
            selectTemplate: 'Izaberite Predložak',
            searchFlowByName: 'Pretraži Flow Po Imenu',
            enterSendAfter: 'Unesite Pošalji Nakon',
          },
          dateTimePicker: {
            selectStartDate: 'Izaberite početni datum',
          }
        }
      },
      failedBroadcastFacebook: {
        chatId: 'Chat Id',
        errorCode: 'Kod Greške',
        errorMessage: 'Poruka Greške',
        nA: 'N/A',
      },
      flows: {
        chatFlows: 'Chat Flow-ovi',
        createChatFlow: 'Kreiraj Chat Flow',
        youCanCreateMultipleChatFlows: 'Možete kreirati više chat flow-ova preko više kanala za A/B testiranje i broadcast-ove.',
        flowName: 'Ime Flow-a',
        nameIsRequired: 'Ime je obavezno',
        cancel: 'Otkaži',
        createFlow: 'Kreiraj Flow',
        importFlow: 'Uvezi Flow',
        createNewFlow: 'Kreiraj Novi Flow',
        ofMessages: 'od poruka',
        createdOn: 'Kreirano',
        lastModified: 'Poslednja Izmena',
        defaultFlow: 'Podrazumevani Flow',
        action: 'Akcija',
        exportStatus: 'Status Izvoza',
        flowExport: 'Izvoz Flow-a ',
        download: 'Preuzmi',
        beforeYouStartUploadPleaseMakeSure: 'Pre nego što počnete sa uvozom, proverite da li',
        point1: '1. Maksimalna veličina fajla za uvoz je 20MB',
        point2: '2. Format fajla treba da bude JSON',
        selectFile: 'Izaberite Fajl',
        inProgress: 'U toku',
        available: 'Dostupno',
        initiated: 'Inicirano',
        placeholders: {
          enterFlowName: 'Unesite ime flow-a',
        },
        appTooltip: {
          importFlowForFacebookBot: 'Uvezi flow za Facebook bota',
          dateAndTimeOfCreationOfChatFlow: 'Datum i vreme kreiranja chat flow-a',
          dateAndTimeWhenChatFlowLastModified: 'Datum i vreme poslednje izmene chat flow-a',
          TOOLTIP_CREATE_FLOW: 'Kliknite da biste kreirali novi chat flow',
          TOOLTIP_FLOW_NAME: 'Unesite ime chat flow-a',
          TOOLTIP_FLOW_TABLE_NAME: 'Ime chat flow-a',
          TOOLTIP_NO_OF_MESSAGES: 'Broj komponenata poruke u chat flow-u',
          TOOLTIP_DEFAULT_FLOW: 'Koristite ovaj prekidač da biste postavili chat flow kao podrazumevani, koji će biti poslužen svim novim korisnicima.',
          TOOLTIP_ACTION: 'Izmenite ili obrišite chat flow',
        },
        noDataFound: {
          flows: 'Flow-ovi',
          noFlowsAddedYet: 'Još uvek nema dodatih Flow-ova!',
        },
        modal: {
          deleteFlow: 'Obriši Flow',
          wantToDeleteThisFlow: 'Da li ste sigurni da želite da obrišete ovaj Flow?',
        }
      },
      widgets: {
        manageWidgets: 'Upravljaj Widgetima',
        widgetsAreRoutingTools: 'Widgeti su alati za usmeravanje kako bi se povećala upotreba bota',
        needHelp: 'Potrebna pomoć?',
        wantToMakeChanges: 'Želite da napravite promene?',
        editIcon: 'Izmeni Ikonu',
        discard: 'Odbaci',
        updateWidget: 'Ažuriraj Widget',
        installChatBotIconOnYourWebsite: 'Instalirajte ikonu chatbota na svoj veb sajt',
        shareWhereEverYouWantToRedirectUsersTo: 'Podelite gde god želite i preusmerite korisnike na svoj Facebook bot u jednom kliku',
        copyAndAddInYourWebsiteHeaderFile: 'Kopirajte i dodajte u header fajl vašeg veb sajta',
        copyLinkAndStartSharing: 'Kopirajte link i počnite sa deljenjem!',
        downloadQrCodeAndStartSharing: 'Preuzmite QR kod i počnite sa deljenjem!',
        addCodeAndDeployNewCodeAndDone: 'Dodajte kod, implementirajte novi kod i gotovi ste!',
        wantToLearnHowToUseIt: 'Želite da saznate kako da ga koristite?',
        copyChatBotCode: 'Kopirajte Kod Chatbota',
        copyFacebookLink: 'Kopirajte Facebook Link',
        downloadQrCode: 'Preuzmite QR Kod',
        link: 'Link',
        chatBotIcon: 'Ikonica Chatbota',
        qrcode: 'QR Kod',
        small: 'Mala',
        medium: 'Srednja',
        large: 'Velika',
        leftMiddle: 'Levo-Sredina',
        rightMiddle: 'Desno-Sredina',
        leftBottom: 'Levo-Dole',
        rightBottom: 'Desno-Dole',
        bpDropDown: {
          selectIcons: 'Izaberite Ikone',
          iconSize: 'Veličina Ikone',
          iconPlacement: 'Postavljanje Ikone',
        }
      },
      autoReply: {
        autoReplyTitle: 'Automatski odgovor',
        configureYour: 'Konfiguriši svoj ',
        message: ' poruku',
        customizeAutoReplyMessagesForYourPostsComments: 'Prilagodi automatske odgovore za komentare na tvojim objavama',
        wouldYouLikeToApply: 'Da li želite primeniti ',
        autoreply: 'Automatski odgovor',
        onAllPost: ' na sve objave',
        configureYourMessageForEachPost: 'Konfiguriši svoju poruku za svaku objavu',
        configureFlowToTriggerAfterOnReply: 'Podesi tok da se pokrene nakon odgovora',
        whenUserLeavesACommentSendMessageAfter: 'Kada korisnik ostavi komentar, pošalji poruku nakon',
        triggerFlowOnReply: 'Pokreni tok na odgovor',
        add: 'Dodaj',
        update: 'Ažuriraj',
        save: 'Sačuvaj',
        cancel: 'Otkaži',
        discard: 'Odbaci',
        bpDropDown: {
          selectPost: 'Izaberi objavu',
          triggerFlowOnReply: 'Pokreni tok na odgovor',
          immendiately: 'Odmah',
          minutes: 'minuta'
        },
        bpTable: {
          message: 'Poruka',
          selectedPost: 'Izabrana objava',
          triggerFlow: 'Pokreni tok',
          actions: 'Akcije'
        },
        placeholder: {
          configureYourMessage: 'Konfiguriši svoju poruku'
        },
        deleteModel: {
          title: 'Obriši automatski odgovor na objavu',
          description: 'Da li ste sigurni da želite obrisati ovaj automatski odgovor na objavu?'
        }
      },
      generalSetting: {
        sendInactivityMessage: 'Poruka o neaktivnosti korisnika',
        sessionTimeOutInHours: 'Vreme isteka sesije',
        enterSessionTimeOutWindowInHours: 'Unesite vreme zatvaranja sesije u satima',
        sessionTimeOutInHoursTooltip: `Unesite trajanje nakon kojeg će sesija čavrljanja automatski isteći
           zbog neaktivnosti. Chatflow će se ponovo pokrenuti ako korisnik pošalje bilo koju poruku nakon isteka sesije`,
        restartChatFlowTriggers: 'Okidači za ponovno pokretanje čavrljanja',
        enterKeyWordsToRestartChatAndhitEnter: 'Unesite ključne reči za ponovno pokretanje čavrljanja i pritisnite Enter',
        restartChatFlowTriggersTooltip: `Ovde navedite ključne reči koje će, kada ih korisnik unese i pošalje, pokrenuti ponovno pokretanje čavrljanja. To omogućava korisnicima da ponovo pokrenu tok razgovora u bilo kojem trenutku.
          Pritisnite Enter nakon dodavanja svake ključne reči kako biste dodali više ključnih reči.`,
        liveChatTriggers: 'Okidači za uživo čavrljanje',
        enterKeyWordsToTriggerLiveChatAndhitEnter: 'Unesite ključne reči za pokretanje uživo čavrljanja i pritisnite Enter',
        liveChatTriggersTooltip: `Definišite ključne reči koje će, kada ih korisnik unese i pošalje, pokrenuti prelazak sa automatizovanog čavrljanja na uživo čavrljanje. Ovo je korisno kada korisnici traže pomoć od ž
          ivog agenta. Pritisnite Enter nakon dodavanja svake ključne reči kako biste dodali više ključnih reči.`,
        messageAfterAutomatedFlowCompleted: 'Poruka nakon završetka automatizovanog toka',
        enterYourMessage: 'Unesite svoju poruku',
        messageAfterAutomatedFlowCompletedTooltip: `Unesite poruku koja će se prikazati korisniku nakon što završi automatizovani
          tok čavrljanja, ali sesija nije istekla.`,
        restart: 'Ponovno pokreni',
        liveChat: 'Uživo čavrljanje',
        lineOneForDefaultMessage: 'Ako imate više pitanja ili vam je potrebna pomoć, evo šta možete sledeće uraditi:',
        to: 'Do',
        restartTheChat: 'ponovo pokrenite čavrljanje',
        simpleTypeRestartAndHitEnter: ` jednostavno unesite 'Restart' i pritisnite Enter. To će vas vratiti na početak našeg razgovornog toka.`,
        lineThreeForDefaultMessagePartOne: `Ako želite razgovarati sa`,
        liveAgent: `živim agentom,`,
        lineThreeForDefaultMessageLastPart: `unestite 'Uživo čavrljanje' i pritisnite Enter. Naš tim je ovde da vam pomogne u realnom vremenu.`,
        saveChanges: 'Sačuvaj promene',
        discard: 'Odbaci',
        configureBotsGeneralSettings: `Konfigurišite opšte postavke vašeg bota`,
        minutes: 'Minuta',
        hours: 'Sati',
      },
    },
    instagram: {
      instagramBotSettings: 'Postavke Instagram Bota',
      chatFlowsHeader: 'Razgovorni Tokovi',
      broadcastHeader: 'Emitiranje',
      dripCampaignHeader: 'Kap Kampanja',
      widgetsHeader: 'Widgets',
      alertsHeader: 'Upozorenja',
      alerts: {
        configureYourBotsSettings: `Postavite postavke alarma vašeg bota`,
        specifyHowYourBotNotifyYou: 'Odredite kako će vaš bot obavještavati o novim potencijalnim klijentima.',
        subject: 'Predmet',
        emailNotification: 'Obavijesti putem e-pošte',
        emailAddresses: 'E-pošta adrese',
        leadRevisitNotifications: 'Obavijesti o ponovnim posjetima potencijalnih klijenata',
        whenToSendLeadInfo: 'Kada poslati informacije o potencijalnom klijentu',
        discard: 'Odbaci',
        saveChanges: 'Spremi promjene',
        placeholders: {
          enterSubjectForYourEmail: 'Unesite predmet za svoj e-mail',
          typeYourEmailAddressAndHitEnter: 'Upišite svoju e-mail adresu i pritisnite Enter',
        }
      },
      broadcasts: {
        createBroadcast: 'Kreiraj emitiranje',
        youCanCreateMultipleBroadcasts: 'Možete kreirati više emitiranja',
        broadcastName: 'Ime emitiranja',
        broadcastNameIsRequired: 'Ime emitiranja je obavezno',
        continue: 'Nastavi',
        manageBroadcasts: 'Upravljanje emitiranjima',
        youCanCreateMultipleBroadcastsWithMultipleTemplatesAndDifferentSegments: 'Možete kreirati više emitiranja s više' +
          ' zakazanih predložaka za različite grupe klijenata.',
        createNewBroadcast: 'Kreiraj novo emitiranje',
        segment: 'Grupa',
        template: 'Predložak',
        contacts: 'Kontakti',
        send: 'Pošalji',
        failed: 'Neuspješno',
        broadcastAt: 'Emitiranje u',
        status: 'Status',
        actions: 'Akcije',
        nA: 'N/A',
        placeholders: {
          enterBroadcastName: 'Unesite ime emitiranja',
          searchHere: 'Pretraži ovdje',
        },
        appTooltip: {
          deleteMultipleBroadcasts: 'Izbriši više emitiranja',
          deleteBroadcast: 'Izbriši emitiranje',
        }
      },
      createBroadcast: {
        broadcastName: 'Ime emitiranja',
        broadcastNameIsRequired: 'Ime emitiranja je obavezno',
        flow: 'Tok',
        segments: 'Grupe',
        whenToSend: 'Kada poslati',
        selectDate: 'Odaberi datum',
        selectTimeSlot: 'Odaberi vremenski slot',
        cancel: 'Odbaci',
        createBroadcast: 'Kreiraj emitiranje',
        placeholders: {
          enterBroadcastName: 'Unesite ime emitiranja',
          selectFlow: 'Odaberi tok',
          searchFlowByName: 'Pretraži tok po imenu',
          selectSegments: 'Odaberi grupe',
          searchSegmentByName: 'Pretraži grupe po imenu',
          selectTimeSlot: 'Odaberi vremenski slot',
        },
        indexMergeDatePicker: {
          selectStartDate: 'Odaberi početni datum',
        }
      },
      dripCampaigns: {
        createDripCampaign: 'Kreirajte kap kampanju',
        youCanCreateMultipleCampaigns: 'Možete kreirati više kampanja',
        dripCampaignName: 'Ime kap kampanje',
        dripCampaignNameIsRequired: 'Ime kap kampanje je obavezno',
        continue: 'Nastavi',
        manageDripCampaign: 'Upravljanje kap kampanjama',
        youCanCreateMultipleCampaignsWith: 'Možete kreirati više kap kampanja s zakazanim, automatiziranim porukama za' +
          ' poticanje odgovora iz određenih skupina korisnika.',
        createNewDripCampaign: 'Kreiraj novu kap kampanju',
        campaignName: 'Ime kampanje',
        appliedOn: 'Primijenjeno na',
        segment: 'Grupa',
        flow: 'Tok',
        startDate: 'Početni datum',
        action: 'Akcija',
        nA: 'N/A',
        placeholders: {
          enterDripCampaignName: 'Unesite ime kap kampanje',
          searchByName: 'Pretraži po imenu',
        },
        appTooltip: {
          deleteMultipleDripCampaigns: 'Izbriši više kap kampanja',
          deleteDripCampaign: 'Izbriši kap kampanju',
        },
        createDripCampaignInstagram: {
          dripCampaignName: 'Ime kap kampanje',
          appliedOn: 'Primijenjeno na',
          segments: 'Grupe',
          selectDate: 'Odaberi datum',
          scheduleYourFlows: 'Zakazivanje vaših tokova',
          flow: 'Tok',
          sendAfter: 'Pošalji nakon',
          cancel: 'Odbaci',
          createDripCampaign: 'Kreiraj kap kampanju',
          placeholders: {
            enterDripName: 'Unesite ime kap kampanje',
            selectAppliedOn: 'Odaberi Primijenjeno na',
            selectSegment: 'Odaberi grupu',
            searchByName: 'Pretraži po imenu',
            selectTemplate: 'Odaberi predložak',
            searchFlowByName: 'Pretraži tok po imenu',
            enterSendAfter: 'Unesite Pošalji nakon',
          },
          dateTimePicker: {
            selectStartDate: 'Odaberi početni datum',
          }
        }
      },
      failedBroadcastInstagram: {
        chatId: 'ID razgovora',
        errorCode: 'Šifra pogreške',
        errorMessage: 'Poruka o pogrešci',
        nA: 'N/A',
      },
      flows: {
        chatFlows: 'Razgovorni Tokovi',
        createChatFlow: 'Kreiraj razgovorni tok',
        youCanCreateMultipleChatFlows: 'Možete kreirati više razgovornih tokova na raznim kanalima za A/B testiranje i emitiranje.',
        flowName: 'Ime toka',
        nameIsRequired: 'Ime je obavezno',
        cancel: 'Odbaci',
        createFlow: 'Kreiraj tok',
        importFlow: 'Uvezi tok',
        createNewFlow: 'Kreiraj novi tok',
        // flowName: 'Ime toka'
        ofMessages: ' poruka',
        createdOn: 'Kreirano na',
        lastModified: 'Zadnje izmijenjeno',
        defaultFlow: 'Zadani tok',
        action: 'Akcija',
        exportStatus: 'Status izvoza',
        flowExport: 'Tok - Izvoz ',
        download: 'Preuzmi',
        // importFlow: 'Uvezi tok',
        beforeYouStartUploadPleaseMakeSure: 'Prije nego počnete s prijenosom, pobrinite se da',
        point1: '1. Maksimalna veličina datoteke za prijenos je 20MB',
        point2: '2. Format datoteke treba biti u JSON-u',
        selectFile: 'Odaberi datoteku',
        placeholders: {
          enterFlowName: 'Unesite ime toka',
        },
        appTooltip: {
          importFlowForInstagramBot: 'Uvezi tok za Instagram bota',
          dateAndTimeOfCreationOfChatFlow: 'Datum i vrijeme kreiranja razgovornog toka',
          dateAndTimeWhenChatFlowLastModified: 'Datum i vrijeme kada je zadnji put izmijenjen razgovorni tok',
        },
        noDataFound: {
          flows: 'Tokovi',
          noFlowsAddedYet: 'Još nisu dodani tokovi!',
        },
        modal: {
          deleteFlow: 'Izbriši tok',
          wantToDeleteThisFlow: 'Jeste li sigurni da želite izbrisati ovaj tok?',
        }
      },
      widgets: {
        manageWidgets: 'Upravljanje widgetima',
        widgetsAreRoutingTools: 'Widgeti su alati za usmjeravanje kako bi se povećala upotreba bota',
        needHelp: 'Trebate pomoć?',
        wantToMakeChanges: 'Želite napraviti promjene?',
        editIcon: 'Uredi ikonu',
        discard: 'Odbaci',
        updateWidget: 'Ažuriraj widget',
        bpDropDown: {
          selectIcons: 'Odaberi ikone',
          iconSize: 'Veličina ikone',
          iconPlacement: 'Raspored ikona',
        }
      }
    },
    telegram: {
      telegramBotSettings: 'Postavke Telegram Bota',
      chatFlowsHeader: 'Razgovarački Tokovi',
      telegramProfileHeader: 'Telegram Profil',
      widgetsHeader: 'Widgeti',
      broadcastHeader: 'Emitiranje',
      dripCampaignHeader: 'Kap Kapanje',
      generalHeader: 'Opće',
      telegramAutomation: 'Telegram Automatizacija',
      appTooltip: {
        TOOLTIP_DRIP_CAMPAIGN_TITLE: 'Stvorite putovanje korisničkog onboardinga pomoću kampanje kap kapanja zakazanih razgovaračkih tokova.',
        TOOLTIP_CHAT_FLOW_TITLE: 'Prilagodite predloške razgovaračkog toka i stvorite različite razgovaračke tokove za različite ciljane publike.',
      },
      broadcasts: {
        createBroadcast: 'Stvori Emitiranje',
        youCanCreateMutlipleBroadcasts: 'Možete stvoriti više emitiranja',
        broadcastName: 'Ime Emitiranja',
        broadcastNameIsRequired: 'Ime emitiranja je obavezno',
        continue: 'Nastavi',
        manageBroadcasts: 'Upravljanje Emitiranjima',
        youCanCreateMultipleBroadcastsWith: 'Možete stvoriti više emitiranja s više zakazanih predložaka za različite grupe korisnika.',
        createNewBroadcast: 'Stvori Novo Emitiranje',
        name: 'Ime',
        segment: 'Grupa',
        template: 'Predložak',
        contacts: 'Kontakti',
        send: 'Pošalji',
        failed: 'Neuspješno',
        broadcastAt: 'Emitirano U',
        status: 'Status',
        actions: 'Akcije',
        nA: 'N/A',
        deleteBroadcast: 'Izbriši Emitiranje',
        wantToDeleteThisBroadcast: 'Jeste li sigurni da želite izbrisati ovo emitiranje?',
        placeholders: {
          enterBroadcastName: 'Unesite ime emitiranja',
          searchHere: 'Pretraži ovdje',
        },
        appTooltip: {
          deleteMultipleBroadcasts: 'Izbriši više emitiranja',
          deleteBroadcast: 'Izbriši Emitiranje',
        }
      },
      createBroadcastTelegram: {
        broadcastName: 'Ime Emitiranja',
        broadcastNameIsRequired: 'Ime emitiranja je obavezno',
        flow: 'Tok',
        segments: 'Grupe',
        whenToSend: 'Kada poslati',
        selectDate: 'Odaberi Datum',
        selectTimeSlot: 'Odaberi Vremenski Prozor',
        cancel: 'Otkaži',
        createBroadcast: 'Stvori Emitiranje',
        now: 'Sada',
        later: 'Kasnije',
        placeholders: {
          enterBroadcastName: 'Unesite ime emitiranja',
          selectFlow: 'Odaberi Tok',
          searchFlowByName: 'Pretraži tok po imenu',
          selectSegments: 'Odaberi Grupe',
          searchSegmentByName: 'Pretraži grupu po imenu',
          selectTimeSlot: 'Odaberi Vremenski Prozor',
        },
        indexMergeDatePicker: {
          selectStartDate: 'Odaberi početni datum',
        }
      },
      dripCampaigns: {
        createDripCampaign: 'Stvori Kampanju Kap Kapanja',
        youCanCreateMultipleCampaigns: 'Možete stvoriti više kampanja',
        dripCampaignName: 'Ime Kampanje Kap Kapanja',
        dripCampaignNameIsRequired: 'Ime kampanje kap kapanja je obavezno',
        continue: 'Nastavi',
        manageDripCampaign: 'Upravljanje Kampanjama Kap Kapanja',
        youCanCreateMultipleDripCampaignsWith: 'Možete stvoriti više kampanja kap kapanja s zakazanim, automatiziranim porukama kako biste potaknuli odgovore iz određenih skupina korisnika.',
        createNewDripCampaign: 'Stvori Novu Kampanju Kap Kapanja',
        campaignName: 'Ime Kampanje',
        appliedOn: 'Primijenjeno Na',
        segment: 'Grupa',
        flow: 'Tok',
        startDate: 'Datum Početka',
        action: 'Akcija',
        nA: 'N/A',
        deleteDripCampaign: 'Izbriši Kampanje Kap Kapanja',
        wantToDeleteThisDripCampaign: 'Jeste li sigurni da želite izbrisati ove kampanje kap kapanja?',
        placeholders: {
          enterDripCampaignName: 'Unesite ime kampanje kap kapanja',
          searchByName: 'Pretraži po imenu',
        },
        appTooltip: {
          deleteMultipleDripCampaigns: 'Izbriši više kampanja kap kapanja',
          deleteDripCampaign: 'Izbriši Kampanju Kap Kapanja',
        },
        createDripCampaignTelegram: {
          dripCampaignName: 'Ime Kampanje Kap Kapanja',
          appliedOn: 'Primijenjeno Na',
          segments: 'Grupe',
          startDate: 'Odaberi Datum',
          scheduleYourFlows: 'Rasporedite Svoje Tokove',
          schedule: 'Raspored',
          flow: 'Tok',
          sendAfter: 'Pošalji Nakon',
          cancel: 'Otkaži',
          createDripCampaign: 'Stvori Kampanju Kap Kapanja',
          newSubscriber: 'Novi Pretplatnik',
          days: 'Dani',
          minutes: 'Minute',
          hours: 'Sati',
          placeholders: {
            enterDripName: 'Unesite ime kampanje kap kapanja',
            selectAppliedOn: 'Odaberi primijenjeno na',
            selectSegment: 'Odaberi grupu',
            searchByName: 'Pretraži po imenu',
            selectFlow: 'Odaberi tok',
            searchFlowByName: 'Pretraži tok po imenu',
          },
          dateTimePicker: {
            selectStartDate: 'Odaberi početni datum',
          }
        }
      },
      failedBroadcastTelegram: {
        name: 'Ime',
        email: 'Email',
        phone: 'Telefon',
        errorCode: 'Kôd Pogreške',
        errorMessage: 'Poruka Pogreške',
        nA: 'N/A',
      },
      flows: {
        chatFlows: 'Razgovarački Tokovi',
        createChatFlow: 'Stvori Razgovarački Tok',
        youCanCreateMultipleChatFlows: 'Možete stvoriti više razgovaračkih tokova na različitim kanalima za A/B testiranje i emitiranja.',
        flowName: 'Ime Tijeka',
        nameIsRequired: 'Ime je obavezno',
        cancel: 'Otkaži',
        createFlow: 'Stvori Tok',
        importFlow: 'Uvezi Tok',
        createNewFlow: 'Stvori Novi Tok',
        ofMessages: ' od poruka',
        createdOn: 'Stvoreno dana',
        lastModified: 'Zadnji put izmijenjeno',
        defaultFlow: 'Zadani tok',
        action: 'Akcija',
        exportStatus: 'Status Izvoza',
        flowExport: 'Izvoz Tijeka',
        inProgress: 'u tijeku',
        available: 'Dostupno',
        initiated: 'Pokrenuto',
        download: 'Preuzmi',
        beforeYouStartUploadPleaseMakeSure: 'Prije nego počnete s prijenosom, pobrinite se',
        point1: '1. Maksimalna veličina datoteke za prijenos iznosi 20MB',
        point2: '2. Format datoteke treba biti JSON',
        selectFile: 'Odaberi Datoteku',
        placeholders: {
          enterFlowName: 'Unesite ime toka',
        },
        appTooltip: {
          importFlowForTelegramBot: 'Uvezi tok za Telegram Bota',
          dateAndTimeOfCreationOfChatFlow: 'Datum i vrijeme stvaranja razgovaračkog toka',
          dateAndTimeWhenChatFlowLastModified: 'Datum i vrijeme posljednje izmjene razgovaračkog toka',
          TOOLTIP_CREATE_FLOW: 'Kliknite da biste stvorili novi razgovarački tok',
          TOOLTIP_FLOW_NAME: 'Unesite ime razgovaračkog toka',
          TOOLTIP_FLOW_TABLE_NAME: 'Ime razgovaračkog toka',
          TOOLTIP_NO_OF_MESSAGES: 'Broj komponenata poruka u razgovaračkom toku',
          TOOLTIP_DEFAULT_FLOW: 'Upotrijebite ovu prekidač da biste postavili razgovarački tok kao zadani, koji će se služiti svim novim korisnicima.',
          TOOLTIP_ACTION: 'Uredi ili izbriši razgovarački tok',
        },
        noDataFound: {
          flows: 'Tokovi',
          noFlowsAddedYet: 'Još nema dodanih tokova!',
        },
        modal: {
          deleteFlow: 'Izbriši Tok',
          wantToDeleteThisFlow: 'Jeste li sigurni da želite izbrisati ovaj tok?',
        }
      },
      telegramProfile: {
        telegramProfile: 'Telegram Profil',
        manageYourBotProfile: 'Upravljajte profilom svog bota kad god želite.',
        allSetNoActionRequired: 'Sve je postavljeno, nema potrebe za radnjom!',
        congratulationYourAccountIsLive: 'Čestitamo! Vaš račun je aktivan s potpunim pristupom',
        botDetails: 'Detalji Bota',
        name: 'Ime',
        nA: 'N/A',
        b: 'B',
        botName: 'Ime Bota',
        bot: 'Bot',
        info: 'Informacije',
        none: 'Nijedan',
        username: 'Korisničko ime',
        notifications: 'Obavijesti',
        on: 'Uključeno',
        addToGroupOrChannel: 'Dodajte Grupi ili Kanalu',
        userName: 'Korisničko ime',
        botToken: 'Token Bota',
      },
      widgets: {
        manageWidgets: 'Upravljanje Widgetima',
        widgetsAreRoutingTools: 'Widgeti su alati za usmjeravanje kako bi se povećala upotreba bota',
        needHelp: 'Trebaš Pomoć?',
        wantToMakeChanges: 'Želite napraviti promjene?',
        editIcon: 'Uredi Ikonicu',
        discard: 'Odbaci',
        updateWidget: 'Ažuriraj Widget',
        installChatBotIconOnYourWebsite: 'Instalirajte ikonu razgovarača na svoju web stranicu',
        shareWhereEverYouWantRedirectUsersTo: 'Dijelite gdje god želite i preusmjeravajte korisnike na svoj Telegram bot u jednom kliku',
        copyAndAddInYourWebsiteHeaderFile: 'Kopirajte i dodajte u zaglavlje vaše web stranice',
        copyLinkAndStartSharing: 'Kopirajte link i počnite dijeliti!',
        downloadQrCodeAndStartSharing: 'Preuzmite QR kod i počnite dijeliti!',
        addCodeAndDeployNewCodeAndDone: 'Dodajte kod, implementirajte novi kod i gotovi ste!',
        wantToLearnHowToUseIt: 'Želite naučiti kako to koristiti?',
        copyChatBotCode: 'Kopiraj Kod Razgovarača',
        downloadQrCode: 'Preuzmi QR Kod',
        copyTelegramLink: 'Kopiraj Telegram Link',
        link: 'Link',
        chatBotIcon: 'Ikonica Razgovarača',
        qrcode: 'QR Kod',
        small: 'Malo',
        medium: 'Srednje',
        large: 'Veliko',
        leftMiddle: 'Lijevo-Srednje',
        rightMiddle: 'Desno-Srednje',
        leftBottom: 'Lijevo-Dolje',
        rightBottom: 'Desno-Dolje',
        bpDropDown: {
          selectIcons: 'Odaberi Ikone',
          iconSize: 'Veličina Ikone',
          iconPlacement: 'Postavljanje Ikone',
        }
      },
      generalSetting: {
        sendInactivityMessage: 'Poruka o neaktivnosti korisnika',
        sessionTimeOutInHours: 'Vrijeme isteka sesije',
        enterSessionTimeOutWindowInHours: 'Unesite prozor za istek sesije u satima',
        sessionTimeOutInHoursTooltip: `Unesite trajanje nakon kojeg će se razgovor automatski prekinuti
           zbog neaktivnosti. Razgovor će se ponovno pokrenuti ako korisnik pošalje bilo koju poruku nakon isteka sesije`,
        restartChatFlowTriggers: 'Pokretači za ponovno pokretanje razgovora',
        enterKeyWordsToRestartChatAndhitEnter: 'Unesite ključne riječi za ponovno pokretanje razgovora i pritisnite Enter',
        restartChatFlowTriggersTooltip: `Ovdje navedite ključne riječi koje će, kada ih korisnik unese i pošalje, pokrenuti ponovno pokretanje razgovora. To omogućuje korisnicima ponovno pokretanje tijeka razgovora u bilo kojem trenutku.
          Pritisnite Enter nakon dodavanja svake ključne riječi kako biste dodali više ključnih riječi.`,
        liveChatTriggers: 'Pokretači za uživo razgovor',
        enterKeyWordsToTriggerLiveChatAndhitEnter: 'Unesite ključne riječi za pokretanje uživo razgovora i pritisnite Enter',
        liveChatTriggersTooltip: `Definirajte ključne riječi koje će, kada ih korisnik unese i pošalje, pokrenuti prijelaz između automatiziranog razgovora i razgovora uživo. Korisno je kada korisnici trebaju pomoć od stvarnog agenta.
          Pritisnite Enter nakon dodavanja svake ključne riječi kako biste dodali više ključnih riječi.`,
        messageAfterAutomatedFlowCompleted: 'Poruka nakon završetka automatiziranog toka',
        enterYourMessage: 'Unesite svoju poruku',
        messageAfterAutomatedFlowCompletedTooltip: `Unesite poruku koja će se prikazati korisniku nakon što završi automatizirani
          razgovor, ali sesija još nije istekla.`,
        restart: 'Ponovno pokreni',
        liveChat: 'Uživo razgovor',
        lineOneForDefaultMessage: 'Ako imate još pitanja ili trebate pomoć, evo što možete učiniti sljedeće:',
        to: 'Do',
        restartTheChat: 'ponovno pokreni razgovor',
        simpleTypeRestartAndHitEnter: `jednostavno unesite 'Restart' i pritisnite Enter. To će vas vratiti na početak našeg razgovornog toka.`,
        lineThreeForDefaultMessagePartOne: `Ako želite razgovarati s`,
        liveAgent: `stvarnim agentom,`,
        lineThreeForDefaultMessageLastPart: `unesite 'Uživo razgovor' i pritisnite Enter. Naš tim je ovdje da vam pomogne u stvarnom vremenu.`,
        saveChanges: 'Spremi promjene',
        discard: 'Odbaci',
        configureBotsGeneralSettings: `Postavite opće postavke vašeg bota`,
        minutes: 'Minute',
        hours: 'Sati',
      }
    },
    whatsapp: {
      whatsappAutomation: 'WhatsApp Automatizacija',
      whatsappBotSettings: 'WhatsApp Bot Postavke',
      generalHeader: 'Općenito',
      chatFlowsHeader: 'Razgovorni Tokovi',
      whatsappProfileHeader: 'WhatsApp Profil',
      broadcastHeader: 'Emitiranje',
      dripCampaignHeader: 'Drip Kampanja',
      widgetHeader: 'Widget',
      templatesHeader: 'Predlošci',
      alertsHeader: 'Upozorenja',
      apiKeyHeader: 'API Ključ',
      catalogHeader: 'Katalog',
      otherConfiguration: 'AI Postavke',
      appTooltip: {
        TOOLTIP_CHAT_FLOW_TITLE: 'Prilagodite predloške razgovora i stvarajte različite razgovorne tokove za različite ciljne skupine.',
      },
      alerts: {
        configureYourBotsAlertSettings: 'Konfigurirajte postavke upozorenja svog bota',
        specifyHowYouBotWillNotify: 'Navedite kako će vaš bot obavijestiti o novim potencijalnim kupcima.',
        subject: 'Predmet',
        emailNotification: 'Obavijest e-poštom',
        emailAddresses: 'E-mail adrese',
        leadRevisitNotifications: 'Obavijesti o povratku potencijalnih kupaca',
        whenToSendLeadInfo: 'Kada poslati informacije o potencijalnom kupcu',
        discard: 'Odbaci',
        saveChanges: 'Spremi promjene',
        seeHowToUse: 'Pogledajte kako koristiti',
        beginningTheFlow: 'Početak toka',
        fiveMinutesLater: '5 minuta kasnije',
        endOfFlow: 'Kraj toka',
        placeholders: {
          enterSubjectForYourEmail: 'Unesite predmet svoje e-pošte',
          typeEmailAndHitEnter: 'Unesite svoju e-mail adresu i pritisnite Enter',
        },
        appTooltip: {
          TOOLTIP_SUBJECTS: 'Prilagodite predmet svojih obavijesti e-poštom iz bota',
          TOOLTIP_EMAIL_NOTIFICATION: 'Omogućite/onemogućite obavijest bota na svojoj e-pošti za nove potencijalne kupce',
          TOOLTIP_EMAIL_ADDRESS: 'Unesite e-mail adresu računa na koju želite primati obavijesti e-poštom. Možete dodati više e-mail adresa tako da unesete jednu i pritisnete Enter za dodavanje druge.',
          TOOLTIP_LEAD_REVISIT_NOTIFICATION: 'Omogućite/onemogućite obavijest bota putem e-pošte ako se korisnik koji je već zabilježen kao potencijalni kupac ponovno interagira s botom.',
        }
      },
      editProfile: {
        updateWhatsappChatBot: 'Ažurirajte WhatsApp Chatbota',
        businessNameIsRequired: 'Naziv tvrtke je obavezan.',
        maxLengthForBusinessName40Characters: 'Maksimalna duljina naziva tvrtke je 40 znakova.',
        categoryIsRequired: 'Kategorija je obavezna.',
        descriptionIsRequired: 'Opis je obavezan.',
        maxLengthForDescription200Characters: 'Maksimalna duljina opisa je 200 znakova.',
        aboutIsRequired: 'O tvrtki je obavezno.',
        maxLengthForAbout139Characters: 'Maksimalna duljina "O tvrtki" je 139 znakova.',
        pleaseFillAValidBusinessEmail: 'Molimo vas da unesete valjanu poslovnu e-mail adresu.',
        businessEmailIsRequired: 'Poslovni e-mail je obavezan.',
        websiteIsRequired: 'Web stranica je obavezna.',
        maxLengthForWebsite40Characters: 'Maksimalna duljina web stranice je 40 znakova.',
        maxLengthForAddress150Characters: 'Maksimalna duljina adrese je 150 znakova.',
        cancel: 'Odbaci',
        update: 'Ažuriraj',
        businessCategory: 'Kategorija tvrtke',
        placeholders: {
          yourBusinessName: 'Naziv vaše tvrtke',
          businessDescription: 'Opis tvrtke',
          about: 'O tvrtki',
          businessEmail: 'Poslovna e-mail adresa',
          website: 'Web stranica (npr. www.primjer.com)',
          address: 'Adresa',
        }
      },
      flows: {
        chatFlows: 'Razgovorni Tokovi',
        createChatFlow: 'Stvori Razgovorni Tok',
        youCanCreateMultipleChatFlows: 'Možete stvoriti više razgovornih tokova za A/B testiranje i emitiranje.',
        flowName: 'Naziv toka',
        nameIsRequired: 'Naziv je obavezan',
        cancel: 'Odbaci',
        createFlow: 'Stvori Tok',
        importFlow: 'Uvezi Tok',
        createNewFlow: 'Stvori Novi Tok',
        ofMessages: ' od poruka',
        createdOn: 'Stvoreno na',
        lastModified: 'Zadnje izmijenjeno',
        defaultFlow: 'Zadani tok',
        revisitFlow: 'Ponovni pregled toka',
        action: 'Akcija',
        exportStatus: 'Status izvoza',
        flowExport: 'Izvoz toka',
        beforeYouStartUploadPleaseMakeSure: 'Prije nego počnete s prijenosom, pobrinite se',
        point1: '1. Maksimalno ograničenje veličine datoteke za prijenos iznosi 20 MB',
        point2: '2. Format datoteke mora biti JSON',
        selectFile: 'Odaberi Datoteku',
        seeHowToUse: 'Pogledajte kako koristiti',
        download: 'Preuzmi',
        available: 'Dostupno',
        initiated: 'Pokrenuto',
        inProgress: 'u tijeku',
        placeholders: {
          enterFlowName: 'Unesite naziv toka',
        },
        appTooltip: {
          importFlowForWhatsappBot: 'Uvoz toka za WhatsApp bota',
          dateAndTimeOfCreationOfChatFlow: 'Datum i vrijeme stvaranja razgovornog toka',
          dateAndTimeWhenChatFlowLastModified: 'Datum i vrijeme zadnje izmjene razgovornog toka',
          TOOLTIP_CREATE_FLOW: 'Kliknite da biste stvorili novi razgovorni tok',
          TOOLTIP_FLOW_NAME: 'Unesite naziv razgovornog toka',
          TOOLTIP_FLOW_TABLE_NAME: 'Naziv razgovornog toka',
          TOOLTIP_NO_OF_MESSAGES: 'Broj komponenata poruka u razgovornom toku',
          TOOLTIP_DEFAULT_FLOW: 'Koristite ovu prekidač da biste postavili razgovorni tok kao zadani, koji će se pružiti svim novim korisnicima.',
          TOOLTIP_REVISIT_FLOW: 'Koristite ovu prekidač da biste odabrali razgovorni tok koji će se pružiti korisnicima kada ponovno posjete vašeg bota.',
          TOOLTIP_ACTION: 'Uređivanje ili brisanje razgovornog toka',
        },
        modal: {
          deleteFlow: 'Izbriši Tok',
          wantToDeleteThisFlow: 'Jeste li sigurni da želite izbrisati ovaj tok?',
        },
        noDataFound: {
          flows: 'Tokovi',
          noFlowsAddedYet: 'Još nisu dodani tokovi!',
        }
      },
      input: {
        manageTemplates: 'Upravljajte Predlošcima',
        manageYourTemplatesForMarketingAutomation: 'Upravljajte svojim predlošcima za marketinšku automatizaciju',
        syncTemplates: 'Sinkronizirajte Predloške',
        createTemplateHeader: 'Stvori Predložak',
        title: 'Naslov',
        info: 'Informacije',
        category: 'Kategorija',
        status: 'Status',
        action: 'Akcija',
        shipmentUpdate: 'Ažuriranje isporuke',
        name: 'Ime',
        headerOptional: 'Zaglavlje (neobavezno)',
        bodyRequired: 'Tijelo (obavezno)',
        footerOptional: 'Podnožje (neobavezno)',
        buttonsOptional: 'Gumbi (neobavezno)',
        makeUpto3Buttons: 'Napravite do 3 gumba',
        makeUpto2ButtonsToRedirect: 'Napravite do 2 gumba za preusmjeravanje kupca na vašu web stranicu',
        placeholders: {
          nameYourTemplate: 'Nazovite svoj predložak (koristite donju crtu za odvajanje riječi)',
          enterText: 'Unesite tekst (maksimalno 60 znakova)',
          enterImageUrl: 'Unesite URL slike',
          enterVideoUrl: 'Unesite URL videozapisa',
          templateMessage: 'Predložak poruke',
          smallFooterAtBottom: 'Malo podnožje na dnu',
          buttons: 'Gumbi',
          text: 'Tekst',
          numberWithCountryCode: 'Broj s pozivnim brojem države',
          enterButtonText: 'Unesite tekst gumba (maksimalno 20 znakova)',
        },
        appTooltip: {
          TOOLTIP_INPUT_TABLE_TITLE: 'Naslov WhatsApp predloška',
          TOOLTIP_INPUT_TABLE_INFO: 'Detaljni podaci o poslovnim iniciranim porukama',
          TOOLTIP_INPUT_TABLE_CATEGORY: 'Vrsta poslovnih iniciranih poruka poput sastanaka, podsjetnika, poruka korisničke skrbi, ažuriranja o dostavi, upozorenja i drugih',
          TOOLTIP_INPUT_TABLE_STATUS: 'Status predloška odobrenja ili odbijanja od strane WhatsAppa. WhatsApp predlošci prvo moraju biti odobreni od strane WhatsAppa, a to je plaćena usluga.',
          TOOLTIP_INPUT_TABLE_ACTIONS: 'Izbriši predložak',
        },
        noDataFound: {
          templates: 'Predlošci',
          noTemplatesCreatedYet: 'Nema još stvorenih predložaka!',
        },
        modal: {
          deleteTemplate: 'Izbriši Predložak',
          wantToDeleteThisTemplate: 'Jeste li sigurni da želite izbrisati ovaj predložak?',
        },
        createTemplate: {
          createTemplates: 'Stvaranje predložaka',
          createTemplatesForMarketingAutomation: 'Stvorite svoje predloške za marketinšku automatizaciju',
          templateMeta: 'Meta predložak',
          selectLanguage: 'Odaberi jezik',
          header: 'Zaglavlje',
          optional: 'Opcionalno',
          samplesForHeaderContent: 'Primjeri sadržaja zaglavlja',
          toHelpMetaReviewYourContent: 'Kako biste pomogli meta pregledu vašeg sadržaja, navedite primjere varijabli ili medija u zaglavlju. Nemojte uključivati nikakve informacije o korisnicima.',
          body: 'Tijelo',
          addVariable: 'Dodaj varijablu',
          samplesForBodyContent: 'Primjeri sadržaja tijela',
          toHelpUsReviewYourContent: 'Kako biste nam pomogli pregledati vaš sadržaj, navedite primjere varijabli u tijelu. Nemojte uključivati nikakve informacije o korisnicima.',
          footer: 'Podnožje',
          // optional: 'Opcionalno',
          buttons: 'Gumbi',
          // optional: 'Opcionalno',
          typeOfAction: 'Vrsta akcije',
          call: 'Poziv',
          phone: 'Telefon',
          website: 'Web stranica',
          static: 'Statički',
          urlType: 'Vrsta URL-a',
          type: 'Vrsta',
          customButton: 'Prilagođeni gumb',
          addAnotherButton: 'Dodaj još jedan gumb',
          preview: 'Pregled',
          test: 'Test',
          create: 'Stvori',
          addSampleUrl: 'Dodaj primjer URL-a',
          toHelpMetaReviewYourMessage: 'Kako biste pomogli meta pregledu vašeg predloška poruke, dodajte primjer URL-a web stranice. Nemojte koristiti stvarne informacije o korisnicima.',
          placeholders: {
            enterMessageTemplateName: 'Unesite naziv predloška poruke',
            searchTemplateByName: 'Pretraži predložak po imenu',
            selectTemplate: 'Odaberi predložak',
            enterText: 'Unesite tekst',
            enterBody: 'Unesite tijelo',
            enterContentForVariable: 'Unesite sadržaj za varijablu',
            enterFooter: 'Unesite podnožje',
            phone: 'Telefon*',
            enterWebsiteUrl: 'Unesite URL web stranice',
          },
          bpInput: {
            name: 'Ime',
            buttonText: 'Tekst gumba',
            websiteUrl: 'URL web stranice',
          },
          bpDropDown: {
            selectCategory: 'Odaberi kategoriju',
          }
        },
        templatePreview: {
          preview: 'Pregled',
          test: 'Test',
        },
        templateConfig: {
          saveChanges: 'Spremi promjene',
          discard: 'Odbaci',
          triggerChatFlowOnTemplateReply: 'Pokreni razgovor na odgovoru predloška',
          templateDetails: 'Detalji predloška',
          configureFlows: 'Konfiguriraj tokove',
          selectFlow: 'Odaberi tok',
          name: 'Ime'
        }
      },
      shopManagement: {
        shopManagement: 'Upravljanje trgovinom',
        manageECommerceShopFromBotPenguin: 'Upravljajte e-trgovinama povezanim s BotPenguinom',
        comingSoon: '(Uskoro)',
        wooCommerce: {
          createConfiguration: 'Stvori konfiguraciju',
          eventConfiguration: {
            createConfiguration: 'Stvori konfiguraciju',
            templateHeader: 'Zaglavlje predloška',
            selectFile: 'Odaberi datoteku',
            templateMessage: 'Poruka predloška',
            saveChanges: 'Spremi promjene',
            bpDropDown: {
              selectEvent: 'Odaberi događaj',
              selectTemplate: 'Odaberi predložak',
            }
          }
        }
      },
      whatsappProfile: {
        whatsappProfile: 'WhatsApp profil',
        manageYourBotProfile: 'Upravljajte svojim Bot profilom kad god želite.',
        allSetNoActionRequired: 'Sve je postavljeno, nema potrebne radnje!',
        congratulationsYourAccountIsLive: 'Čestitamo! Vaš račun je aktivan s potpunim pristupom',
        somethingIsWrongReactivateYourBot: 'Nešto nije u redu, ponovno aktivirajte svog bota!',
        itSeemsLikeYourBotIsNotWorkingProperly: 'Čini se da vaš bot ne radi ispravno. Poništite postavke svog bota.',
        reConfigureYourBot: 'Ponovno konfigurirajte svog bota',
        phoneNumberDetails: 'Detalji broja telefona',
        phoneNumber: 'Broj telefona',
        nA: 'N/A',
        phoneNumberId: 'ID broja telefona',
        wabaId: 'WABA ID',
        change: 'Promijeni',
        accessToken: 'Pristupni token',
        messagingLimit: 'Limit poruka',
        qualityRating: 'Ocjena kvalitete',
        whatsappBusinessAccountName: 'Naziv WhatsApp poslovnog računa',
        whatsappPublicProfile: 'Javni WhatsApp profil',
        profilePicture: 'Profilna slika',
        aboutText: 'Tekst o sebi',
        address: 'Adresa',
        description: 'Opis',
        email: 'Email',
        websitePrimary: 'Web stranica (Primarna)',
        websiteSecondary: 'Web stranica (Sekundarna)',
        businessVertical: 'Poslovna vertikala',
        editProfile: 'Uredi profil',
        thisIsABusinessAccount: 'Ovo je poslovni račun',
        aboutAndPhoneNumber: 'O nama i broj telefona',
        yourTrialAccountIsLive: 'Čestitamo! Vaš probni račun je aktivan s potpunim pristupom na vašem verificiranom broju',
        updateWithNewAccessToken: 'Ažurirajte s novim pristupnim tokenom',
      },
      widgets: {
        manageWidgets: 'Upravljanje widgetima',
        widgetsAreRoutingTools: 'Widgeti su alati za usmjeravanje kako bi se povećala upotreba bota',
        needHelp: 'Trebate pomoć?',
        wantToMakeChanges: 'Želite napraviti promjene?',
        prePopulatedMessage: 'Prethodno popunjena poruka',
        discard: 'Odbaci',
        updateWidget: 'Ažuriraj widget',
        hiThere: 'Bok, ovdje ',
        seeHowToUse: 'Pogledajte kako koristiti',
        editIcon: 'Uredi ikonu',
        editPrePopulatedMessage: 'Uredi prethodno popunjenu poruku',
        small: 'Mala',
        medium: 'Srednja',
        large: 'Velika',
        leftMiddle: 'Lijevo-sredina',
        rightMiddle: 'Desno-sredina',
        leftBottom: 'Lijevo-dolje',
        rightBottom: 'Desno-dolje',
        chatBotIcon: 'Ikona bota za razgovor',
        link: 'Link',
        qrcode: 'QR kod',
        copyChatBotCode: 'Kopirajte kod bota za razgovor',
        copyWALink: 'Kopirajte WA link',
        downloadQrCode: 'Preuzmite QR kod',
        installChatBotIconOnYourWebsite: 'Instalirajte ikonu bota za razgovor na svoju web stranicu',
        shareWhereEverYouWantRedirectUsersTo: 'Dijelite gdje god želite i preusmjerite korisnike na svoj WhatsApp bot jednim klikom',
        copyAndAddInYourWebsiteHeaderFile: 'Kopirajte i dodajte u zaglavlje datoteke svoje web stranice',
        copyLinkAndStartSharing: 'Kopirajte link i počnite dijeliti!',
        downloadQrCodeAndStartSharing: 'Preuzmite QR kod i počnite dijeliti!',
        addCodeAndDeployNewCodeAndDone: 'Dodajte kod, implementirajte novi kod i gotovi ste!',
        wantToLearnHowToUseIt: 'Želite saznati kako to koristiti?',
        placeholders: {
          enterWhatsappNumber: 'Unesite broj za WhatsApp',
          updateYourMessageHere: 'Ažurirajte svoju poruku ovdje...',
        },
        bpDropDown: {
          selectIcons: 'Odaberi ikone',
          iconSize: 'Veličina ikone',
          iconPlacement: 'Postavljanje ikone',
        },
        bpInput: {
          whatsappNumber: 'Broj WhatsApp-a',
        }
      },
      catalog: {
        createCatalog: 'Stvori katalog',
        createProductCatalogOnTheMetaCommerceManagerOrLinkItWithShopify: 'Stvori katalog proizvoda na Meta Commerce Manageru ili ga poveži sa Shopifyem',
        useYourMetaCommerceManagertoManageCatalogs: 'Koristi svoj Meta Commerce Manager za upravljanje katalozima',
        connectCatalogToWhatsAppAccount: 'Poveži katalog s WhatsApp računom',
        connectYourCatalogsToWhatsAppAccountUsingYourWhatsAppManager: 'Poveži svoje kataloge s WhatsApp računom koristeći svog WhatsApp menadžera',
        useYourMetaWhatsAppManagerToConnectCatalogsAndUsethemWithBotPenguin: 'Koristi svoj Meta WhatsApp Manager za povezivanje kataloga i korištenje s BotPenguinom',
        goToMeta: 'Idi na Meta',
        goToShopify: 'Idi na Shopify',
        next: 'Sljedeće',
        back: 'Natrag',
        setupCatalog: 'Postavi katalog',
        completeAllTheStepsToEnableCatalogMessages: 'Završi sve korake kako bi omogućio poruke kataloga'
      },
      generalSetting: {
        sendInactivityMessage: 'Poruka o neaktivnosti korisnika',
        sessionTimeOutInHours: 'Istek sesije',
        enterSessionTimeOutWindowInHours: 'Unesite trajanje prozora isteka sesije u satima',
        sessionTimeOutInHoursTooltip: `Unesite trajanje nakon kojeg će se chat sesija automatski zatvoriti
           zbog neaktivnosti. Chatflow će se ponovno pokrenuti ako korisnik pošalje bilo koju poruku nakon isteka sesije`,
        restartChatFlowTriggers: 'Pokretači ponovnog pokretanja Chat Flow-a',
        enterKeyWordsToRestartChatAndhitEnter: 'Unesite ključne riječi za ponovno pokretanje chata i pritisnite Enter',
        restartChatFlowTriggersTooltip: `Ovdje odredite ključne riječi koje će, kada ih korisnik unese i pošalje, pokrenuti ponovno pokretanje chat flow-a. To omogućuje korisnicima da ponovno pokrenu tijek razgovora u bilo kojem trenutku.
        Pritisnite Enter nakon dodavanja svake ključne riječi kako biste dodali više ključnih riječi.`,
        liveChatTriggers: 'Pokretači zaživog chata',
        enterKeyWordsToTriggerLiveChatAndhitEnter: 'Unesite ključne riječi za pokretanje live chata i pritisnite Enter',
        liveChatTriggersTooltip: `Definirajte ključne riječi koje će, kada ih korisnik unese i pošalje, pokrenuti prijelaz s automatskog chata na live chat. Korisno je kada korisnici trebaju pomoć od stvarnog
        živog agenta. Pritisnite Enter nakon dodavanja svake ključne riječi kako biste dodali više ključnih riječi.`,
        messageAfterAutomatedFlowCompleted: 'Poruka nakon završetka automatskog toka',
        enterYourMessage: 'Unesite svoju poruku',
        messageAfterAutomatedFlowCompletedTooltip: `Unesite poruku koja će se prikazati korisniku nakon što završi automatski
        tijek razgovora, ali sesija nije istekla.`,
        restart: 'Ponovno pokreni',
        liveChat: 'Live Chat',
        lineOneForDefaultMessage: 'Ako imate još pitanja ili trebate pomoć, evo što možete učiniti:',
        to: 'Do',
        restartTheChat: 'ponovno pokrenuti razgovor',
        simpleTypeRestartAndHitEnter: `jednostavno unesite 'Restart' i pritisnite enter. To će vas vratiti na početak našeg tijeka razgovora.`,
        lineThreeForDefaultMessagePartOne: `Ako želite razgovarati s`,
        liveAgent: `živim agentom,`,
        lineThreeForDefaultMessageLastPart: `unesite 'Live Chat' i pritisnite enter. Naš tim je ovdje da vam pomogne u stvarnom vremenu.`,
        saveChanges: 'Spremi promjene',
        discard: 'Odbaci',
        configureBotsGeneralSettings: `Konfigurirajte opće postavke vašeg bota`,
        minutes: 'Minute',
        hours: 'Sati',
      }
    },
    activateWhatsAppBot: {
      justAStepAway: 'Samo korak dalje',
      seeHowToUse: 'Pogledajte kako koristiti',
      testWhatsAppTrialBot: 'Testirajte svoj WhatsApp probni Chatbot',
      sendMessage: 'Pošaljite poruku',
      sendWhatsAppMessageOn: 'Pošaljite nam WhatsApp poruku na ',
      bySavingInYourContact: 'spremanjem u svoje kontakte i poruka bi trebala početi s ',
      connect: 'Povežite se',
      or: 'ILI',
      scanQRCode: 'Skenirajte QR kod',
      yourPhoneWillOpen: 'Vaš telefon će otvoriti prethodno popunjenu poruku za slanje na naš broj u pješčaniku. Pritisnite "Pošalji" na WhatsAppu',
      sendVerificationCode: 'Pošaljite verifikacijski kod',
      copyAndEnterCode: 'Kopirajte i unesite 6-znamenkasti kod',
      shareWhereYouWant: 'Podijelite gdje god želite i preusmjerite korisnike na svoj WhatsApp bot u jednom kliku',
      youShouldHaveReceived: 'Trebali ste primiti 6-znamenkasti kod na svoj WhatsApp broj',
      EnterYourPhoneNumber: 'Unesite svoj broj telefona',
      send: 'Pošalji',
      sixDigitCode: 'Unesite 6-znamenkasti kod',
      pleaseNote: 'Napomena: Verifikacijski kod od 6 znamenki može potrajati do 3 minute. Pričekajte prije nego što ga ponovno pošaljete.',
      resendVerificationCode: 'Ponovno pošalji verifikacijski kod',
      verify: 'Verificiraj',
      providePhoneNumber: 'Molimo vas da navedete broj koji želite koristiti za testiranje',
      demoBotisReady: 'Sjajno! Vaš demo bot je spreman za upotrebu',
      placeHolder: {
        phone: 'Unesite svoj broj telefona',
        code: 'Unesite verifikacijski kod',
      }
    }
  },
  integrations: {
    thirdPartyAppsIntegration: 'Integracija s aplikacijama trećih strana',
    thirdPartyApps: 'Aplikacije trećih strana',
    customApps: 'Prilagođene aplikacije',
    preview: 'Pregled',
    test: 'Test',
    install: 'Instalacija',
    appTooltip: {
      clickToInstallYourBotToSelectedPlatform: 'Kliknite da instalirate svog bota na odabrane platforme',
      TOOLTIP_MY_INTEGRATION_TITLE: 'Integrirajte svoje prilagođene stvorene aplikacije sa svojim botom',
      TOOLTIP_ALL_INTEGRATION_TITLE: 'Povežite svog bota s dostupnim aplikacijama/CRM-ovima trećih strana',
    },
    allIntegration: {
      list: {
        thirdPartyAppsIntegrations: 'Integracije aplikacija trećih strana',
        integrateYourBotWithListedCrms: 'Integrirajte svog bota s jednim od navedenih aplikacija/CRM-ova.',
        help: 'Pomoć',
        name: 'Ime',
        status: 'Status',
        action: 'Akcija',
        chatGpt: 'ChatGPT',
        addOn: 'Dodatak',
        purchased: 'Kupljeno',
        readyToRideGptWave: 'Spremni za vožnju vala GPT? Integrirajte sada.',
        purchase: 'Kupi',
        notConnected: 'Nije povezano',
        integrated: 'Integrirano',
        configure: 'Konfiguriraj',
        connected: 'Povezano',
        edit: 'Uredi',
        connect: 'Poveži',
        requestYourIntegration: 'Zatražite svoju integraciju',
        toRequestNewIntegration: 'Zahtjev za novu integraciju, unesite niže navedene pojedinosti i javit ćemo vam se.',
        emailId: 'Email ID',
        integrationName: 'Ime integracije',
        contactNumber: 'Broj kontakta',
        howSoonYouWantToAddThisIntegration: 'Koliko brzo želite dodati ovu integraciju',
        sendRequest: 'Pošalji zahtjev',
        cancel: 'Otkaži',
        requestSent: 'Zahtjev poslan!',
        yourRequestSuccessfullySent: 'Vaš zahtjev za novu integraciju uspješno je poslan.',
        goBack: 'Natrag',
        disconnect: 'Odspoji',
        OopsIntegrationAreNotAvailable: 'Ups! Integracije nisu dostupne u ',
        pleaseUpgradeTo: ' Nadogradite na ',
        planForIntegration: ' za integracije.',

        placeholders: {
          searchIntegrationByName: 'Pretraži integraciju po imenu',
          enterTeamMemberName: 'Unesite ime člana tima',
          enterEmailId: 'Unesite Email ID',
          enterIntegrationName: 'Unesite naziv integracije',
          searchCountry: 'Pretraži zemlju',
          enterContactNumber: 'Unesite broj kontakta',
          addComment: 'Dodaj komentar',
        },
        noDataFound: {
          integrations: 'Integracije',
          noIntegrationsFound: 'Nema pronađenih integracija!',
        },
        appTooltip: {
          nameOfAppOrCrm: 'Ime aplikacije/CRM-a',
          statusAsConnectedOrNotConnected: 'Status kao povezano/nije povezano',
          clickToConnectToAppOrCrm: 'Kliknite da se povežete s aplikacijom/CRM-om',
        },
        feedbackModal: {
          submit: 'Pošalji',
        }
      },
      providers: {
        pabbly: {
          newLeadHooks: 'Nove vodilne kukice',
          newMessageHooks: 'Nove kukice za poruke',
          addParameters: '',
          update: 'Ažuriraj',
          connect: 'Poveži',
          botId: 'Bot ID',
          toolTip: {
            copyBotId: `Dohvatite ID bota za besprijekorno integriranje Pabbly-a s ${brand} za automatizaciju radnji na Pabbly-u`
          },
          placeholders: {
            enterYourPabblyWebhookUrl: 'Unesite svoj Pabbly Webhook URL',
          }
        },
        agileCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          agileCrmDomain: 'Agile CRM domena',
          nameIsRequired: 'Ime je obavezno',
          emailAddress: 'Email adresa',
          apiToken: 'API token',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameter: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            exampleSite: 'https://tvrtka.agilecrm.com',
            exampleEmail: 'primjer@tvrtka.ekstenzija',
            enterTokenHere: 'Unesite token ovdje',
          }
        },
        appTivo: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiKey: 'API ključ',
          accessKey: 'Pristupni ključ',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterApiKeyHere: 'Unesite API ključ ovdje',
            enterAccessKeyHere: 'Unesite pristupni ključ ovdje',
          }
        },
        autoPilot: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiToken: 'API token',
          nameIsRequired: 'Ime je obavezno',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterApiToken: 'Unesite API token',
          }
        },
        bitrixCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          nameColon: 'Ime:',
          inboundWebhookUrl: 'Ulazni webhook URL',
          nameIsRequired: 'Ime je obavezno',
          leadTitle: 'Naslov vodstva',
          source: 'Izvor',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterInboundWebhookUrl: 'Unesite URL ulaznog webkuka...',
            enterTitle: 'Unesite naslov',
            enterSource: 'Unesite izvor'
          }
        },
        calendarHeroCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiToken: 'API token',
          connect: 'Poveži',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterTokenHere: 'Unesite token ovdje',
          }
        },
        capsuleCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiToken: 'API token',
          nameIsRequired: 'Ime je obavezno',
          testLead: 'Testiraj vodstvo',
          connect: 'Poveži',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterApiToken: 'Unesite API token',
          }
        },
        chakraCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiToken: 'API token',
          testLead: 'Testiraj vodstvo',
          connect: 'Poveži',
          selectTheQuestion: 'Odaberite pitanje čiji odgovor korisnika želite poslati kao vrijednost',
          mapWith: 'Mapiraj s',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterApiToken: 'Unesite API token',
            attributes: 'Atributi (ključ)',
            values: 'Vrijednosti',
          }
        },
        chatGpt: {
          chatGptApiKey: 'ChatGPT (Open AI) API ključ',
          chatGpt: 'ChatGPT (Open AI)',
          gpt3: 'GPT-3.5 (Niži trošak, Prosječna točnost)',
          gpt4: 'GPT-4 (Viši trošak, Viša točnost)',
          gptAssistant: 'Assistente Beta* (Custu Premium, Precisione Superiore)',
          readyToRideWave: 'Spremni za vožnju GPT vala? Integrirajte odmah.',
          doNotHaveAnyApiKeyNeedHelp: `Nemate API ključ, Trebate pomoć?`,
          authenticate: 'Autenticiraj',
          nowYouCanAccessChatGpt: 'Sada možete pristupiti Chat GPT komponenti u graditelju tijeka razgovora',
          paymentSuccessful: 'Uspješno plaćanje!',
          paymentHasBeenCompletedSuccessfully: 'Plaćanje je uspješno završeno. Sve je spremno za obuku vašeg bota',
          cancel: 'Otkaži',
          trainNow: 'Treniraj sada',
          paymentInProgress: 'Plaćanje u tijeku...',
          apiKey: 'ChatGPT API ključ',
          model: 'Model',
          integrateWithChatGPT: 'Integrirajte s ChatGPT',
          updateKey: 'Ažuriraj ključ',
          connect: 'Poveži',
          update: 'Ažuriraj',
          disconnect: 'Isključi',
          placeholders: {
            chatGptApiKey: 'ChatGPT (Open AI) API ključ',
          }
        },
        closeCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiToken: 'API token',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          leadId: 'ID vodstva',
          selectLeadId: 'Odaberi ID vodstva',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterTokenHere: 'Unesite token ovdje',
          }
        },
        copperCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          emailAddress: 'Email adresa',
          leadTitle: 'Naslov vodstva',
          apiToken: 'API token',
          nameIsRequired: 'Ime je obavezno',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            exampleEmail: 'primjer@tvrtka.ekstenzija',
            enterYourLeadTitle: 'Unesite naslov vodstva',
            enterTokenHere: 'Unesite token ovdje',
          }
        },
        dripCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          dripCrmAccountId: 'Drip CRM ID računa',
          apiToken: 'API token',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterAccountIdHere: 'Unesite ID računa ovdje',
            enterYourTokenHere: 'Unesite svoj token ovdje',
          }
        },
        elevioCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apikey: 'API ključ',
          accessToken: 'Pristupni token',
          connect: 'Poveži',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          selectParameter: 'Odaberi parametar',
          disconnect: 'Isključi',
          update: 'Ažuriraj',
          save: 'Spremi',
          placeholders: {
            enterApiKeyHere: 'Unesite API ključ ovdje',
            enterTokenHere: 'Unesite token ovdje',
          }
        },
        engageBay: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiKey: 'API ključ',
          nameIsRequired: 'Ime je obavezno',
          connect: 'Poveži',
          questionColon: 'Pitanje:',
          testLead: 'Testiraj vodstvo',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterApiToken: 'Unesite API token',
          }
        },
        extraEdge: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          authToken: 'Auth token',
          source: 'Izvor',
          connect: 'Poveži',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterAuthTokenHere: 'Unesite Auth token ovdje',
            enterSourceHere: 'Unesite izvor ovdje'
          }
        },
        facebookPixel: {
          facebookPixel: 'Facebook Pixel',
          getInsight: `Dobijte uvide koji pretvaraju vaš posao u poduzeće pomoću BotPenguin-ove integracije s Google Analyticsom`,
          pixelId: 'Facebook Pixel ID',
          connect: 'Poveži',
          disconnect: 'Isključi',
          placeholders: {
            enterYourId: 'Unesite Facebook Pixel ID'
          }
        },
        firmao: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          companyName: 'Naziv tvrtke',
          emailAddress: 'Email adresa',
          password: 'Lozinka',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapsWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterCompanyName: 'Unesite naziv tvrtke',
            enterEmailAddress: 'Unesite email adresu',
            enterPassword: 'Unesite lozinku',
          }
        },
        firstPromoterCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiKey: 'API ključ',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterApiKeyHere: 'Unesite API ključ ovdje',
          }
        },
        flowlu: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          flowluDomain: 'Flowlu domena',
          apiToken: 'API token',
          title: 'Naslov',
          connect: 'Poveži',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            exampleDomain: 'https://yourcompany.flowlu.com',
            enterTokenHere: 'Unesite token ovdje',
            enterYourLeadTitle: 'Unesite naslov vodstva',
          }
        },
        freshdeskCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          freshdeskDomain: 'Freshdesk domena',
          apiToken: 'API token',
          nameIsRequired: 'Ime je obavezno',
          connect: 'Poveži',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            exampleDomain: 'https://yoursubdomain.freshdesk.com',
            enterTokenHere: 'Unesite token ovdje',
          }
        },
        freshworksCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          freshworkCrmDomain: 'Freshwork CRM domena',
          apiToken: 'API token',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            exampleDomain: 'https://yourcompany.myfreshworks.com',
            enterToken: 'Unesite token ovdje',
          }
        },
        frontApp: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiToken: 'API token',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          mapWith: 'Mapiraj s',
          select: 'Odaberi',
          update: 'Ažuriraj',
          disconnect: 'Isključi',
          placeholders: {
            enterApiToken: 'Unesite API token',
          }
        },
        getResponseCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiKey: 'API ključ',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          campaignList: 'Popis kampanja',
          selectCampaign: 'Odaberi kampanju',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterTokenHere: 'Unesite token ovdje',
          }
        },
        googleAnalytics: {
          googleAnalytics: 'Google Analytics',
          getInsights: `Dobijte uvide koji pretvaraju vaš posao u poduzeće pomoću BotPenguin-ove integracije s Google Analyticsom`,
          measurementId: 'Mjerni ID',
          connect: 'Poveži',
          disconnect: 'Isključi',
          placeholders: {
            enterYourId: 'Unesite svoj ID',
          }
        },
        googleCalendar: {
          testLead: 'Testiraj vodstvo',
          name: 'Ime:',
          email: 'Email:',
          appointmentSummary: 'Sažetak sastanka',
          appointmentDescription: 'Opis sastanka',
          addParameters: 'Dodaj parametre',
          questionColon: 'Pitanje:',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          pause: 'Pauza',
          resume: 'Nastavi',
          disconnect: 'Isključi',
          reconnect: 'Ponovno poveži',
        },
        googleContacts: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          name: 'Ime :',
          email: 'Email : ',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
        },
        googleRedirect: {

        },
        googleSheet: {
          testLead: 'Testiraj vodstvo',
          title: 'Naslov',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          update: 'Ažuriraj',
          save: 'Spremi',
          pause: 'Pauza',
          resume: 'Nastavi',
          disconnect: 'Isključi',
          reconnect: 'Ponovno poveži',
          placeholders: {
            mappingValues: 'Vrijednosti mapiranja',
          }
        },
        googleTask: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          name: 'Ime:',
          email: 'Email:',
          taskList: 'Popis zadataka',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          pause: 'Pauza',
          resume: 'Nastavi',
          disconnect: 'Isključi',
          reconnect: 'Ponovno poveži',
        },
        grooveHq: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiToken: 'API token',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          select: 'Odaberi',
          addParameters: 'Dodaj parametre',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterTokenHere: 'Unesite token ovdje',
          }
        },
        helpCrunchCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiKey: 'API ključ',
          connect: 'Poveži',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Odspoji',
          placeholders: {
            enterApiHere: 'Unesite API ovdje',
          }
        },
        helpDeskCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          testLead: 'Testni lead',
          accountId: 'ID računa',
          accessToken: 'Pristupni token',
          connect: 'Poveži',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Odspoji',
          placeholders: {
            enterAccountIdHere: 'Unesite ID računa ovdje',
            enterAccessTokenHere: 'Unesite pristupni token ovdje',
          }
        },
        helpDocsCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiToken: 'API ključ',
          connect: 'Poveži',
          questionColon: 'Pitanje:',
          testLead: 'Testni lead',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Odspoji',
          placeholders: {
            enterTokenHere: 'Unesite token ovdje',
          }
        },
        helpLink: {
          help: 'Pomoć',
        },
        helpRaceCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          helpRaceCrmDomain: 'Helprace CRM domena',
          emailAddress: 'Adresa e-pošte',
          apiToken: 'API token',
          connect: 'Poveži',
          update: 'Ažuriraj',
          placeholders: {
            exampleDomain: 'https://tvrtka.helprace.com',
            exampleEmail: 'primjer@tvrtka.domena',
            token: 'Token',
          }
        },
        helpShiftCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          domainName: 'Ime domene',
          apiKey: 'API ključ',
          connect: 'Poveži',
          testLead: 'Testni lead',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Odspoji',
          placeholders: {
            enterTokenHere: 'Unesite token ovdje',
          }
        },
        hubspotCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiToken: 'API token',
          nameIsRequired: 'Ime je obavezno',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          selectTheQuestion: 'Odaberite pitanje čiji odgovor korisnika želite poslati kao vrijednost',
          placeholders: {
            enterApiToken: 'Unesite API token',
            values: 'Vrijednosti'
          }
        },
        infobipCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiKey: 'API ključ',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterApiHere: 'Unesite API ovdje',
          }
        },
        insightlyCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiToken: 'API token',
          nameIsRequired: 'Ime je obavezno',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterApiToken: 'Unesite API token',
          }
        },
        jiraCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiToken: 'API token',
          emailAddress: 'Email adresa',
          apiUrl: 'API URL',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          selectProjectName: 'Odaberi naziv projekta',
          selectIssueType: 'Odaberi vrstu pitanja',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapsWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterTokenHere: 'Unesite token ovdje',
            enterEmailAddress: 'Unesite email adresu',
            exampleUrl: 'https://primjer.atlassian.net',
          }
        },
        jogetCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiUrl: 'API URL',
          nameIsRequired: 'Ime je obavezno',
          apiKey: 'API ključ',
          apiId: 'API ID',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          mapWith: 'Mapiraj s',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          selectTheQuestion: 'Odaberite pitanje čiji odgovor korisnika želite poslati kao vrijednost',
          placeholders: {
            enterApiUrl: 'Unesite API URL',
            enterApiKey: 'Unesite API ključ',
            enterApiId: 'Unesite API ID',
            attributes: 'Atributi (ključ)',
            values: 'Vrijednosti',
          }
        },
        karmaCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiKey: 'API ključ',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterTokenHere: 'Unesite token ovdje',
          }
        },
        kylasCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiToken: 'API token',
          nameIsRequired: 'Ime je obavezno',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterApiToken: 'Unesite API token',
          }
        },
        leadSquared: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          accessKey: 'Pristupni ključ',
          secretKey: 'Tajni ključ',
          connect: 'Poveži',
          apiLogs: 'API zapisi',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          udpate: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          filterApplied: 'primijenjeni filtri',
          retry: 'Ponovno pokušaj',
          back: 'Natrag',
          filterYourLeads: 'Filtrirajte svoje vode',
          filterOn: 'Filtriraj na',
          filterBy: 'Filtriraj po ',
          discard: 'Odbaci',
          applyFilter: 'Primijeni filtar',
          loadMore: 'Učitaj više',
          placeholders: {
            enterAccessKeyHere: 'Unesite pristupni ključ ovdje',
            enterSecretKeyHere: 'Unesite tajni ključ ovdje',
            attributes: 'Atributi (ključ)',
            values: 'Vrijednosti',
          },
          appTooltip: {
            filterDataBasedOnResponse: 'Filtriraj podatke prema odgovoru',
          }
        },
        liveAgentCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiKey: 'API ključ',
          apiUrl: 'API URL',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterApiHere: 'Unesite API ovdje',
            exampleUrl: 'https://companyName.ladesk.com'
          }
        },
        microsoftTeams: {
          downloadPackage: 'Preuzmi paket aplikacija za Microsoft Teams',
          downloadApp: 'Preuzmi aplikaciju',
          wantToLearnHowToUploadIt: 'Želite saznati kako je otpremiti?',
          needHelp: 'Treba vam pomoć?',
        },
        moengageUser: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiUrl: 'API URL',
          appId: 'APP ID',
          nameIsRequired: 'APP ID je obvezan',
          dataApiKey: 'DATA API KEY',
          dataApiKeyIsRequired: 'DATA API ključ je obvezan',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          addParameters: 'Dodaj parametre',
          mapWith: 'Mapiraj s',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          selectTheQuestion: 'Odaberite pitanje čiji odgovor korisnika želite poslati kao vrijednost',
          placeholders: {
            enterApiUrl: 'Unesite API URL',
            enterAppId: 'Unesite APP ID',
            enterDataApiKey: 'Unesite DATA API KEY',
            attributes: 'Atributi (ključ)',
            pressForMappingQuestion: 'Pritisnite / za pitanje o mapiranju',
          }
        },
        nethuntCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          emailAddress: 'Email adresa',
          apiKey: 'API ključ',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          leadId: 'Lead ID',
          selectLeadId: 'Odaberite Lead ID',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterEmailHere: 'Unesite email ovdje',
            enterApiKeyHere: 'Unesite API ključ ovdje',
          }
        },
        nimbleCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiKey: 'API ključ',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterApiToken: 'Unesite API token',
          }
        },
        noCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          noCrmDomain: 'Nocrm domena',
          leadTitle: 'Naslov vode',
          titleIsRequired: 'Naslov je obvezan',
          token: 'Token',
          tokenIsRequired: 'Token je obvezan',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            exampleDomain: 'https://YOUR_SUBDOMAIN_HERE.nocrm.io',
            enterYourLeadTitle: 'Unesite naslov vode',
            enterYourToken: 'Unesite svoj token',
          }
        },
        nutshellCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          emailAddress: 'Email adresa',
          apiKey: 'API ključ',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterApiToken: 'Unesite API token',
          }
        },
        onpipelineCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          secretToken: 'Tajni token',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterTokenHere: 'Unesite token ovdje',
          }
        },
        ontraportCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          appId: 'App Id',
          appIdIsRequired: 'App Id je obvezan',
          apiKey: 'API ključ',
          apiKeyIsRequired: 'API ključ je obvezan',
          connect: 'Poveži',
          update: 'Ažuriraj',
          disconnect: 'Isključi',
          placeholders: {
            appId: 'App Id',
            apiKey: 'API ključ',
          }
        },
        outlook: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          clientId: 'Klijentski ID',
          connect: 'Poveži',
          clientSecret: 'Klijentska tajna',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          save: 'Spremi',
          update: 'Ažuriraj',
          disconnect: 'Isključi',
          placeholders: {
            enterClientIdHere: 'Unesite klijentski ID ovdje',
            enterClientSecretHere: 'Unesite klijentsku tajnu ovdje',
          }
        },
        pipedriverCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          pipedriverDomain: 'Pipedriver domena',
          domainIsRequired: 'Domena je obvezna',
          apiToken: 'API token',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            exampleDomain: 'https://yourcompany.pipedrive.com',
            enterTokenHere: 'Unesite token ovdje',
          }
        },
        pipeline: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiKey: 'API ključ',
          apiKeyIsRequired: 'API ključ je obvezan',
          appKey: 'APP ključ',
          appKeyIsRequired: 'APP ključ je obvezan',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterApiKey: 'Unesite API ključ',
            enterAppKey: 'Unesite APP ključ',
          }
        },
        plivoSmsBot: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          authId: 'Auth Id',
          authToken: 'Auth Token',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterTokenHere: 'Unesite token ovdje',
          }
        },
        recurlyCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiKey: 'API ključ',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterApiHere: 'Unesite API ovdje',
          }
        },
        salesfareCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiKey: 'API ključ',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterApiKey: 'Unesite API ključ ovdje',
          }
        },
        salesforce: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          domain: 'Domena',
          clientId: 'Klijentski ID',
          clientSecret: 'Klijentska tajna',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterDomainHere: 'Unesite domenu ovdje',
            enterClientIdHere: 'Unesite klijentski ID ovdje',
            enterClientSecretHere: 'Unesite klijentsku tajnu ovdje',
          }
        },
        sendInBlueCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiKey: 'API ključ',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          addEventsAndTemplates: 'Dodaj događaje i predloške:',
          add: 'Dodaj',
          question: 'Pitanje',
          reply: 'Odgovor',
          requestBody: 'Tijelo zahtjeva',
          validateJson: 'Provjeri ispravnost JSON-a',
          emailAddress: 'Email adresa',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          selectTheQuestion: 'Odaberite pitanje čiji odgovor korisnika želite poslati kao vrijednost',
          placeholders: {
            enterApiHere: 'Unesite API ovdje',
            enterTemplateId: 'Unesite ID predloška',
            typeYourJsonCodeHere: 'Upišite svoj JSON kôd ovdje',
          },
          appTooltip: {
            typeYourJsonCode: 'Upišite svoj JSON kôd',
            clickToValidateJsonCode: 'Kliknite za provjeru ispravnosti JSON koda',
          }
        },
        shipwayCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          userName: 'Korisničko ime',
          licenseKey: 'Ključ licence',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterNameHere: 'Unesite ime ovdje',
            enterKeyHere: 'Unesite ključ ovdje',
          }
        },
        supportBeeCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiToken: 'API token',
          connect: 'Poveži',
          testLead: 'Testni lead',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Odspoji',
          placeholders: {
            enterTokenHere: 'Unesite token ovdje',
          }
        },
        simplybook: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          company: 'Tvrtka',
          loginId: 'ID prijave',
          password: 'Lozinka',
          testLead: 'Testni lead',
          connect: 'Poveži',
          selectTheQuestion: 'Odaberite pitanje čiji odgovor korisnika želite poslati kao vrijednost',
          mapWith: 'Mapiraj s',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Odspoji',
          selectParameter: 'Odaberi parametar',
          placeholders: {
            enterCompanyHere: 'Unesite naziv tvrtke ovdje',
            enterLoginIdHere: 'Unesite ID prijave ovdje',
            enterPasswordHere: 'Unesite lozinku ovdje',
            values: 'vrijednosti',
          }
        },
        twilio: {
          description: 'Pudete aduprà Twilio per fà una chjama di voce',
          accountSid: 'SID di u contu',
          phoneNumber: 'Numeru di telefunu',
          twiMlSid: 'TwiML App Sid',
          apiKey: 'Chiave API ',
          apiSecret: 'Secret API',
          apiUrl: 'Url di l\'app (POST)',
          required: 'necessariu',
          accountSidRequired: 'Account Sid hè ',
          phoneNumberRequired: 'U numeru di telefunu hè ',
          sidRequired: 'TwiML App Sid is ',
          apiKeyRequired: 'Chiave API hè ',
          apiSecretRequired: 'API Secret hè ',
          update: 'Aggiornamentu',
          connect: 'Connect',
          disconnect: 'Odspoji',
        },
        teamGate: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          applicationKey: 'Ključ aplikacije',
          authToken: 'Auth Token',
          connect: 'Poveži',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Odspoji',
          placeholders: {
            enterApplicationKeyHere: 'Unesite ključ aplikacije ovdje',
            enterTokenHere: 'Unesite token ovdje',
          }
        },
        wealthboxCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          accessToken: 'Pristupni token',
          connect: 'Poveži',
          testLead: 'Testni lead',
          question: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Odspoji',
          placeholders: {
            enterTokenHere: 'Unesite token ovdje',
          }
        },
        webhopersCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          webhoperDomain: 'Webhoper domena',
          domainIsRequired: 'Domena je obavezna',
          companyName: 'Naziv tvrtke',
          companyIsRequired: 'Tvrtka je obavezna',
          leadSource: 'Izvor potencijalnih klijenata',
          leadSourceIsRequired: 'Izvor potencijalnih klijenata je obavezan',
          division: 'Podjela',
          divisionIsRequired: 'Podjela je obavezna',
          enterPassword: 'Unesite lozinku',
          passwordIsRequired: 'Lozinka je obavezna',
          disconnect: 'Odspoji',
          update: 'Ažuriraj',
          connect: 'Poveži',
          placeholders: {
            exampleDomain: 'http://tvrtkina-domena',
            enterYourCompanyName: 'Unesite naziv svoje tvrtke',
            enterLeadSource: 'Unesite izvor potencijalnih klijenata',
            enterDivision: 'Unesite podjelu',
            enterPassword: 'Unesite lozinku',
          }
        },
        zapierCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          name: 'Ime:',
          zapier: 'Zapier',
          inboundWebhookUrl: 'URL dolaznog web-kuka',
          connect: 'Poveži',
          testLead: 'Testni lead',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Odspoji',
          placeholders: {
            enterWebhookUrl: 'Unesite URL web-kuka',
          }
        },
        zendeskCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiToken: 'API token',
          emailAddress: 'Adresa e-pošte',
          apiUrl: 'API URL',
          connect: 'Poveži',
          testLead: 'Testni lead',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Odspoji',
          placeholders: {
            enterEmailAddress: 'Unesite adresu e-pošte',
            enterUrlHere: 'Unesite URL ovdje',
            enterTokenHere: 'Unesite token ovdje',
          }
        },
        zingtreeCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiKey: 'API ključ',
          connect: 'Poveži',
          testLead: 'Testni lead',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Odspoji',
          placeholders: {
            enterApiHere: 'Unesite API ovdje',
          }
        },
        zohoCrm: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          connect: 'Poveži',
          update: 'Ažuriraj',
          disconnect: 'Odspoji',
          companyName: 'Naziv tvrtke',
          emailAddress: 'Adresa e-pošte',
          phone: 'Telefon',
          countryCode: 'Pozivni broj države',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          save: 'Spremi',
          testLead: 'Testni lead',
          crmExtensionUrl: 'URL CRM proširenja',
          installExtension: 'Instaliraj proširenje',
          toolTip: {
            crmExtensionUrl: 'Pokrenite ovaj URL kako biste dodali Zoho proširenje i slali poruke voditeljima preko WhatsApp-a iz Zoho CRM-a.'
          }
        },
        zohoDesk: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          connect: 'Poveži',
          disconnect: 'Odspoji',
          testLead: 'Testni lead',
          emailAddress: 'Adresa e-pošte',
          selectOrganizationName: 'Odaberite naziv organizacije',
          selectDepartmentName: 'Odaberite naziv odjela',
          addParameters: 'Dodaj parametre',
          questionColon: 'Pitanje:',
          select: 'Odaberi',
          mapsWith: 'Mapira s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
        },
        zohoProject: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          testLead: 'Testni lead',
          connect: 'Poveži',
          disconnect: 'Odspoji',
          projectsList: 'Popis projekata',
          selectProjectsName: 'Odaberite naziv projekta',
          projectsTaskList: 'Popis zadatka projekta',
          selectTaskListName: 'Odaberite naziv popisa zadataka',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
        },
        wooCommerce: {
          configure: 'Konfiguriraj',
          automatedMessage: 'Automatska poruka',
          configureTab: {
            wooCommercePluginApiKey: 'WooCommerce API ključ dodatka',
            downloadWooCommercePlugin: 'Preuzmi dodatak WooCommerce'
          },
          automatedMessageTab: {
            abandonedRecoveryMessage: 'Poruka oporavka napuštenih košarica',
            configureAutomatedRecoveryMessagesToWinBackCustomerWhoAbandonedTheirCarts: 'Konfigurirajte automatske poruke oporavka kako biste privukli natrag kupce koji su napustili svoje košarice',
            enableAbandonedCartRecoveryMessaegs: 'Omogući poruke oporavka napuštenih košarica',
            selectTemplate: 'Odaberi predložak',
            sendMessageAfter: 'Pošalji poruku nakon',
            templateMessage: 'Poruka predloška',
            saveChanges: 'Spremi promjene',
            selectFile: 'Odaberi datoteku',
            orderCompleted: 'Naručeno završeno',
            templateHeader: 'Zaglavlje predloška',
            orderFulfillMent: 'Ispunjenje narudžbe',
            enableOrderConfirmationMessages: 'Omogući poruke potvrde narudžbe',
            sendAnOrderConfirmationMessageAsSoonAsACustomerPlacesAnOrder: 'Pošaljite poruku potvrde narudžbe čim kupac naruči proizvod.',
            orderShipmentMessageIsSentWhenYouFulfillAnOrder: 'Poruka o isporuci narudžbe šalje se kada ispunite narudžbu.',
            enableOrderFulfillmentMessages: 'Omogući poruke o ispunjenju narudžbe',
            returnExchangeRequest: 'Zahtjev za povrat/razmjenu',
            theMessageIsSentAfterARefundIsRequested: 'Poruka se šalje nakon što je zatražen povrat sredstava',
            enableOrderRefundMessages: 'Omogući poruke o povratu sredstava za narudžbu',
          }
        },
        shopify: {
          configure: 'Konfiguriraj',
          automatedMessage: 'Automatska poruka',
          configureTab: {
            enterYourShopifyDomain: 'Unesite svoj Shopify domen',
            disconnect: 'Isključi',
            integrated: 'Integrirano',
            install: 'Instaliraj',
          },
          automatedMessageTab: {
            shopifyAutomatedMessage: 'Automatizirana poruka Shopify-a',
            viewYourCashOnDeliveryInsights: 'Pogledajte svoje podatke o plaćanju pouzećem.',
            noTemplateFound: 'Nije pronađen predložak',
            hours: 'Sati',
            minutes: 'Minute',
            saveChanges: 'Spremi promjene',
            selectTemplate: 'Odaberi predložak',
            templateMessage: 'Predložak poruke',
            selectFile: 'Odaberi datoteku',
            templateHeader: 'Zaglavlje predloška',
            sendMessageAfter: 'Pošalji poruku nakon',
            select: 'Odaberi',
            abandonedCartRecovery: 'Obnova napuštenih košarica',
            abandonedCartDescription: 'Obavijestite korisnike o napuštenim košaricama za daljnje praćenje putem WhatsApp razgovora.',
            enableAbandonedCartRecoveryMessages: 'Omogući poruke obnove napuštenih košarica',
            orderCreated: 'Kreirana narudžba',
            orderCreatedDescription: 'Pošaljite korisnicima trenutna upozorenja o njihovim novim narudžbama.',
            enableOrderCreatedMessages: 'Omogući poruke o kreiranju narudžbe',
            codOrderTracking: 'Pratnja narudžbi s plaćanjem pouzećem',
            codOrderTrackingDescription: 'Dajte poveznicu za praćenje u WhatsApp razgovoru kako biste omogućili korisnicima praćenje narudžbi s plaćanjem pouzećem u stvarnom vremenu.',
            enableCodOrderTrackingMessages: 'Omogući poruke praćenja narudžbi s plaćanjem pouzećem',
            orderFulfilled: 'Ispunjena narudžba',
            orderFulfilledDescription: 'Pošaljite obavijesti kupcima o uspješnom ispunjenju narudžbe.',
            enableOrderFulfilledMessages: 'Omogući poruke o ispunjenju narudžbe',
            orderCancelled: 'Otkazana narudžba',
            orderCancelledDescription: 'Prikažite i potvrdite otkazane narudžbe učinkovito putem WhatsApp-a.',
            enableOrderCancelledMessages: 'Omogući poruke o otkazanoj narudžbi',
            orderReturnRequestPlaced: 'Postavljena zahtjev za povrat narudžbe',
            orderReturnRequestPlacedDescription: 'Obavijestite kupce kada postave zahtjev za povrat na vašoj Shopify trgovini.',
            enableOrderReturnRequestPlacedMessages: 'Omogući poruke o postavljanju zahtjeva za povrat narudžbe',
            orderReturned: 'Vraćena narudžba (refundirana)',
            orderReturnedDescription: 'Pošaljite ažuriranja kupcima kada se njihova narudžba za povrat ispuni.',
            enableOrderRefundMessages: 'Omogući poruke o povratu novca za narudžbu',
          }
        },
        goHighLevel: {
          youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
          apiToken: 'API token',
          nameIsRequired: 'Ime je obavezno',
          connect: 'Poveži',
          testLead: 'Testiraj vodstvo',
          questionColon: 'Pitanje:',
          addParameters: 'Dodaj parametre',
          select: 'Odaberi',
          mapWith: 'Mapiraj s',
          selectParameter: 'Odaberi parametar',
          update: 'Ažuriraj',
          save: 'Spremi',
          disconnect: 'Isključi',
          placeholders: {
            enterApiToken: 'Unesite API token ovdje',
          }
        }
      }
    },
    createIntegration: {
      createNewIntegration: 'Stvorite novu integraciju',
      youDoNotHaveAnyIntegrationSetupAsOfNow: 'Trenutačno nemate postavljenu nijednu integraciju.',
      pleaseCreateOneToIntegrateYourFavourite: 'Molimo stvorite jednu kako biste integrirali svoje omiljene',
      appsWith: 'aplikacije s',
      integrationName: 'Naziv integracije',
      integrationNameIsRequired: 'Naziv integracije je obavezan',
      continue: 'Nastavi',
      addAnImageToRepresentYourIntegration: 'Dodajte sliku koja će predstavljati vašu integraciju.',
      description: 'Opis',
      submit: 'Pošalji',
      youHaveSuccessfullyCreatedIntegration: `Uspješno ste stvorili integraciju. Sada je možete konfigurirati.`,
      apiUrl: 'API URL',
      pleaseEnterAValidApiUrl: 'Unesite valjanu API URL adresu',
      requestMethod: 'Način zahtjeva',
      get: 'Dohvati',
      post: 'Pošalji',
      put: 'Postavi',
      patch: 'Patch',
      queryParameter: 'Upitni parametar',
      addParameter: 'Dodaj parametar',
      mapsWith: 'mapira s',
      question: 'Pitanje',
      addQuestion: 'Dodaj pitanje',
      select: 'Odaberi',
      selectParameter: 'Odaberi parametar',
      header: 'Zaglavlje',
      addHeader: 'Dodaj zaglavlje',
      value: 'Vrijednost',
      connect: 'Poveži',
      requestBody: 'Tijelo zahtjeva',
      validate: 'Provjera valjanosti',
      key: 'Ključ',
    },
    myIntegrations: {
      integrationDetails: {
        canAlsoBeIntegratedWith: ' se također može integrirati s ovim besplatnim CRM-om.',
        apiUrl: 'API URL',
        pleaseEnterAValidApiUrl: 'Unesite valjanu API URL adresu',
        requestMethod: 'Metoda zahtjeva:',
        get: 'Dohvati',
        post: 'Pošalji',
        put: 'Stavi',
        patch: 'Popravi',
        queryParameter: 'Parametar upita',
        addParameter: ' Dodaj parametar',
        header: 'Zaglavlje',
        addHeader: ' Dodaj zaglavlje',
        requestBody: 'Tijelo zahtjeva',
        validateJson: 'Provjeri ispravnost JSON-a',
        connect: 'Poveži',
        update: 'Ažuriraj',
        delete: 'Izbriši',
        selectTheQuestion: 'Odaberite pitanje čiji odgovor korisnika želite poslati kao vrijednost',
        appTooltip: {
          typeYourJsonCode: 'Upišite svoj JSON kod',
          clickToValidateJsonCode: 'Kliknite za provjeru ispravnosti JSON koda',
        }
      },
      list: {
        customAppsIntegrations: 'Prilagođene integracije aplikacija',
        integrateYourAppsWith: 'Integrirajte vlastite aplikacije s ',
        help: 'Pomoć',
        addIntegration: ' Dodaj integraciju',
        name: 'Ime',
        status: 'Status',
        action: 'Radnja',
        installed: 'Instalirano',
        edit: 'Uredi',
        connect: 'Poveži',
        requestYourIntegration: 'Zatražite svoju integraciju',
        toRequestNewIntegration: 'Zahtjev za novom integracijom. Molimo unesite dolje navedene pojedinosti i mi ćemo vam se javiti.',
        emailId: 'Email adresa',
        integrationName: 'Ime integracije',
        contactNumber: 'Broj telefona',
        howSoonYouWantToAddThisIntegration: 'Koliko brzo želite dodati ovu integraciju',
        sendRequest: 'Pošalji zahtjev',
        cancel: 'Odustani',
        delete: 'Izbriši',
        oopsOwnIntegrationsAreSupportedOnlyIn: 'Ups! Vaše vlastite integracije podržane su samo u',
        plan: 'Plan',
        pleaseUpgradeTo: 'Molimo nadogradite se na',
        toCreateOwnIntegrations: 'za stvaranje vlastitih integracija',
        appTooltip: {
          integrations: 'Integracije',
          noIntegrationsFound: 'Nema pronađenih integracija!',
          nameOfYourApp: 'Ime vaše aplikacije',
          clickToConnectApp: 'Kliknite za povezivanje aplikacije',
          statusAsConnectedOrNotConnected: 'Status kao povezan / nije povezan',
        }
      }
    }
  }
};
